// The minimum ABI to get ERC20 Token balance
export const MIN_ABI = [
  {
    constant: true,
    inputs: [{ name: "_owner", type: "address" }],
    name: "balanceOf",
    outputs: [{ name: "balance", type: "uint256" }],
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "decimals",
    outputs: [{ name: "", type: "uint8" }],
    type: "function"
  }
];

// Contract ABI
export const CONTRACT_ABI = {
  contractName: "FuturesFactory",
  abi: [
    {
      constant: true,
      inputs: [],
      name: "TEMPERATURE_THRESHOLD",
      outputs: [
        {
          name: "",
          type: "uint256"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: false,
      inputs: [],
      name: "renounceOwnership",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "owner",
      outputs: [
        {
          name: "",
          type: "address"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "isOwner",
      outputs: [
        {
          name: "",
          type: "bool"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: false,
      inputs: [
        {
          name: "newOwner",
          type: "address"
        }
      ],
      name: "transferOwnership",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          name: "_oracleAddress",
          type: "address"
        }
      ],
      payable: false,
      stateMutability: "nonpayable",
      type: "constructor"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          name: "",
          type: "uint256"
        }
      ],
      name: "idEvent",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          name: "previousOwner",
          type: "address"
        },
        {
          indexed: true,
          name: "newOwner",
          type: "address"
        }
      ],
      name: "OwnershipTransferred",
      type: "event"
    },
    {
      constant: false,
      inputs: [
        {
          name: "_position",
          type: "uint8"
        },
        {
          name: "_qty",
          type: "uint256"
        },
        {
          name: "_price",
          type: "uint256"
        },
        {
          name: "_expiry",
          type: "uint256"
        }
      ],
      name: "submitOrder",
      outputs: [],
      payable: true,
      stateMutability: "payable",
      type: "function"
    },
    {
      constant: false,
      inputs: [
        {
          name: "_long",
          type: "address"
        },
        {
          name: "_short",
          type: "address"
        },
        {
          name: "_qty",
          type: "uint256"
        },
        {
          name: "_price",
          type: "uint256"
        },
        {
          name: "_expiry",
          type: "uint256"
        }
      ],
      name: "fillOrder",
      outputs: [
        {
          name: "",
          type: "uint256"
        }
      ],
      payable: true,
      stateMutability: "payable",
      type: "function"
    },
    {
      constant: false,
      inputs: [
        {
          name: "_futureId",
          type: "uint256"
        }
      ],
      name: "squareOffOrder",
      outputs: [],
      payable: false,
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "getEscrowAddress",
      outputs: [
        {
          name: "",
          type: "address"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "getLatestFutureID",
      outputs: [
        {
          name: "",
          type: "uint256"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "getLatestOrderID",
      outputs: [
        {
          name: "",
          type: "uint256"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: true,
      inputs: [
        {
          name: "_futureId",
          type: "uint256"
        }
      ],
      name: "getFutureDetails",
      outputs: [
        {
          name: "",
          type: "address"
        },
        {
          name: "",
          type: "address"
        },
        {
          name: "",
          type: "uint256"
        },
        {
          name: "",
          type: "uint256"
        },
        {
          name: "",
          type: "uint256"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: true,
      inputs: [
        {
          name: "_orderId",
          type: "uint256"
        }
      ],
      name: "getOrderDetails",
      outputs: [
        {
          name: "",
          type: "address"
        },
        {
          name: "",
          type: "uint8"
        },
        {
          name: "",
          type: "uint256"
        },
        {
          name: "",
          type: "uint256"
        },
        {
          name: "",
          type: "uint256"
        },
        {
          name: "",
          type: "bool"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "_getAvgTemperature",
      outputs: [
        {
          name: "",
          type: "int256"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    }
  ],
  metadata:
    '{"compiler":{"version":"0.4.24+commit.e67f0147"},"language":"Solidity","output":{"abi":[{"constant":true,"inputs":[],"name":"TEMPERATURE_THRESHOLD","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"getLatestFutureID","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"getEscrowAddress","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_getAvgTemperature","outputs":[{"name":"","type":"int256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_position","type":"uint8"},{"name":"_qty","type":"uint256"},{"name":"_price","type":"uint256"},{"name":"_expiry","type":"uint256"}],"name":"submitOrder","outputs":[],"payable":true,"stateMutability":"payable","type":"function"},{"constant":true,"inputs":[{"name":"_futureId","type":"uint256"}],"name":"getFutureDetails","outputs":[{"name":"","type":"address"},{"name":"","type":"address"},{"name":"","type":"uint256"},{"name":"","type":"uint256"},{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_long","type":"address"},{"name":"_short","type":"address"},{"name":"_qty","type":"uint256"},{"name":"_price","type":"uint256"},{"name":"_expiry","type":"uint256"}],"name":"fillOrder","outputs":[{"name":"","type":"uint256"}],"payable":true,"stateMutability":"payable","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_futureId","type":"uint256"}],"name":"squareOffOrder","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"isOwner","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_orderId","type":"uint256"}],"name":"getOrderDetails","outputs":[{"name":"","type":"address"},{"name":"","type":"uint8"},{"name":"","type":"uint256"},{"name":"","type":"uint256"},{"name":"","type":"uint256"},{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"getLatestOrderID","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"inputs":[{"name":"_oracleAddress","type":"address"}],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":false,"name":"","type":"uint256"}],"name":"idEvent","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"previousOwner","type":"address"},{"indexed":true,"name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"}],"devdoc":{"methods":{"isOwner()":{"return":"true if `msg.sender` is the owner of the contract."},"owner()":{"return":"the address of the owner."},"renounceOwnership()":{"details":"Allows the current owner to relinquish control of the contract."},"transferOwnership(address)":{"details":"Allows the current owner to transfer control of the contract to a newOwner.","params":{"newOwner":"The address to transfer ownership to."}}}},"userdoc":{"methods":{"renounceOwnership()":{"notice":"Renouncing to ownership will leave the contract without an owner. It will not be possible to call the functions with the `onlyOwner` modifier anymore."}}}},"settings":{"compilationTarget":{"/home/roheat/honeycomb/helios/contracts/FuturesFactory.sol":"FuturesFactory"},"evmVersion":"byzantium","libraries":{},"optimizer":{"enabled":false,"runs":200},"remappings":[]},"sources":{"/home/roheat/honeycomb/helios/contracts/Escrow.sol":{"keccak256":"0xcbc3ffc2808a3f8721df65c888b983316c5b98d6da7cd1c4f1cd324a3c8acc7e","urls":["bzzr://913b86da2172603a246d3e38bd3ff3326ce10e5f28eb816777f759c90741a58d"]},"/home/roheat/honeycomb/helios/contracts/FuturesFactory.sol":{"keccak256":"0xd895cd99f4a0dada6e40212e506974b5e09a0d71ed5144dc2a7648b4a36ab011","urls":["bzzr://74e5421fb8acba89dfd5a7ee769c1e42252db3e64a2092d3dcdbbb8de051563a"]},"/home/roheat/honeycomb/helios/contracts/Ownable.sol":{"keccak256":"0x32ab6890bb9f829c5b20c82169cb1922394291c67524e315e919a5be1eb2dbe3","urls":["bzzr://d2c3e71f3c568cb627dd15aa4e0a8671200a11d3c606898f08a0ba79861635a6"]},"/home/roheat/honeycomb/helios/contracts/SafeMath.sol":{"keccak256":"0x93c8b18c8a6178957d987bf27514619dedd974cb57707b1195c9021bbd2e5995","urls":["bzzr://8a49d2ff1d7ae2de602aaeb8f4ea893072c6d249d6c22cc7becadbdd8812cb28"]},"/home/roheat/honeycomb/helios/contracts/interfaces/IOracle.sol":{"keccak256":"0x4226ad2beb68d5ff64a076e4d15ad22cc96f417c5eb583a2639d28ca3af3479e","urls":["bzzr://900a3687d50fc31e7e3241106ca55b97d06ea34509b10414a0b1b367365f5535"]}},"version":1}',
  bytecode:
    "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",
  deployedBytecode:
    "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",
  sourceMap:
    "247:6633:1:-;;;1122:202;8:9:-1;5:2;;;30:1;27;20:12;5:2;1122:202:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;518:10:4;509:6;;:19;;;;;;;;;;;;;;;;;;572:6;;;;;;;;;;;539:40;;568:1;539:40;;;;;;;;;;;;1195:14:1;1171:21;;:38;;;;;;;;;;;;;;;;;;1239:12;;:::i;:::-;;;;;;;;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;1239:12:1;1215:13;;:37;;;;;;;;;;;;;;;;;;1269:1;1258:8;:12;;;;1286:1;1276:7;:11;;;;1317:2;1293:21;:26;;;;1122:202;247:6633;;;;;;;;;;;;:::o;:::-;;;;;;;",
  deployedSourceMap:
    "247:6633:1:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;508:36;;8:9:-1;5:2;;;30:1;27;20:12;5:2;508:36:1;;;;;;;;;;;;;;;;;;;;;;;4850:85;;8:9:-1;5:2;;;30:1;27;20:12;5:2;4850:85:1;;;;;;;;;;;;;;;;;;;;;;;4757:89;;8:9:-1;5:2;;;30:1;27;20:12;5:2;4757:89:1;;;;;;;;;;;;;;;;;;;;;;;;;;;6174:338;;8:9:-1;5:2;;;30:1;27;20:12;5:2;6174:338:1;;;;;;;;;;;;;;;;;;;;;;;1328:395;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5026:356;;8:9:-1;5:2;;;30:1;27;20:12;5:2;5026:356:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2068:972;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1273:127:4;;8:9:-1;5:2;;;30:1;27;20:12;5:2;1273:127:4;;;;;;3283:1470:1;;8:9:-1;5:2;;;30:1;27;20:12;5:2;3283:1470:1;;;;;;;;;;;;;;;;;;;;;;;;;;639:70:4;;8:9:-1;5:2;;;30:1;27;20:12;5:2;639:70:4;;;;;;;;;;;;;;;;;;;;;;;;;;;926:83;;8:9:-1;5:2;;;30:1;27;20:12;5:2;926:83:4;;;;;;;;;;;;;;;;;;;;;;;;;;;5386:391:1;;8:9:-1;5:2;;;30:1;27;20:12;5:2;5386:391:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1561:101:4;;8:9:-1;5:2;;;30:1;27;20:12;5:2;1561:101:4;;;;;;;;;;;;;;;;;;;;;;;;;;;;4939:83:1;;8:9:-1;5:2;;;30:1;27;20:12;5:2;4939:83:1;;;;;;;;;;;;;;;;;;;;;;;508:36;;;;:::o;4850:85::-;4900:7;4922:8;;4915:15;;4850:85;:::o;4757:89::-;4806:7;4828:13;;;;;;;;;;;4821:20;;4757:89;:::o;6174:338::-;6225:6;6430:14;6280:1;6247:35;;:21;;;;;;;;;;;:35;;;;6239:78;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6383:4;6331:56;;6339:21;;;;;;;;;;;6331:46;;;:48;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;6331:48:1;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;6331:48:1;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;6331:48:1;;;;;;;;;;;;;;;;:56;;;6323:101;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6455:21;;;;;;;;;;;6447:38;;;:40;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;6447:40:1;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;6447:40:1;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;6447:40:1;;;;;;;;;;;;;;;;6430:57;;6500:7;6493:14;;6174:338;;:::o;1328:395::-;1570:21;;:::i;:::-;1485:9;1465:16;1474:6;1465:4;:8;;:16;;;;:::i;:::-;:29;1457:66;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1554:9;1529:14;:35;;;;1594:58;;;;;;;;;1600:10;1594:58;;;;;;1612:9;1594:58;;;;;;;;;;;;1623:4;1594:58;;;;1629:6;1594:58;;;;1637:7;1594:58;;;;1646:5;1594:58;;;;;1570:82;;1680:8;1658:10;:19;1669:7;;1658:19;;;;;;;;;;;:30;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1704:14;1716:1;1704:7;;:11;;:14;;;;:::i;:::-;1694:7;:24;;;;1328:395;;;;;:::o;5026:356::-;5097:7;5110;5123;5136;5149;5167:28;;:::i;:::-;5198:11;:22;5210:9;5198:22;;;;;;;;;;;5167:53;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5241:14;:19;;;5268:14;:20;;;5296:14;:18;;;5322:14;:20;;;5350:14;:21;;;5226:151;;;;;;;;;;5026:356;;;;;;;;:::o;2068:972::-;2213:7;2504:23;;:::i;:::-;2656:19;2698:22;;:::i;:::-;2254:9;2236:14;;:27;2228:67;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2309:49;2335:14;;2352:5;2309:17;:49::i;:::-;2301:94;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2409:50;2435:14;;2452:6;2409:17;:50::i;:::-;2401:96;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2530:80;;;;;;;;;2544:5;2530:80;;;;;;2557:6;2530:80;;;;;;2571:4;2530:80;;;;2583:6;2530:80;;;;2597:7;2530:80;;;2504:106;;2641:9;2617:11;:21;2629:8;;2617:21;;;;;;;;;;;:33;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2678:14;2690:1;2678:7;;:11;;:14;;;;:::i;:::-;2656:36;;2723:211;;;;;;;;;2736:10;:23;2747:11;2736:23;;;;;;;;;;;:30;;;;;;;;;;;;2723:211;;;;;;2774:10;:23;2785:11;2774:23;;;;;;;;;;;:32;;;;;;;;;;;;2723:211;;;;;;;;;;;;2814:10;:23;2825:11;2814:23;;;;;;;;;;;:27;;;2723:211;;;;2849:10;:23;2860:11;2849:23;;;;;;;;;;;:29;;;2723:211;;;;2886:10;:23;2897:11;2886:23;;;;;;;;;;;:30;;;2723:211;;;;2924:4;2723:211;;;;;2698:236;;2966:9;2940:10;:23;2951:11;2940:23;;;;;;;;;;;:35;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2986:17;2994:8;;2986:17;;;;;;;;;;;;;;;;;;3020:15;3033:1;3020:8;;:12;;:15;;;;:::i;:::-;3009:8;:26;;;;2068:972;;;;;;;;;;:::o;1273:127:4:-;824:9;:7;:9::i;:::-;816:18;;;;;;;;1367:1;1330:40;;1351:6;;;;;;;;;;;1330:40;;;;;;;;;;;;1393:1;1376:6;;:19;;;;;;;;;;;;;;;;;;1273:127::o;3283:1470:1:-;3421:28;;:::i;:::-;3481:15;3534:11;3551;3568:23;3347:26;3363:9;3347:15;:26::i;:::-;3339:76;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3452:11;:22;3464:9;3452:22;;;;;;;;;;;3421:53;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3507:20;:18;:20::i;:::-;3481:47;;3805:2;3795:7;:12;3791:958;;;3823:34;3849:7;3823:21;;:25;;:34;;;;:::i;:::-;3817:40;;3883:25;3891:16;3883:3;:7;;:25;;;;:::i;:::-;3865:43;;3997:77;4017:14;;4033;:19;;;4054:14;:19;;;3997;:77::i;:::-;;4082:79;4102:15;4119:14;:20;;;4141:14;:19;;;4082;:79::i;:::-;;4169:100;4189:35;4208:15;4189:14;;:18;;:35;;;;:::i;:::-;4226:14;:20;;;4248:14;:20;;;4169:19;:100::i;:::-;;3791:958;;;4296:34;4308:21;;4296:7;:11;;:34;;;;:::i;:::-;4290:40;;4356:25;4364:16;4356:3;:7;;:25;;;;:::i;:::-;4338:43;;4470:79;4490:14;;4506;:20;;;4528:14;:20;;;4470:19;:79::i;:::-;;4557;4577:15;4594:14;:19;;;4615:14;:20;;;4557:19;:79::i;:::-;;4644:98;4664:35;4683:15;4664:14;;:18;;:35;;;;:::i;:::-;4701:14;:19;;;4722:14;:19;;;4644;:98::i;:::-;;3791:958;3283:1470;;;;;;:::o;639:70:4:-;676:7;698:6;;;;;;;;;;;691:13;;639:70;:::o;926:83::-;965:4;998:6;;;;;;;;;;;984:20;;:10;:20;;;977:27;;926:83;:::o;5386:391:1:-;5455:7;5468:8;5482:7;5495;5508;5521:4;5536:26;;:::i;:::-;5565:10;:20;5576:8;5565:20;;;;;;;;;;;5536:49;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5606:13;:20;;;5634:13;:22;;;5664:13;:17;;;5689:13;:19;;;5716:13;:20;;;5744:13;:22;;;5591:181;;;;;;;;;;;;5386:391;;;;;;;;:::o;1561:101:4:-;824:9;:7;:9::i;:::-;816:18;;;;;;;;1629:28;1648:8;1629:18;:28::i;:::-;1561:101;:::o;4939:83:1:-;4988:7;5010;;5003:14;;4939:83;:::o;204:381:5:-;262:7;523:9;491:1;486;:6;482:35;;;509:1;502:8;;;;482:35;539:1;535;:5;523:17;;563:1;558;554;:5;;;;;;;;:10;546:19;;;;;;;;579:1;572:8;;204:381;;;;;;:::o;1272:131::-;1330:7;1345:9;1361:1;1357;:5;1345:17;;1381:1;1376;:6;;1368:15;;;;;;;;1397:1;1390:8;;1272:131;;;;;:::o;6516:173:1:-;6594:4;6613:13;;;;;;;;;;;6606:29;;;6642:7;6651:6;6659:7;6606:61;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;6606:61:1;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;6606:61:1;;;;;6680:4;6673:11;;6516:173;;;;:::o;1078:131:5:-;1136:7;1172:9;1164:1;1159;:6;;1151:15;;;;;;;;1188:1;1184;:5;1172:17;;1203:1;1196:8;;1078:131;;;;;:::o;5781:389:1:-;5848:4;5942:28;;:::i;:::-;5880:8;;5868:9;:20;:37;;;;;5904:1;5892:9;:13;5868:37;5860:76;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5973:11;:22;5985:9;5973:22;;;;;;;;;;;5942:53;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6030:14;:19;;;6016:33;;:10;:33;;;:71;;;;6067:14;:20;;;6053:34;;:10;:34;;;6016:71;6001:147;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6161:4;6154:11;;5781:389;;;;:::o;6693:185::-;6789:4;6808:13;;;;;;;;;;;6801:30;;;6832:6;6840;6848:7;6801:55;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;6801:55:1;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;6801:55:1;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;6801:55:1;;;;;;;;;;;;;;;;;6869:4;6862:11;;6693:185;;;;;:::o;1796:169:4:-;1885:1;1865:22;;:8;:22;;;;1857:31;;;;;;;;1928:8;1899:38;;1920:6;;;;;;;;;;;1899:38;;;;;;;;;;;;1952:8;1943:6;;:17;;;;;;;;;;;;;;;;;;1796:169;:::o;247:6633:1:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o",
  source:
    'pragma solidity 0.4.24;\n\nimport "./SafeMath.sol";\nimport "./Ownable.sol";\nimport "./Escrow.sol";\nimport "./interfaces/IOracle.sol";\n\n/*\n * @title FuturesFactory\n * @dev Contract that manges futures trading - long/short position and square off\n */\ncontract FuturesFactory is Ownable {\n  using SafeMath for uint256;\n  using SafeMath for int256;\n  address private escrowAddress;\n  uint256 private futureId;\n  uint256 private orderId;\n  address private deployedOracleAddress;\n  uint256 private positionAmount;\n  uint256 public TEMPERATURE_THRESHOLD;\n\n  enum Position { LONG, SHORT }\n\n  struct future {\n    address long;\n    address short;\n    uint256 qty;\n    uint256 price;\n    uint256 expiry;\n  }\n\n  struct order {\n    address trader;\n    Position position;\n    uint256 qty;\n    uint256 price;\n    uint256 expiry;\n    bool isFilled;\n  }\n\n  event idEvent(uint256);\n\n  mapping(uint256 => future) futuresList; // futureId => future\n  mapping(uint256 => order) ordersList; // orderId => order\n\n  /*\n   * @dev Initializes oracle, escrow and positionAmount\n   * @param _oracleAddress address of honeycomb chainlink oracle\n   */\n  constructor(address _oracleAddress) public {\n    deployedOracleAddress = _oracleAddress;\n    escrowAddress = address(new Escrow());\n    futureId = 1;\n    orderId = 1;\n    TEMPERATURE_THRESHOLD = 18;\n  }\n\n  function submitOrder(\n    Position _position,\n    uint256 _qty,\n    uint256 _price,\n    uint256 _expiry\n  ) public payable {\n    require(_qty.mul(_price) == msg.value, "Amount paid is incorrect");\n    positionAmount = uint256(msg.value);\n    order memory newOrder = order(msg.sender, _position, _qty, _price, _expiry, false);\n    ordersList[orderId] = newOrder;\n    orderId = orderId.add(1);\n  }\n\n  /*\n   * @dev Fills order - deposit margin amount of long and\n   * short to escrow.\n   * @param _long address of long trader\n   * @param _short address of short trader\n   * @param _qty qty of stocks (no. of lots * lot size)\n   * @param _price price of one lot (ether)\n   * @param _expiry expiry of future contract (last day of month)\n   */\n  function fillOrder(\n    address _long,\n    address _short,\n    uint256 _qty,\n    uint256 _price,\n    uint256 _expiry\n  ) public payable returns (uint256) {\n    require(positionAmount == msg.value, "Insuficient position amount");\n    require(_transferToEscrow(uint256(positionAmount), _long), "Failed at long _transferToEscrow");\n    require(_transferToEscrow(uint256(positionAmount), _short), "Failed at short _transferToEscrow");\n\n    future memory newFuture = future(\n      _long,\n      _short,\n      _qty,\n      _price,\n      _expiry\n    );\n\n    futuresList[futureId] = newFuture;\n    uint256 prevOrderId = orderId.sub(1);\n    order memory tempOrder = order(\n      ordersList[prevOrderId].trader,\n      ordersList[prevOrderId].position,\n      ordersList[prevOrderId].qty,\n      ordersList[prevOrderId].price,\n      ordersList[prevOrderId].expiry,\n      true\n    );\n    ordersList[prevOrderId] = tempOrder;\n    emit idEvent(futureId);\n    futureId = futureId.add(1);\n  }\n\n  /*\n   * @dev Square off trade - long goes short and vice versa\n   * Settlement is done according to temperature indexes -\n   * Heating Degree Days (HDD) and Cooling Degree Days (CDD)\n   * @param _futureId id of the future contract\n   */\n  function squareOffOrder(uint256 _futureId) public {\n    require(_canBeExercised(_futureId), "Future contract cannot be squared off");\n    future memory existingFuture = futuresList[_futureId];\n\n    uint256 avgTemp = uint256(_getAvgTemperature());\n    uint256 HDD;\n    uint256 CDD;\n    uint256 settlementPrice;\n    // Calculate HDD\n    // if avgTemp < 18, HDD = 18 - avgTemp, else HDD = 0\n    // if avgTemp > 18, CDD = avgTemp - 18, else CDD = 0\n    // Settlement price = HDD * 0.03 ETH or CDD * 0.03 ETH\n    if (avgTemp < 18) {\n      HDD = TEMPERATURE_THRESHOLD.sub(avgTemp);\n      settlementPrice = HDD.mul(3000000000000000);\n      // Transfer (settlementPrice + positionAmount) to long, remaining to short\n      _withdrawFromEscrow(positionAmount, existingFuture.long, existingFuture.long);\n      _withdrawFromEscrow(settlementPrice, existingFuture.short, existingFuture.long);\n      _withdrawFromEscrow(positionAmount.sub(settlementPrice), existingFuture.short, existingFuture.short);\n    } else {\n      CDD = avgTemp.sub(TEMPERATURE_THRESHOLD);\n      settlementPrice = CDD.mul(3000000000000000);\n      // Transfer (settlementPrice + positionAmount) to short, remaining to long\n      _withdrawFromEscrow(positionAmount, existingFuture.short, existingFuture.short);\n      _withdrawFromEscrow(settlementPrice, existingFuture.long, existingFuture.short);\n      _withdrawFromEscrow(positionAmount.sub(settlementPrice), existingFuture.long, existingFuture.long);\n    }\n  }\n\n  function getEscrowAddress() public view returns (address) {\n    return escrowAddress;\n  }\n\n  function getLatestFutureID() public view returns (uint256) {\n    return futureId;\n  }\n\n  function getLatestOrderID() public view returns (uint256) {\n    return orderId;\n  }\n\n  function getFutureDetails(uint256 _futureId) public view returns (\n    address,\n    address,\n    uint256,\n    uint256,\n    uint256\n  ) {\n    future memory existingFuture = futuresList[_futureId];\n    return (\n      existingFuture.long,\n      existingFuture.short,\n      existingFuture.qty,\n      existingFuture.price,\n      existingFuture.expiry\n    );\n  }\n\n  function getOrderDetails(uint256 _orderId) public view returns (\n    address,\n    Position,\n    uint256,\n    uint256,\n    uint256,\n    bool\n  ) {\n    order memory existingOrder = ordersList[_orderId];\n    return (\n      existingOrder.trader,\n      existingOrder.position,\n      existingOrder.qty,\n      existingOrder.price,\n      existingOrder.expiry,\n      existingOrder.isFilled\n    );\n  }\n\n  function _canBeExercised(uint256 _futureId) internal view returns (bool) {\n    require(_futureId < futureId && _futureId > 0, "Invalid future contract ID");\n    future memory existingFuture = futuresList[_futureId];\n    require(\n      msg.sender == existingFuture.long || msg.sender == existingFuture.short,\n      "Only long or short seller can exercise future"\n    );\n    return true;\n  }\n\n  function _getAvgTemperature() public view returns (int256) {\n    require(deployedOracleAddress != address(0), "Weather oracle address not set");\n    require(IOracle(deployedOracleAddress).avgTempReceived() == true, "Avg temperature not recieved yet");\n    int256 avgTemp = IOracle(deployedOracleAddress).avgTemp();\n    return avgTemp;\n  }\n\n  function _transferToEscrow(uint256 _amount, address _payer) internal returns (bool) {\n    Escrow(escrowAddress).deposit.value(_amount)(_payer, _amount);\n    return true;\n  }\n\n  function _withdrawFromEscrow(uint256 _amount, address _payer, address _payee) internal returns (bool) {\n    Escrow(escrowAddress).withdraw(_payer, _payee, _amount);\n    return true;\n  }\n}',
  sourcePath: "/home/roheat/honeycomb/helios/contracts/FuturesFactory.sol",
  ast: {
    absolutePath: "/home/roheat/honeycomb/helios/contracts/FuturesFactory.sol",
    exportedSymbols: {
      FuturesFactory: [690]
    },
    id: 691,
    nodeType: "SourceUnit",
    nodes: [
      {
        id: 88,
        literals: ["solidity", "0.4", ".24"],
        nodeType: "PragmaDirective",
        src: "0:23:1"
      },
      {
        absolutePath: "/home/roheat/honeycomb/helios/contracts/SafeMath.sol",
        file: "./SafeMath.sol",
        id: 89,
        nodeType: "ImportDirective",
        scope: 691,
        sourceUnit: 1099,
        src: "25:24:1",
        symbolAliases: [],
        unitAlias: ""
      },
      {
        absolutePath: "/home/roheat/honeycomb/helios/contracts/Ownable.sol",
        file: "./Ownable.sol",
        id: 90,
        nodeType: "ImportDirective",
        scope: 691,
        sourceUnit: 971,
        src: "50:23:1",
        symbolAliases: [],
        unitAlias: ""
      },
      {
        absolutePath: "/home/roheat/honeycomb/helios/contracts/Escrow.sol",
        file: "./Escrow.sol",
        id: 91,
        nodeType: "ImportDirective",
        scope: 691,
        sourceUnit: 87,
        src: "74:22:1",
        symbolAliases: [],
        unitAlias: ""
      },
      {
        absolutePath:
          "/home/roheat/honeycomb/helios/contracts/interfaces/IOracle.sol",
        file: "./interfaces/IOracle.sol",
        id: 92,
        nodeType: "ImportDirective",
        scope: 691,
        sourceUnit: 1146,
        src: "97:34:1",
        symbolAliases: [],
        unitAlias: ""
      },
      {
        baseContracts: [
          {
            arguments: null,
            baseName: {
              contractScope: null,
              id: 93,
              name: "Ownable",
              nodeType: "UserDefinedTypeName",
              referencedDeclaration: 970,
              src: "274:7:1",
              typeDescriptions: {
                typeIdentifier: "t_contract$_Ownable_$970",
                typeString: "contract Ownable"
              }
            },
            id: 94,
            nodeType: "InheritanceSpecifier",
            src: "274:7:1"
          }
        ],
        contractDependencies: [86, 970],
        contractKind: "contract",
        documentation: null,
        fullyImplemented: true,
        id: 690,
        linearizedBaseContracts: [690, 970],
        name: "FuturesFactory",
        nodeType: "ContractDefinition",
        nodes: [
          {
            id: 97,
            libraryName: {
              contractScope: null,
              id: 95,
              name: "SafeMath",
              nodeType: "UserDefinedTypeName",
              referencedDeclaration: 1098,
              src: "292:8:1",
              typeDescriptions: {
                typeIdentifier: "t_contract$_SafeMath_$1098",
                typeString: "library SafeMath"
              }
            },
            nodeType: "UsingForDirective",
            src: "286:27:1",
            typeName: {
              id: 96,
              name: "uint256",
              nodeType: "ElementaryTypeName",
              src: "305:7:1",
              typeDescriptions: {
                typeIdentifier: "t_uint256",
                typeString: "uint256"
              }
            }
          },
          {
            id: 100,
            libraryName: {
              contractScope: null,
              id: 98,
              name: "SafeMath",
              nodeType: "UserDefinedTypeName",
              referencedDeclaration: 1098,
              src: "322:8:1",
              typeDescriptions: {
                typeIdentifier: "t_contract$_SafeMath_$1098",
                typeString: "library SafeMath"
              }
            },
            nodeType: "UsingForDirective",
            src: "316:26:1",
            typeName: {
              id: 99,
              name: "int256",
              nodeType: "ElementaryTypeName",
              src: "335:6:1",
              typeDescriptions: {
                typeIdentifier: "t_int256",
                typeString: "int256"
              }
            }
          },
          {
            constant: false,
            id: 102,
            name: "escrowAddress",
            nodeType: "VariableDeclaration",
            scope: 690,
            src: "345:29:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_address",
              typeString: "address"
            },
            typeName: {
              id: 101,
              name: "address",
              nodeType: "ElementaryTypeName",
              src: "345:7:1",
              typeDescriptions: {
                typeIdentifier: "t_address",
                typeString: "address"
              }
            },
            value: null,
            visibility: "private"
          },
          {
            constant: false,
            id: 104,
            name: "futureId",
            nodeType: "VariableDeclaration",
            scope: 690,
            src: "378:24:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_uint256",
              typeString: "uint256"
            },
            typeName: {
              id: 103,
              name: "uint256",
              nodeType: "ElementaryTypeName",
              src: "378:7:1",
              typeDescriptions: {
                typeIdentifier: "t_uint256",
                typeString: "uint256"
              }
            },
            value: null,
            visibility: "private"
          },
          {
            constant: false,
            id: 106,
            name: "orderId",
            nodeType: "VariableDeclaration",
            scope: 690,
            src: "406:23:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_uint256",
              typeString: "uint256"
            },
            typeName: {
              id: 105,
              name: "uint256",
              nodeType: "ElementaryTypeName",
              src: "406:7:1",
              typeDescriptions: {
                typeIdentifier: "t_uint256",
                typeString: "uint256"
              }
            },
            value: null,
            visibility: "private"
          },
          {
            constant: false,
            id: 108,
            name: "deployedOracleAddress",
            nodeType: "VariableDeclaration",
            scope: 690,
            src: "433:37:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_address",
              typeString: "address"
            },
            typeName: {
              id: 107,
              name: "address",
              nodeType: "ElementaryTypeName",
              src: "433:7:1",
              typeDescriptions: {
                typeIdentifier: "t_address",
                typeString: "address"
              }
            },
            value: null,
            visibility: "private"
          },
          {
            constant: false,
            id: 110,
            name: "positionAmount",
            nodeType: "VariableDeclaration",
            scope: 690,
            src: "474:30:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_uint256",
              typeString: "uint256"
            },
            typeName: {
              id: 109,
              name: "uint256",
              nodeType: "ElementaryTypeName",
              src: "474:7:1",
              typeDescriptions: {
                typeIdentifier: "t_uint256",
                typeString: "uint256"
              }
            },
            value: null,
            visibility: "private"
          },
          {
            constant: false,
            id: 112,
            name: "TEMPERATURE_THRESHOLD",
            nodeType: "VariableDeclaration",
            scope: 690,
            src: "508:36:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_uint256",
              typeString: "uint256"
            },
            typeName: {
              id: 111,
              name: "uint256",
              nodeType: "ElementaryTypeName",
              src: "508:7:1",
              typeDescriptions: {
                typeIdentifier: "t_uint256",
                typeString: "uint256"
              }
            },
            value: null,
            visibility: "public"
          },
          {
            canonicalName: "FuturesFactory.Position",
            id: 115,
            members: [
              {
                id: 113,
                name: "LONG",
                nodeType: "EnumValue",
                src: "565:4:1"
              },
              {
                id: 114,
                name: "SHORT",
                nodeType: "EnumValue",
                src: "571:5:1"
              }
            ],
            name: "Position",
            nodeType: "EnumDefinition",
            src: "549:29:1"
          },
          {
            canonicalName: "FuturesFactory.future",
            id: 126,
            members: [
              {
                constant: false,
                id: 117,
                name: "long",
                nodeType: "VariableDeclaration",
                scope: 126,
                src: "602:12:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_address",
                  typeString: "address"
                },
                typeName: {
                  id: 116,
                  name: "address",
                  nodeType: "ElementaryTypeName",
                  src: "602:7:1",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  }
                },
                value: null,
                visibility: "internal"
              },
              {
                constant: false,
                id: 119,
                name: "short",
                nodeType: "VariableDeclaration",
                scope: 126,
                src: "620:13:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_address",
                  typeString: "address"
                },
                typeName: {
                  id: 118,
                  name: "address",
                  nodeType: "ElementaryTypeName",
                  src: "620:7:1",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  }
                },
                value: null,
                visibility: "internal"
              },
              {
                constant: false,
                id: 121,
                name: "qty",
                nodeType: "VariableDeclaration",
                scope: 126,
                src: "639:11:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256"
                },
                typeName: {
                  id: 120,
                  name: "uint256",
                  nodeType: "ElementaryTypeName",
                  src: "639:7:1",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  }
                },
                value: null,
                visibility: "internal"
              },
              {
                constant: false,
                id: 123,
                name: "price",
                nodeType: "VariableDeclaration",
                scope: 126,
                src: "656:13:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256"
                },
                typeName: {
                  id: 122,
                  name: "uint256",
                  nodeType: "ElementaryTypeName",
                  src: "656:7:1",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  }
                },
                value: null,
                visibility: "internal"
              },
              {
                constant: false,
                id: 125,
                name: "expiry",
                nodeType: "VariableDeclaration",
                scope: 126,
                src: "675:14:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256"
                },
                typeName: {
                  id: 124,
                  name: "uint256",
                  nodeType: "ElementaryTypeName",
                  src: "675:7:1",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  }
                },
                value: null,
                visibility: "internal"
              }
            ],
            name: "future",
            nodeType: "StructDefinition",
            scope: 690,
            src: "582:112:1",
            visibility: "public"
          },
          {
            canonicalName: "FuturesFactory.order",
            id: 139,
            members: [
              {
                constant: false,
                id: 128,
                name: "trader",
                nodeType: "VariableDeclaration",
                scope: 139,
                src: "717:14:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_address",
                  typeString: "address"
                },
                typeName: {
                  id: 127,
                  name: "address",
                  nodeType: "ElementaryTypeName",
                  src: "717:7:1",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  }
                },
                value: null,
                visibility: "internal"
              },
              {
                constant: false,
                id: 130,
                name: "position",
                nodeType: "VariableDeclaration",
                scope: 139,
                src: "737:17:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_enum$_Position_$115",
                  typeString: "enum FuturesFactory.Position"
                },
                typeName: {
                  contractScope: null,
                  id: 129,
                  name: "Position",
                  nodeType: "UserDefinedTypeName",
                  referencedDeclaration: 115,
                  src: "737:8:1",
                  typeDescriptions: {
                    typeIdentifier: "t_enum$_Position_$115",
                    typeString: "enum FuturesFactory.Position"
                  }
                },
                value: null,
                visibility: "internal"
              },
              {
                constant: false,
                id: 132,
                name: "qty",
                nodeType: "VariableDeclaration",
                scope: 139,
                src: "760:11:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256"
                },
                typeName: {
                  id: 131,
                  name: "uint256",
                  nodeType: "ElementaryTypeName",
                  src: "760:7:1",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  }
                },
                value: null,
                visibility: "internal"
              },
              {
                constant: false,
                id: 134,
                name: "price",
                nodeType: "VariableDeclaration",
                scope: 139,
                src: "777:13:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256"
                },
                typeName: {
                  id: 133,
                  name: "uint256",
                  nodeType: "ElementaryTypeName",
                  src: "777:7:1",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  }
                },
                value: null,
                visibility: "internal"
              },
              {
                constant: false,
                id: 136,
                name: "expiry",
                nodeType: "VariableDeclaration",
                scope: 139,
                src: "796:14:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256"
                },
                typeName: {
                  id: 135,
                  name: "uint256",
                  nodeType: "ElementaryTypeName",
                  src: "796:7:1",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  }
                },
                value: null,
                visibility: "internal"
              },
              {
                constant: false,
                id: 138,
                name: "isFilled",
                nodeType: "VariableDeclaration",
                scope: 139,
                src: "816:13:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_bool",
                  typeString: "bool"
                },
                typeName: {
                  id: 137,
                  name: "bool",
                  nodeType: "ElementaryTypeName",
                  src: "816:4:1",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  }
                },
                value: null,
                visibility: "internal"
              }
            ],
            name: "order",
            nodeType: "StructDefinition",
            scope: 690,
            src: "698:136:1",
            visibility: "public"
          },
          {
            anonymous: false,
            documentation: null,
            id: 143,
            name: "idEvent",
            nodeType: "EventDefinition",
            parameters: {
              id: 142,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 141,
                  indexed: false,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 143,
                  src: "852:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 140,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "852:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "851:9:1"
            },
            src: "838:23:1"
          },
          {
            constant: false,
            id: 147,
            name: "futuresList",
            nodeType: "VariableDeclaration",
            scope: 690,
            src: "865:38:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier:
                "t_mapping$_t_uint256_$_t_struct$_future_$126_storage_$",
              typeString: "mapping(uint256 => struct FuturesFactory.future)"
            },
            typeName: {
              id: 146,
              keyType: {
                id: 144,
                name: "uint256",
                nodeType: "ElementaryTypeName",
                src: "873:7:1",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256"
                }
              },
              nodeType: "Mapping",
              src: "865:26:1",
              typeDescriptions: {
                typeIdentifier:
                  "t_mapping$_t_uint256_$_t_struct$_future_$126_storage_$",
                typeString: "mapping(uint256 => struct FuturesFactory.future)"
              },
              valueType: {
                contractScope: null,
                id: 145,
                name: "future",
                nodeType: "UserDefinedTypeName",
                referencedDeclaration: 126,
                src: "884:6:1",
                typeDescriptions: {
                  typeIdentifier: "t_struct$_future_$126_storage_ptr",
                  typeString: "struct FuturesFactory.future"
                }
              }
            },
            value: null,
            visibility: "internal"
          },
          {
            constant: false,
            id: 151,
            name: "ordersList",
            nodeType: "VariableDeclaration",
            scope: 690,
            src: "929:36:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier:
                "t_mapping$_t_uint256_$_t_struct$_order_$139_storage_$",
              typeString: "mapping(uint256 => struct FuturesFactory.order)"
            },
            typeName: {
              id: 150,
              keyType: {
                id: 148,
                name: "uint256",
                nodeType: "ElementaryTypeName",
                src: "937:7:1",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256"
                }
              },
              nodeType: "Mapping",
              src: "929:25:1",
              typeDescriptions: {
                typeIdentifier:
                  "t_mapping$_t_uint256_$_t_struct$_order_$139_storage_$",
                typeString: "mapping(uint256 => struct FuturesFactory.order)"
              },
              valueType: {
                contractScope: null,
                id: 149,
                name: "order",
                nodeType: "UserDefinedTypeName",
                referencedDeclaration: 139,
                src: "948:5:1",
                typeDescriptions: {
                  typeIdentifier: "t_struct$_order_$139_storage_ptr",
                  typeString: "struct FuturesFactory.order"
                }
              }
            },
            value: null,
            visibility: "internal"
          },
          {
            body: {
              id: 180,
              nodeType: "Block",
              src: "1165:159:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    id: 158,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      argumentTypes: null,
                      id: 156,
                      name: "deployedOracleAddress",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 108,
                      src: "1171:21:1",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      argumentTypes: null,
                      id: 157,
                      name: "_oracleAddress",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 153,
                      src: "1195:14:1",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    src: "1171:38:1",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  id: 159,
                  nodeType: "ExpressionStatement",
                  src: "1171:38:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    id: 166,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      argumentTypes: null,
                      id: 160,
                      name: "escrowAddress",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 102,
                      src: "1215:13:1",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      argumentTypes: null,
                      arguments: [
                        {
                          argumentTypes: null,
                          arguments: [],
                          expression: {
                            argumentTypes: [],
                            id: 163,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: "NewExpression",
                            src: "1239:10:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_function_creation_nonpayable$__$returns$_t_contract$_Escrow_$86_$",
                              typeString:
                                "function () returns (contract Escrow)"
                            },
                            typeName: {
                              contractScope: null,
                              id: 162,
                              name: "Escrow",
                              nodeType: "UserDefinedTypeName",
                              referencedDeclaration: 86,
                              src: "1243:6:1",
                              typeDescriptions: {
                                typeIdentifier: "t_contract$_Escrow_$86",
                                typeString: "contract Escrow"
                              }
                            }
                          },
                          id: 164,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          names: [],
                          nodeType: "FunctionCall",
                          src: "1239:12:1",
                          typeDescriptions: {
                            typeIdentifier: "t_contract$_Escrow_$86",
                            typeString: "contract Escrow"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_contract$_Escrow_$86",
                            typeString: "contract Escrow"
                          }
                        ],
                        id: 161,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        nodeType: "ElementaryTypeNameExpression",
                        src: "1231:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_address_$",
                          typeString: "type(address)"
                        },
                        typeName: "address"
                      },
                      id: 165,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "typeConversion",
                      lValueRequested: false,
                      names: [],
                      nodeType: "FunctionCall",
                      src: "1231:21:1",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    src: "1215:37:1",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  id: 167,
                  nodeType: "ExpressionStatement",
                  src: "1215:37:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    id: 170,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      argumentTypes: null,
                      id: 168,
                      name: "futureId",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 104,
                      src: "1258:8:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      argumentTypes: null,
                      hexValue: "31",
                      id: 169,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "1269:1:1",
                      subdenomination: null,
                      typeDescriptions: {
                        typeIdentifier: "t_rational_1_by_1",
                        typeString: "int_const 1"
                      },
                      value: "1"
                    },
                    src: "1258:12:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 171,
                  nodeType: "ExpressionStatement",
                  src: "1258:12:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    id: 174,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      argumentTypes: null,
                      id: 172,
                      name: "orderId",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 106,
                      src: "1276:7:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      argumentTypes: null,
                      hexValue: "31",
                      id: 173,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "1286:1:1",
                      subdenomination: null,
                      typeDescriptions: {
                        typeIdentifier: "t_rational_1_by_1",
                        typeString: "int_const 1"
                      },
                      value: "1"
                    },
                    src: "1276:11:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 175,
                  nodeType: "ExpressionStatement",
                  src: "1276:11:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    id: 178,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      argumentTypes: null,
                      id: 176,
                      name: "TEMPERATURE_THRESHOLD",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 112,
                      src: "1293:21:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      argumentTypes: null,
                      hexValue: "3138",
                      id: 177,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "1317:2:1",
                      subdenomination: null,
                      typeDescriptions: {
                        typeIdentifier: "t_rational_18_by_1",
                        typeString: "int_const 18"
                      },
                      value: "18"
                    },
                    src: "1293:26:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 179,
                  nodeType: "ExpressionStatement",
                  src: "1293:26:1"
                }
              ]
            },
            documentation: null,
            id: 181,
            implemented: true,
            isConstructor: true,
            isDeclaredConst: false,
            modifiers: [],
            name: "",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 154,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 153,
                  name: "_oracleAddress",
                  nodeType: "VariableDeclaration",
                  scope: 181,
                  src: "1134:22:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 152,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "1134:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "1133:24:1"
            },
            payable: false,
            returnParameters: {
              id: 155,
              nodeType: "ParameterList",
              parameters: [],
              src: "1165:0:1"
            },
            scope: 690,
            src: "1122:202:1",
            stateMutability: "nonpayable",
            superFunction: null,
            visibility: "public"
          },
          {
            body: {
              id: 235,
              nodeType: "Block",
              src: "1451:272:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        id: 199,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          argumentTypes: null,
                          arguments: [
                            {
                              argumentTypes: null,
                              id: 195,
                              name: "_price",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 187,
                              src: "1474:6:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            ],
                            expression: {
                              argumentTypes: null,
                              id: 193,
                              name: "_qty",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 185,
                              src: "1465:4:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            id: 194,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberName: "mul",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 1005,
                            src: "1465:8:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
                              typeString:
                                "function (uint256,uint256) pure returns (uint256)"
                            }
                          },
                          id: 196,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          names: [],
                          nodeType: "FunctionCall",
                          src: "1465:16:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: "==",
                        rightExpression: {
                          argumentTypes: null,
                          expression: {
                            argumentTypes: null,
                            id: 197,
                            name: "msg",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 2940,
                            src: "1485:3:1",
                            typeDescriptions: {
                              typeIdentifier: "t_magic_message",
                              typeString: "msg"
                            }
                          },
                          id: 198,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberName: "value",
                          nodeType: "MemberAccess",
                          referencedDeclaration: null,
                          src: "1485:9:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        src: "1465:29:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      {
                        argumentTypes: null,
                        hexValue:
                          "416d6f756e74207061696420697320696e636f7272656374",
                        id: 200,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "1496:26:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_e5197f906cb686880b18e3b4f67ef11b1a40b0004d98423bf5be9df5c145fdce",
                          typeString:
                            'literal_string "Amount paid is incorrect"'
                        },
                        value: "Amount paid is incorrect"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_e5197f906cb686880b18e3b4f67ef11b1a40b0004d98423bf5be9df5c145fdce",
                          typeString:
                            'literal_string "Amount paid is incorrect"'
                        }
                      ],
                      id: 192,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [2943, 2944],
                      referencedDeclaration: 2944,
                      src: "1457:7:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure"
                      }
                    },
                    id: 201,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1457:66:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 202,
                  nodeType: "ExpressionStatement",
                  src: "1457:66:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    id: 208,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      argumentTypes: null,
                      id: 203,
                      name: "positionAmount",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 110,
                      src: "1529:14:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      argumentTypes: null,
                      arguments: [
                        {
                          argumentTypes: null,
                          expression: {
                            argumentTypes: null,
                            id: 205,
                            name: "msg",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 2940,
                            src: "1554:3:1",
                            typeDescriptions: {
                              typeIdentifier: "t_magic_message",
                              typeString: "msg"
                            }
                          },
                          id: 206,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberName: "value",
                          nodeType: "MemberAccess",
                          referencedDeclaration: null,
                          src: "1554:9:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        ],
                        id: 204,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        nodeType: "ElementaryTypeNameExpression",
                        src: "1546:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_uint256_$",
                          typeString: "type(uint256)"
                        },
                        typeName: "uint256"
                      },
                      id: 207,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "typeConversion",
                      lValueRequested: false,
                      names: [],
                      nodeType: "FunctionCall",
                      src: "1546:18:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "1529:35:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 209,
                  nodeType: "ExpressionStatement",
                  src: "1529:35:1"
                },
                {
                  assignments: [211],
                  declarations: [
                    {
                      constant: false,
                      id: 211,
                      name: "newOrder",
                      nodeType: "VariableDeclaration",
                      scope: 236,
                      src: "1570:21:1",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_order_$139_memory_ptr",
                        typeString: "struct FuturesFactory.order"
                      },
                      typeName: {
                        contractScope: null,
                        id: 210,
                        name: "order",
                        nodeType: "UserDefinedTypeName",
                        referencedDeclaration: 139,
                        src: "1570:5:1",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_order_$139_storage_ptr",
                          typeString: "struct FuturesFactory.order"
                        }
                      },
                      value: null,
                      visibility: "internal"
                    }
                  ],
                  id: 221,
                  initialValue: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 213,
                          name: "msg",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 2940,
                          src: "1600:3:1",
                          typeDescriptions: {
                            typeIdentifier: "t_magic_message",
                            typeString: "msg"
                          }
                        },
                        id: 214,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "sender",
                        nodeType: "MemberAccess",
                        referencedDeclaration: null,
                        src: "1600:10:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        argumentTypes: null,
                        id: 215,
                        name: "_position",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 183,
                        src: "1612:9:1",
                        typeDescriptions: {
                          typeIdentifier: "t_enum$_Position_$115",
                          typeString: "enum FuturesFactory.Position"
                        }
                      },
                      {
                        argumentTypes: null,
                        id: 216,
                        name: "_qty",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 185,
                        src: "1623:4:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        argumentTypes: null,
                        id: 217,
                        name: "_price",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 187,
                        src: "1629:6:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        argumentTypes: null,
                        id: 218,
                        name: "_expiry",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 189,
                        src: "1637:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        argumentTypes: null,
                        hexValue: "66616c7365",
                        id: 219,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "bool",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "1646:5:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        value: "false"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_enum$_Position_$115",
                          typeString: "enum FuturesFactory.Position"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      ],
                      id: 212,
                      name: "order",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 139,
                      src: "1594:5:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_type$_t_struct$_order_$139_storage_ptr_$",
                        typeString:
                          "type(struct FuturesFactory.order storage pointer)"
                      }
                    },
                    id: 220,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "structConstructorCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1594:58:1",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_order_$139_memory",
                      typeString: "struct FuturesFactory.order memory"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "1570:82:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    id: 226,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      argumentTypes: null,
                      baseExpression: {
                        argumentTypes: null,
                        id: 222,
                        name: "ordersList",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 151,
                        src: "1658:10:1",
                        typeDescriptions: {
                          typeIdentifier:
                            "t_mapping$_t_uint256_$_t_struct$_order_$139_storage_$",
                          typeString:
                            "mapping(uint256 => struct FuturesFactory.order storage ref)"
                        }
                      },
                      id: 224,
                      indexExpression: {
                        argumentTypes: null,
                        id: 223,
                        name: "orderId",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 106,
                        src: "1669:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "1658:19:1",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_order_$139_storage",
                        typeString: "struct FuturesFactory.order storage ref"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      argumentTypes: null,
                      id: 225,
                      name: "newOrder",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 211,
                      src: "1680:8:1",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_order_$139_memory_ptr",
                        typeString: "struct FuturesFactory.order memory"
                      }
                    },
                    src: "1658:30:1",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_order_$139_storage",
                      typeString: "struct FuturesFactory.order storage ref"
                    }
                  },
                  id: 227,
                  nodeType: "ExpressionStatement",
                  src: "1658:30:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    id: 233,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      argumentTypes: null,
                      id: 228,
                      name: "orderId",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 106,
                      src: "1694:7:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      argumentTypes: null,
                      arguments: [
                        {
                          argumentTypes: null,
                          hexValue: "31",
                          id: 231,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "number",
                          lValueRequested: false,
                          nodeType: "Literal",
                          src: "1716:1:1",
                          subdenomination: null,
                          typeDescriptions: {
                            typeIdentifier: "t_rational_1_by_1",
                            typeString: "int_const 1"
                          },
                          value: "1"
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_rational_1_by_1",
                            typeString: "int_const 1"
                          }
                        ],
                        expression: {
                          argumentTypes: null,
                          id: 229,
                          name: "orderId",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 106,
                          src: "1704:7:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        id: 230,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "add",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 1077,
                        src: "1704:11:1",
                        typeDescriptions: {
                          typeIdentifier:
                            "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
                          typeString:
                            "function (uint256,uint256) pure returns (uint256)"
                        }
                      },
                      id: 232,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      names: [],
                      nodeType: "FunctionCall",
                      src: "1704:14:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "1694:24:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 234,
                  nodeType: "ExpressionStatement",
                  src: "1694:24:1"
                }
              ]
            },
            documentation: null,
            id: 236,
            implemented: true,
            isConstructor: false,
            isDeclaredConst: false,
            modifiers: [],
            name: "submitOrder",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 190,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 183,
                  name: "_position",
                  nodeType: "VariableDeclaration",
                  scope: 236,
                  src: "1354:18:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_enum$_Position_$115",
                    typeString: "enum FuturesFactory.Position"
                  },
                  typeName: {
                    contractScope: null,
                    id: 182,
                    name: "Position",
                    nodeType: "UserDefinedTypeName",
                    referencedDeclaration: 115,
                    src: "1354:8:1",
                    typeDescriptions: {
                      typeIdentifier: "t_enum$_Position_$115",
                      typeString: "enum FuturesFactory.Position"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 185,
                  name: "_qty",
                  nodeType: "VariableDeclaration",
                  scope: 236,
                  src: "1378:12:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 184,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "1378:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 187,
                  name: "_price",
                  nodeType: "VariableDeclaration",
                  scope: 236,
                  src: "1396:14:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 186,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "1396:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 189,
                  name: "_expiry",
                  nodeType: "VariableDeclaration",
                  scope: 236,
                  src: "1416:15:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 188,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "1416:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "1348:87:1"
            },
            payable: true,
            returnParameters: {
              id: 191,
              nodeType: "ParameterList",
              parameters: [],
              src: "1451:0:1"
            },
            scope: 690,
            src: "1328:395:1",
            stateMutability: "payable",
            superFunction: null,
            visibility: "public"
          },
          {
            body: {
              id: 345,
              nodeType: "Block",
              src: "2222:818:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        id: 255,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          argumentTypes: null,
                          id: 252,
                          name: "positionAmount",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 110,
                          src: "2236:14:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: "==",
                        rightExpression: {
                          argumentTypes: null,
                          expression: {
                            argumentTypes: null,
                            id: 253,
                            name: "msg",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 2940,
                            src: "2254:3:1",
                            typeDescriptions: {
                              typeIdentifier: "t_magic_message",
                              typeString: "msg"
                            }
                          },
                          id: 254,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberName: "value",
                          nodeType: "MemberAccess",
                          referencedDeclaration: null,
                          src: "2254:9:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        src: "2236:27:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      {
                        argumentTypes: null,
                        hexValue:
                          "496e737566696369656e7420706f736974696f6e20616d6f756e74",
                        id: 256,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "2265:29:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_b1830e3a311ee118b47b8bf2c5651f8cdc8ade03d6a6b90f13e529267878a6ce",
                          typeString:
                            'literal_string "Insuficient position amount"'
                        },
                        value: "Insuficient position amount"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_b1830e3a311ee118b47b8bf2c5651f8cdc8ade03d6a6b90f13e529267878a6ce",
                          typeString:
                            'literal_string "Insuficient position amount"'
                        }
                      ],
                      id: 251,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [2943, 2944],
                      referencedDeclaration: 2944,
                      src: "2228:7:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure"
                      }
                    },
                    id: 257,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "2228:67:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 258,
                  nodeType: "ExpressionStatement",
                  src: "2228:67:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        arguments: [
                          {
                            argumentTypes: null,
                            arguments: [
                              {
                                argumentTypes: null,
                                id: 262,
                                name: "positionAmount",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 110,
                                src: "2335:14:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              ],
                              id: 261,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              lValueRequested: false,
                              nodeType: "ElementaryTypeNameExpression",
                              src: "2327:7:1",
                              typeDescriptions: {
                                typeIdentifier: "t_type$_t_uint256_$",
                                typeString: "type(uint256)"
                              },
                              typeName: "uint256"
                            },
                            id: 263,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "typeConversion",
                            lValueRequested: false,
                            names: [],
                            nodeType: "FunctionCall",
                            src: "2327:23:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          {
                            argumentTypes: null,
                            id: 264,
                            name: "_long",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 238,
                            src: "2352:5:1",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            },
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          ],
                          id: 260,
                          name: "_transferToEscrow",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 666,
                          src: "2309:17:1",
                          typeDescriptions: {
                            typeIdentifier:
                              "t_function_internal_nonpayable$_t_uint256_$_t_address_$returns$_t_bool_$",
                            typeString:
                              "function (uint256,address) returns (bool)"
                          }
                        },
                        id: 265,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        names: [],
                        nodeType: "FunctionCall",
                        src: "2309:49:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      {
                        argumentTypes: null,
                        hexValue:
                          "4661696c6564206174206c6f6e67205f7472616e73666572546f457363726f77",
                        id: 266,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "2360:34:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_219df58f81064029780e8ba857a924cb36a5a197c8f3410698ec3dc7e18b0350",
                          typeString:
                            'literal_string "Failed at long _transferToEscrow"'
                        },
                        value: "Failed at long _transferToEscrow"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_219df58f81064029780e8ba857a924cb36a5a197c8f3410698ec3dc7e18b0350",
                          typeString:
                            'literal_string "Failed at long _transferToEscrow"'
                        }
                      ],
                      id: 259,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [2943, 2944],
                      referencedDeclaration: 2944,
                      src: "2301:7:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure"
                      }
                    },
                    id: 267,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "2301:94:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 268,
                  nodeType: "ExpressionStatement",
                  src: "2301:94:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        arguments: [
                          {
                            argumentTypes: null,
                            arguments: [
                              {
                                argumentTypes: null,
                                id: 272,
                                name: "positionAmount",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 110,
                                src: "2435:14:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              ],
                              id: 271,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              lValueRequested: false,
                              nodeType: "ElementaryTypeNameExpression",
                              src: "2427:7:1",
                              typeDescriptions: {
                                typeIdentifier: "t_type$_t_uint256_$",
                                typeString: "type(uint256)"
                              },
                              typeName: "uint256"
                            },
                            id: 273,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "typeConversion",
                            lValueRequested: false,
                            names: [],
                            nodeType: "FunctionCall",
                            src: "2427:23:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          {
                            argumentTypes: null,
                            id: 274,
                            name: "_short",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 240,
                            src: "2452:6:1",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            },
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          ],
                          id: 270,
                          name: "_transferToEscrow",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 666,
                          src: "2409:17:1",
                          typeDescriptions: {
                            typeIdentifier:
                              "t_function_internal_nonpayable$_t_uint256_$_t_address_$returns$_t_bool_$",
                            typeString:
                              "function (uint256,address) returns (bool)"
                          }
                        },
                        id: 275,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        names: [],
                        nodeType: "FunctionCall",
                        src: "2409:50:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      {
                        argumentTypes: null,
                        hexValue:
                          "4661696c65642061742073686f7274205f7472616e73666572546f457363726f77",
                        id: 276,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "2461:35:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_c1dd06e1bec49b538449019ae7ed984bdbde3bba9e30de9227b7736bb6549ab3",
                          typeString:
                            'literal_string "Failed at short _transferToEscrow"'
                        },
                        value: "Failed at short _transferToEscrow"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_c1dd06e1bec49b538449019ae7ed984bdbde3bba9e30de9227b7736bb6549ab3",
                          typeString:
                            'literal_string "Failed at short _transferToEscrow"'
                        }
                      ],
                      id: 269,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [2943, 2944],
                      referencedDeclaration: 2944,
                      src: "2401:7:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure"
                      }
                    },
                    id: 277,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "2401:96:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 278,
                  nodeType: "ExpressionStatement",
                  src: "2401:96:1"
                },
                {
                  assignments: [280],
                  declarations: [
                    {
                      constant: false,
                      id: 280,
                      name: "newFuture",
                      nodeType: "VariableDeclaration",
                      scope: 346,
                      src: "2504:23:1",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_future_$126_memory_ptr",
                        typeString: "struct FuturesFactory.future"
                      },
                      typeName: {
                        contractScope: null,
                        id: 279,
                        name: "future",
                        nodeType: "UserDefinedTypeName",
                        referencedDeclaration: 126,
                        src: "2504:6:1",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_future_$126_storage_ptr",
                          typeString: "struct FuturesFactory.future"
                        }
                      },
                      value: null,
                      visibility: "internal"
                    }
                  ],
                  id: 288,
                  initialValue: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        id: 282,
                        name: "_long",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 238,
                        src: "2544:5:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        argumentTypes: null,
                        id: 283,
                        name: "_short",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 240,
                        src: "2557:6:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        argumentTypes: null,
                        id: 284,
                        name: "_qty",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 242,
                        src: "2571:4:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        argumentTypes: null,
                        id: 285,
                        name: "_price",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 244,
                        src: "2583:6:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        argumentTypes: null,
                        id: 286,
                        name: "_expiry",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 246,
                        src: "2597:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      id: 281,
                      name: "future",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 126,
                      src: "2530:6:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_type$_t_struct$_future_$126_storage_ptr_$",
                        typeString:
                          "type(struct FuturesFactory.future storage pointer)"
                      }
                    },
                    id: 287,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "structConstructorCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "2530:80:1",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_future_$126_memory",
                      typeString: "struct FuturesFactory.future memory"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "2504:106:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    id: 293,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      argumentTypes: null,
                      baseExpression: {
                        argumentTypes: null,
                        id: 289,
                        name: "futuresList",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 147,
                        src: "2617:11:1",
                        typeDescriptions: {
                          typeIdentifier:
                            "t_mapping$_t_uint256_$_t_struct$_future_$126_storage_$",
                          typeString:
                            "mapping(uint256 => struct FuturesFactory.future storage ref)"
                        }
                      },
                      id: 291,
                      indexExpression: {
                        argumentTypes: null,
                        id: 290,
                        name: "futureId",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 104,
                        src: "2629:8:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "2617:21:1",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_future_$126_storage",
                        typeString: "struct FuturesFactory.future storage ref"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      argumentTypes: null,
                      id: 292,
                      name: "newFuture",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 280,
                      src: "2641:9:1",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_future_$126_memory_ptr",
                        typeString: "struct FuturesFactory.future memory"
                      }
                    },
                    src: "2617:33:1",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_future_$126_storage",
                      typeString: "struct FuturesFactory.future storage ref"
                    }
                  },
                  id: 294,
                  nodeType: "ExpressionStatement",
                  src: "2617:33:1"
                },
                {
                  assignments: [296],
                  declarations: [
                    {
                      constant: false,
                      id: 296,
                      name: "prevOrderId",
                      nodeType: "VariableDeclaration",
                      scope: 346,
                      src: "2656:19:1",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 295,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "2656:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      value: null,
                      visibility: "internal"
                    }
                  ],
                  id: 301,
                  initialValue: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        hexValue: "31",
                        id: 299,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "number",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "2690:1:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier: "t_rational_1_by_1",
                          typeString: "int_const 1"
                        },
                        value: "1"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_rational_1_by_1",
                          typeString: "int_const 1"
                        }
                      ],
                      expression: {
                        argumentTypes: null,
                        id: 297,
                        name: "orderId",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 106,
                        src: "2678:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      id: 298,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberName: "sub",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 1053,
                      src: "2678:11:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
                        typeString:
                          "function (uint256,uint256) pure returns (uint256)"
                      }
                    },
                    id: 300,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "2678:14:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "2656:36:1"
                },
                {
                  assignments: [303],
                  declarations: [
                    {
                      constant: false,
                      id: 303,
                      name: "tempOrder",
                      nodeType: "VariableDeclaration",
                      scope: 346,
                      src: "2698:22:1",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_order_$139_memory_ptr",
                        typeString: "struct FuturesFactory.order"
                      },
                      typeName: {
                        contractScope: null,
                        id: 302,
                        name: "order",
                        nodeType: "UserDefinedTypeName",
                        referencedDeclaration: 139,
                        src: "2698:5:1",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_order_$139_storage_ptr",
                          typeString: "struct FuturesFactory.order"
                        }
                      },
                      value: null,
                      visibility: "internal"
                    }
                  ],
                  id: 327,
                  initialValue: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          baseExpression: {
                            argumentTypes: null,
                            id: 305,
                            name: "ordersList",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 151,
                            src: "2736:10:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_mapping$_t_uint256_$_t_struct$_order_$139_storage_$",
                              typeString:
                                "mapping(uint256 => struct FuturesFactory.order storage ref)"
                            }
                          },
                          id: 307,
                          indexExpression: {
                            argumentTypes: null,
                            id: 306,
                            name: "prevOrderId",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 296,
                            src: "2747:11:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "2736:23:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_order_$139_storage",
                            typeString:
                              "struct FuturesFactory.order storage ref"
                          }
                        },
                        id: 308,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "trader",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 128,
                        src: "2736:30:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          baseExpression: {
                            argumentTypes: null,
                            id: 309,
                            name: "ordersList",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 151,
                            src: "2774:10:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_mapping$_t_uint256_$_t_struct$_order_$139_storage_$",
                              typeString:
                                "mapping(uint256 => struct FuturesFactory.order storage ref)"
                            }
                          },
                          id: 311,
                          indexExpression: {
                            argumentTypes: null,
                            id: 310,
                            name: "prevOrderId",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 296,
                            src: "2785:11:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "2774:23:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_order_$139_storage",
                            typeString:
                              "struct FuturesFactory.order storage ref"
                          }
                        },
                        id: 312,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "position",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 130,
                        src: "2774:32:1",
                        typeDescriptions: {
                          typeIdentifier: "t_enum$_Position_$115",
                          typeString: "enum FuturesFactory.Position"
                        }
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          baseExpression: {
                            argumentTypes: null,
                            id: 313,
                            name: "ordersList",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 151,
                            src: "2814:10:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_mapping$_t_uint256_$_t_struct$_order_$139_storage_$",
                              typeString:
                                "mapping(uint256 => struct FuturesFactory.order storage ref)"
                            }
                          },
                          id: 315,
                          indexExpression: {
                            argumentTypes: null,
                            id: 314,
                            name: "prevOrderId",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 296,
                            src: "2825:11:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "2814:23:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_order_$139_storage",
                            typeString:
                              "struct FuturesFactory.order storage ref"
                          }
                        },
                        id: 316,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "qty",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 132,
                        src: "2814:27:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          baseExpression: {
                            argumentTypes: null,
                            id: 317,
                            name: "ordersList",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 151,
                            src: "2849:10:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_mapping$_t_uint256_$_t_struct$_order_$139_storage_$",
                              typeString:
                                "mapping(uint256 => struct FuturesFactory.order storage ref)"
                            }
                          },
                          id: 319,
                          indexExpression: {
                            argumentTypes: null,
                            id: 318,
                            name: "prevOrderId",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 296,
                            src: "2860:11:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "2849:23:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_order_$139_storage",
                            typeString:
                              "struct FuturesFactory.order storage ref"
                          }
                        },
                        id: 320,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "price",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 134,
                        src: "2849:29:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          baseExpression: {
                            argumentTypes: null,
                            id: 321,
                            name: "ordersList",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 151,
                            src: "2886:10:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_mapping$_t_uint256_$_t_struct$_order_$139_storage_$",
                              typeString:
                                "mapping(uint256 => struct FuturesFactory.order storage ref)"
                            }
                          },
                          id: 323,
                          indexExpression: {
                            argumentTypes: null,
                            id: 322,
                            name: "prevOrderId",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 296,
                            src: "2897:11:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "2886:23:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_order_$139_storage",
                            typeString:
                              "struct FuturesFactory.order storage ref"
                          }
                        },
                        id: 324,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "expiry",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 136,
                        src: "2886:30:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        argumentTypes: null,
                        hexValue: "74727565",
                        id: 325,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "bool",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "2924:4:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        value: "true"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_enum$_Position_$115",
                          typeString: "enum FuturesFactory.Position"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      ],
                      id: 304,
                      name: "order",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 139,
                      src: "2723:5:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_type$_t_struct$_order_$139_storage_ptr_$",
                        typeString:
                          "type(struct FuturesFactory.order storage pointer)"
                      }
                    },
                    id: 326,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "structConstructorCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "2723:211:1",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_order_$139_memory",
                      typeString: "struct FuturesFactory.order memory"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "2698:236:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    id: 332,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      argumentTypes: null,
                      baseExpression: {
                        argumentTypes: null,
                        id: 328,
                        name: "ordersList",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 151,
                        src: "2940:10:1",
                        typeDescriptions: {
                          typeIdentifier:
                            "t_mapping$_t_uint256_$_t_struct$_order_$139_storage_$",
                          typeString:
                            "mapping(uint256 => struct FuturesFactory.order storage ref)"
                        }
                      },
                      id: 330,
                      indexExpression: {
                        argumentTypes: null,
                        id: 329,
                        name: "prevOrderId",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 296,
                        src: "2951:11:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "2940:23:1",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_order_$139_storage",
                        typeString: "struct FuturesFactory.order storage ref"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      argumentTypes: null,
                      id: 331,
                      name: "tempOrder",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 303,
                      src: "2966:9:1",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_order_$139_memory_ptr",
                        typeString: "struct FuturesFactory.order memory"
                      }
                    },
                    src: "2940:35:1",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_order_$139_storage",
                      typeString: "struct FuturesFactory.order storage ref"
                    }
                  },
                  id: 333,
                  nodeType: "ExpressionStatement",
                  src: "2940:35:1"
                },
                {
                  eventCall: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        id: 335,
                        name: "futureId",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 104,
                        src: "2994:8:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      id: 334,
                      name: "idEvent",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 143,
                      src: "2986:7:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_event_nonpayable$_t_uint256_$returns$__$",
                        typeString: "function (uint256)"
                      }
                    },
                    id: 336,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "2986:17:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 337,
                  nodeType: "EmitStatement",
                  src: "2981:22:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    id: 343,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      argumentTypes: null,
                      id: 338,
                      name: "futureId",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 104,
                      src: "3009:8:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      argumentTypes: null,
                      arguments: [
                        {
                          argumentTypes: null,
                          hexValue: "31",
                          id: 341,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "number",
                          lValueRequested: false,
                          nodeType: "Literal",
                          src: "3033:1:1",
                          subdenomination: null,
                          typeDescriptions: {
                            typeIdentifier: "t_rational_1_by_1",
                            typeString: "int_const 1"
                          },
                          value: "1"
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_rational_1_by_1",
                            typeString: "int_const 1"
                          }
                        ],
                        expression: {
                          argumentTypes: null,
                          id: 339,
                          name: "futureId",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 104,
                          src: "3020:8:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        id: 340,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "add",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 1077,
                        src: "3020:12:1",
                        typeDescriptions: {
                          typeIdentifier:
                            "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
                          typeString:
                            "function (uint256,uint256) pure returns (uint256)"
                        }
                      },
                      id: 342,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      names: [],
                      nodeType: "FunctionCall",
                      src: "3020:15:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "3009:26:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 344,
                  nodeType: "ExpressionStatement",
                  src: "3009:26:1"
                }
              ]
            },
            documentation: null,
            id: 346,
            implemented: true,
            isConstructor: false,
            isDeclaredConst: false,
            modifiers: [],
            name: "fillOrder",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 247,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 238,
                  name: "_long",
                  nodeType: "VariableDeclaration",
                  scope: 346,
                  src: "2092:13:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 237,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "2092:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 240,
                  name: "_short",
                  nodeType: "VariableDeclaration",
                  scope: 346,
                  src: "2111:14:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 239,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "2111:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 242,
                  name: "_qty",
                  nodeType: "VariableDeclaration",
                  scope: 346,
                  src: "2131:12:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 241,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "2131:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 244,
                  name: "_price",
                  nodeType: "VariableDeclaration",
                  scope: 346,
                  src: "2149:14:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 243,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "2149:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 246,
                  name: "_expiry",
                  nodeType: "VariableDeclaration",
                  scope: 346,
                  src: "2169:15:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 245,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "2169:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "2086:102:1"
            },
            payable: true,
            returnParameters: {
              id: 250,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 249,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 346,
                  src: "2213:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 248,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "2213:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "2212:9:1"
            },
            scope: 690,
            src: "2068:972:1",
            stateMutability: "payable",
            superFunction: null,
            visibility: "public"
          },
          {
            body: {
              id: 468,
              nodeType: "Block",
              src: "3333:1420:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        arguments: [
                          {
                            argumentTypes: null,
                            id: 353,
                            name: "_futureId",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 348,
                            src: "3363:9:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          ],
                          id: 352,
                          name: "_canBeExercised",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 607,
                          src: "3347:15:1",
                          typeDescriptions: {
                            typeIdentifier:
                              "t_function_internal_view$_t_uint256_$returns$_t_bool_$",
                            typeString: "function (uint256) view returns (bool)"
                          }
                        },
                        id: 354,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        names: [],
                        nodeType: "FunctionCall",
                        src: "3347:26:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      {
                        argumentTypes: null,
                        hexValue:
                          "46757475726520636f6e74726163742063616e6e6f742062652073717561726564206f6666",
                        id: 355,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "3375:39:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_06285b237b98788468fb57eba31cc3eb154769821626d67b1eda114d4fe15826",
                          typeString:
                            'literal_string "Future contract cannot be squared off"'
                        },
                        value: "Future contract cannot be squared off"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_06285b237b98788468fb57eba31cc3eb154769821626d67b1eda114d4fe15826",
                          typeString:
                            'literal_string "Future contract cannot be squared off"'
                        }
                      ],
                      id: 351,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [2943, 2944],
                      referencedDeclaration: 2944,
                      src: "3339:7:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure"
                      }
                    },
                    id: 356,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "3339:76:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 357,
                  nodeType: "ExpressionStatement",
                  src: "3339:76:1"
                },
                {
                  assignments: [359],
                  declarations: [
                    {
                      constant: false,
                      id: 359,
                      name: "existingFuture",
                      nodeType: "VariableDeclaration",
                      scope: 469,
                      src: "3421:28:1",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_future_$126_memory_ptr",
                        typeString: "struct FuturesFactory.future"
                      },
                      typeName: {
                        contractScope: null,
                        id: 358,
                        name: "future",
                        nodeType: "UserDefinedTypeName",
                        referencedDeclaration: 126,
                        src: "3421:6:1",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_future_$126_storage_ptr",
                          typeString: "struct FuturesFactory.future"
                        }
                      },
                      value: null,
                      visibility: "internal"
                    }
                  ],
                  id: 363,
                  initialValue: {
                    argumentTypes: null,
                    baseExpression: {
                      argumentTypes: null,
                      id: 360,
                      name: "futuresList",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 147,
                      src: "3452:11:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_mapping$_t_uint256_$_t_struct$_future_$126_storage_$",
                        typeString:
                          "mapping(uint256 => struct FuturesFactory.future storage ref)"
                      }
                    },
                    id: 362,
                    indexExpression: {
                      argumentTypes: null,
                      id: 361,
                      name: "_futureId",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 348,
                      src: "3464:9:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "3452:22:1",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_future_$126_storage",
                      typeString: "struct FuturesFactory.future storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "3421:53:1"
                },
                {
                  assignments: [365],
                  declarations: [
                    {
                      constant: false,
                      id: 365,
                      name: "avgTemp",
                      nodeType: "VariableDeclaration",
                      scope: 469,
                      src: "3481:15:1",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 364,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "3481:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      value: null,
                      visibility: "internal"
                    }
                  ],
                  id: 370,
                  initialValue: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        arguments: [],
                        expression: {
                          argumentTypes: [],
                          id: 367,
                          name: "_getAvgTemperature",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 643,
                          src: "3507:18:1",
                          typeDescriptions: {
                            typeIdentifier:
                              "t_function_internal_view$__$returns$_t_int256_$",
                            typeString: "function () view returns (int256)"
                          }
                        },
                        id: 368,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        names: [],
                        nodeType: "FunctionCall",
                        src: "3507:20:1",
                        typeDescriptions: {
                          typeIdentifier: "t_int256",
                          typeString: "int256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_int256",
                          typeString: "int256"
                        }
                      ],
                      id: 366,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      nodeType: "ElementaryTypeNameExpression",
                      src: "3499:7:1",
                      typeDescriptions: {
                        typeIdentifier: "t_type$_t_uint256_$",
                        typeString: "type(uint256)"
                      },
                      typeName: "uint256"
                    },
                    id: 369,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "typeConversion",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "3499:29:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "3481:47:1"
                },
                {
                  assignments: [],
                  declarations: [
                    {
                      constant: false,
                      id: 372,
                      name: "HDD",
                      nodeType: "VariableDeclaration",
                      scope: 469,
                      src: "3534:11:1",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 371,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "3534:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      value: null,
                      visibility: "internal"
                    }
                  ],
                  id: 373,
                  initialValue: null,
                  nodeType: "VariableDeclarationStatement",
                  src: "3534:11:1"
                },
                {
                  assignments: [],
                  declarations: [
                    {
                      constant: false,
                      id: 375,
                      name: "CDD",
                      nodeType: "VariableDeclaration",
                      scope: 469,
                      src: "3551:11:1",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 374,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "3551:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      value: null,
                      visibility: "internal"
                    }
                  ],
                  id: 376,
                  initialValue: null,
                  nodeType: "VariableDeclarationStatement",
                  src: "3551:11:1"
                },
                {
                  assignments: [],
                  declarations: [
                    {
                      constant: false,
                      id: 378,
                      name: "settlementPrice",
                      nodeType: "VariableDeclaration",
                      scope: 469,
                      src: "3568:23:1",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 377,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "3568:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      value: null,
                      visibility: "internal"
                    }
                  ],
                  id: 379,
                  initialValue: null,
                  nodeType: "VariableDeclarationStatement",
                  src: "3568:23:1"
                },
                {
                  condition: {
                    argumentTypes: null,
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 382,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      argumentTypes: null,
                      id: 380,
                      name: "avgTemp",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 365,
                      src: "3795:7:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "<",
                    rightExpression: {
                      argumentTypes: null,
                      hexValue: "3138",
                      id: 381,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "3805:2:1",
                      subdenomination: null,
                      typeDescriptions: {
                        typeIdentifier: "t_rational_18_by_1",
                        typeString: "int_const 18"
                      },
                      value: "18"
                    },
                    src: "3795:12:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  falseBody: {
                    id: 466,
                    nodeType: "Block",
                    src: "4282:467:1",
                    statements: [
                      {
                        expression: {
                          argumentTypes: null,
                          id: 430,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            argumentTypes: null,
                            id: 425,
                            name: "CDD",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 375,
                            src: "4290:3:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            argumentTypes: null,
                            arguments: [
                              {
                                argumentTypes: null,
                                id: 428,
                                name: "TEMPERATURE_THRESHOLD",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 112,
                                src: "4308:21:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              ],
                              expression: {
                                argumentTypes: null,
                                id: 426,
                                name: "avgTemp",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 365,
                                src: "4296:7:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              id: 427,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "sub",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 1053,
                              src: "4296:11:1",
                              typeDescriptions: {
                                typeIdentifier:
                                  "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
                                typeString:
                                  "function (uint256,uint256) pure returns (uint256)"
                              }
                            },
                            id: 429,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            names: [],
                            nodeType: "FunctionCall",
                            src: "4296:34:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          src: "4290:40:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        id: 431,
                        nodeType: "ExpressionStatement",
                        src: "4290:40:1"
                      },
                      {
                        expression: {
                          argumentTypes: null,
                          id: 437,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            argumentTypes: null,
                            id: 432,
                            name: "settlementPrice",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 378,
                            src: "4338:15:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            argumentTypes: null,
                            arguments: [
                              {
                                argumentTypes: null,
                                hexValue: "33303030303030303030303030303030",
                                id: 435,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                kind: "number",
                                lValueRequested: false,
                                nodeType: "Literal",
                                src: "4364:16:1",
                                subdenomination: null,
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_rational_3000000000000000_by_1",
                                  typeString: "int_const 3000000000000000"
                                },
                                value: "3000000000000000"
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier:
                                    "t_rational_3000000000000000_by_1",
                                  typeString: "int_const 3000000000000000"
                                }
                              ],
                              expression: {
                                argumentTypes: null,
                                id: 433,
                                name: "CDD",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 375,
                                src: "4356:3:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              id: 434,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "mul",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 1005,
                              src: "4356:7:1",
                              typeDescriptions: {
                                typeIdentifier:
                                  "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
                                typeString:
                                  "function (uint256,uint256) pure returns (uint256)"
                              }
                            },
                            id: 436,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            names: [],
                            nodeType: "FunctionCall",
                            src: "4356:25:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          src: "4338:43:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        id: 438,
                        nodeType: "ExpressionStatement",
                        src: "4338:43:1"
                      },
                      {
                        expression: {
                          argumentTypes: null,
                          arguments: [
                            {
                              argumentTypes: null,
                              id: 440,
                              name: "positionAmount",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 110,
                              src: "4490:14:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 441,
                                name: "existingFuture",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 359,
                                src: "4506:14:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_struct$_future_$126_memory_ptr",
                                  typeString:
                                    "struct FuturesFactory.future memory"
                                }
                              },
                              id: 442,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "short",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 119,
                              src: "4506:20:1",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            },
                            {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 443,
                                name: "existingFuture",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 359,
                                src: "4528:14:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_struct$_future_$126_memory_ptr",
                                  typeString:
                                    "struct FuturesFactory.future memory"
                                }
                              },
                              id: 444,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "short",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 119,
                              src: "4528:20:1",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            ],
                            id: 439,
                            name: "_withdrawFromEscrow",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 689,
                            src: "4470:19:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_function_internal_nonpayable$_t_uint256_$_t_address_$_t_address_$returns$_t_bool_$",
                              typeString:
                                "function (uint256,address,address) returns (bool)"
                            }
                          },
                          id: 445,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          names: [],
                          nodeType: "FunctionCall",
                          src: "4470:79:1",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        id: 446,
                        nodeType: "ExpressionStatement",
                        src: "4470:79:1"
                      },
                      {
                        expression: {
                          argumentTypes: null,
                          arguments: [
                            {
                              argumentTypes: null,
                              id: 448,
                              name: "settlementPrice",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 378,
                              src: "4577:15:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 449,
                                name: "existingFuture",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 359,
                                src: "4594:14:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_struct$_future_$126_memory_ptr",
                                  typeString:
                                    "struct FuturesFactory.future memory"
                                }
                              },
                              id: 450,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "long",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 117,
                              src: "4594:19:1",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            },
                            {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 451,
                                name: "existingFuture",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 359,
                                src: "4615:14:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_struct$_future_$126_memory_ptr",
                                  typeString:
                                    "struct FuturesFactory.future memory"
                                }
                              },
                              id: 452,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "short",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 119,
                              src: "4615:20:1",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            ],
                            id: 447,
                            name: "_withdrawFromEscrow",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 689,
                            src: "4557:19:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_function_internal_nonpayable$_t_uint256_$_t_address_$_t_address_$returns$_t_bool_$",
                              typeString:
                                "function (uint256,address,address) returns (bool)"
                            }
                          },
                          id: 453,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          names: [],
                          nodeType: "FunctionCall",
                          src: "4557:79:1",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        id: 454,
                        nodeType: "ExpressionStatement",
                        src: "4557:79:1"
                      },
                      {
                        expression: {
                          argumentTypes: null,
                          arguments: [
                            {
                              argumentTypes: null,
                              arguments: [
                                {
                                  argumentTypes: null,
                                  id: 458,
                                  name: "settlementPrice",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 378,
                                  src: "4683:15:1",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                ],
                                expression: {
                                  argumentTypes: null,
                                  id: 456,
                                  name: "positionAmount",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 110,
                                  src: "4664:14:1",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                id: 457,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                lValueRequested: false,
                                memberName: "sub",
                                nodeType: "MemberAccess",
                                referencedDeclaration: 1053,
                                src: "4664:18:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
                                  typeString:
                                    "function (uint256,uint256) pure returns (uint256)"
                                }
                              },
                              id: 459,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "functionCall",
                              lValueRequested: false,
                              names: [],
                              nodeType: "FunctionCall",
                              src: "4664:35:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 460,
                                name: "existingFuture",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 359,
                                src: "4701:14:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_struct$_future_$126_memory_ptr",
                                  typeString:
                                    "struct FuturesFactory.future memory"
                                }
                              },
                              id: 461,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "long",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 117,
                              src: "4701:19:1",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            },
                            {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 462,
                                name: "existingFuture",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 359,
                                src: "4722:14:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_struct$_future_$126_memory_ptr",
                                  typeString:
                                    "struct FuturesFactory.future memory"
                                }
                              },
                              id: 463,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "long",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 117,
                              src: "4722:19:1",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            ],
                            id: 455,
                            name: "_withdrawFromEscrow",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 689,
                            src: "4644:19:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_function_internal_nonpayable$_t_uint256_$_t_address_$_t_address_$returns$_t_bool_$",
                              typeString:
                                "function (uint256,address,address) returns (bool)"
                            }
                          },
                          id: 464,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          names: [],
                          nodeType: "FunctionCall",
                          src: "4644:98:1",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        id: 465,
                        nodeType: "ExpressionStatement",
                        src: "4644:98:1"
                      }
                    ]
                  },
                  id: 467,
                  nodeType: "IfStatement",
                  src: "3791:958:1",
                  trueBody: {
                    id: 424,
                    nodeType: "Block",
                    src: "3809:467:1",
                    statements: [
                      {
                        expression: {
                          argumentTypes: null,
                          id: 388,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            argumentTypes: null,
                            id: 383,
                            name: "HDD",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 372,
                            src: "3817:3:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            argumentTypes: null,
                            arguments: [
                              {
                                argumentTypes: null,
                                id: 386,
                                name: "avgTemp",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 365,
                                src: "3849:7:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              ],
                              expression: {
                                argumentTypes: null,
                                id: 384,
                                name: "TEMPERATURE_THRESHOLD",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 112,
                                src: "3823:21:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              id: 385,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "sub",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 1053,
                              src: "3823:25:1",
                              typeDescriptions: {
                                typeIdentifier:
                                  "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
                                typeString:
                                  "function (uint256,uint256) pure returns (uint256)"
                              }
                            },
                            id: 387,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            names: [],
                            nodeType: "FunctionCall",
                            src: "3823:34:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          src: "3817:40:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        id: 389,
                        nodeType: "ExpressionStatement",
                        src: "3817:40:1"
                      },
                      {
                        expression: {
                          argumentTypes: null,
                          id: 395,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            argumentTypes: null,
                            id: 390,
                            name: "settlementPrice",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 378,
                            src: "3865:15:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            argumentTypes: null,
                            arguments: [
                              {
                                argumentTypes: null,
                                hexValue: "33303030303030303030303030303030",
                                id: 393,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                kind: "number",
                                lValueRequested: false,
                                nodeType: "Literal",
                                src: "3891:16:1",
                                subdenomination: null,
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_rational_3000000000000000_by_1",
                                  typeString: "int_const 3000000000000000"
                                },
                                value: "3000000000000000"
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier:
                                    "t_rational_3000000000000000_by_1",
                                  typeString: "int_const 3000000000000000"
                                }
                              ],
                              expression: {
                                argumentTypes: null,
                                id: 391,
                                name: "HDD",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 372,
                                src: "3883:3:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              id: 392,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "mul",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 1005,
                              src: "3883:7:1",
                              typeDescriptions: {
                                typeIdentifier:
                                  "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
                                typeString:
                                  "function (uint256,uint256) pure returns (uint256)"
                              }
                            },
                            id: 394,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            names: [],
                            nodeType: "FunctionCall",
                            src: "3883:25:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          src: "3865:43:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        id: 396,
                        nodeType: "ExpressionStatement",
                        src: "3865:43:1"
                      },
                      {
                        expression: {
                          argumentTypes: null,
                          arguments: [
                            {
                              argumentTypes: null,
                              id: 398,
                              name: "positionAmount",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 110,
                              src: "4017:14:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 399,
                                name: "existingFuture",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 359,
                                src: "4033:14:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_struct$_future_$126_memory_ptr",
                                  typeString:
                                    "struct FuturesFactory.future memory"
                                }
                              },
                              id: 400,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "long",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 117,
                              src: "4033:19:1",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            },
                            {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 401,
                                name: "existingFuture",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 359,
                                src: "4054:14:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_struct$_future_$126_memory_ptr",
                                  typeString:
                                    "struct FuturesFactory.future memory"
                                }
                              },
                              id: 402,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "long",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 117,
                              src: "4054:19:1",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            ],
                            id: 397,
                            name: "_withdrawFromEscrow",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 689,
                            src: "3997:19:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_function_internal_nonpayable$_t_uint256_$_t_address_$_t_address_$returns$_t_bool_$",
                              typeString:
                                "function (uint256,address,address) returns (bool)"
                            }
                          },
                          id: 403,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          names: [],
                          nodeType: "FunctionCall",
                          src: "3997:77:1",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        id: 404,
                        nodeType: "ExpressionStatement",
                        src: "3997:77:1"
                      },
                      {
                        expression: {
                          argumentTypes: null,
                          arguments: [
                            {
                              argumentTypes: null,
                              id: 406,
                              name: "settlementPrice",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 378,
                              src: "4102:15:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 407,
                                name: "existingFuture",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 359,
                                src: "4119:14:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_struct$_future_$126_memory_ptr",
                                  typeString:
                                    "struct FuturesFactory.future memory"
                                }
                              },
                              id: 408,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "short",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 119,
                              src: "4119:20:1",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            },
                            {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 409,
                                name: "existingFuture",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 359,
                                src: "4141:14:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_struct$_future_$126_memory_ptr",
                                  typeString:
                                    "struct FuturesFactory.future memory"
                                }
                              },
                              id: 410,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "long",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 117,
                              src: "4141:19:1",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            ],
                            id: 405,
                            name: "_withdrawFromEscrow",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 689,
                            src: "4082:19:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_function_internal_nonpayable$_t_uint256_$_t_address_$_t_address_$returns$_t_bool_$",
                              typeString:
                                "function (uint256,address,address) returns (bool)"
                            }
                          },
                          id: 411,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          names: [],
                          nodeType: "FunctionCall",
                          src: "4082:79:1",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        id: 412,
                        nodeType: "ExpressionStatement",
                        src: "4082:79:1"
                      },
                      {
                        expression: {
                          argumentTypes: null,
                          arguments: [
                            {
                              argumentTypes: null,
                              arguments: [
                                {
                                  argumentTypes: null,
                                  id: 416,
                                  name: "settlementPrice",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 378,
                                  src: "4208:15:1",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                ],
                                expression: {
                                  argumentTypes: null,
                                  id: 414,
                                  name: "positionAmount",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 110,
                                  src: "4189:14:1",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                id: 415,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                lValueRequested: false,
                                memberName: "sub",
                                nodeType: "MemberAccess",
                                referencedDeclaration: 1053,
                                src: "4189:18:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
                                  typeString:
                                    "function (uint256,uint256) pure returns (uint256)"
                                }
                              },
                              id: 417,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "functionCall",
                              lValueRequested: false,
                              names: [],
                              nodeType: "FunctionCall",
                              src: "4189:35:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 418,
                                name: "existingFuture",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 359,
                                src: "4226:14:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_struct$_future_$126_memory_ptr",
                                  typeString:
                                    "struct FuturesFactory.future memory"
                                }
                              },
                              id: 419,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "short",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 119,
                              src: "4226:20:1",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            },
                            {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 420,
                                name: "existingFuture",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 359,
                                src: "4248:14:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_struct$_future_$126_memory_ptr",
                                  typeString:
                                    "struct FuturesFactory.future memory"
                                }
                              },
                              id: 421,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "short",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 119,
                              src: "4248:20:1",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            ],
                            id: 413,
                            name: "_withdrawFromEscrow",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 689,
                            src: "4169:19:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_function_internal_nonpayable$_t_uint256_$_t_address_$_t_address_$returns$_t_bool_$",
                              typeString:
                                "function (uint256,address,address) returns (bool)"
                            }
                          },
                          id: 422,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          names: [],
                          nodeType: "FunctionCall",
                          src: "4169:100:1",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        id: 423,
                        nodeType: "ExpressionStatement",
                        src: "4169:100:1"
                      }
                    ]
                  }
                }
              ]
            },
            documentation: null,
            id: 469,
            implemented: true,
            isConstructor: false,
            isDeclaredConst: false,
            modifiers: [],
            name: "squareOffOrder",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 349,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 348,
                  name: "_futureId",
                  nodeType: "VariableDeclaration",
                  scope: 469,
                  src: "3307:17:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 347,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "3307:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "3306:19:1"
            },
            payable: false,
            returnParameters: {
              id: 350,
              nodeType: "ParameterList",
              parameters: [],
              src: "3333:0:1"
            },
            scope: 690,
            src: "3283:1470:1",
            stateMutability: "nonpayable",
            superFunction: null,
            visibility: "public"
          },
          {
            body: {
              id: 476,
              nodeType: "Block",
              src: "4815:31:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    id: 474,
                    name: "escrowAddress",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 102,
                    src: "4828:13:1",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  functionReturnParameters: 473,
                  id: 475,
                  nodeType: "Return",
                  src: "4821:20:1"
                }
              ]
            },
            documentation: null,
            id: 477,
            implemented: true,
            isConstructor: false,
            isDeclaredConst: true,
            modifiers: [],
            name: "getEscrowAddress",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 470,
              nodeType: "ParameterList",
              parameters: [],
              src: "4782:2:1"
            },
            payable: false,
            returnParameters: {
              id: 473,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 472,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 477,
                  src: "4806:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 471,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "4806:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "4805:9:1"
            },
            scope: 690,
            src: "4757:89:1",
            stateMutability: "view",
            superFunction: null,
            visibility: "public"
          },
          {
            body: {
              id: 484,
              nodeType: "Block",
              src: "4909:26:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    id: 482,
                    name: "futureId",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 104,
                    src: "4922:8:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  functionReturnParameters: 481,
                  id: 483,
                  nodeType: "Return",
                  src: "4915:15:1"
                }
              ]
            },
            documentation: null,
            id: 485,
            implemented: true,
            isConstructor: false,
            isDeclaredConst: true,
            modifiers: [],
            name: "getLatestFutureID",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 478,
              nodeType: "ParameterList",
              parameters: [],
              src: "4876:2:1"
            },
            payable: false,
            returnParameters: {
              id: 481,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 480,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 485,
                  src: "4900:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 479,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "4900:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "4899:9:1"
            },
            scope: 690,
            src: "4850:85:1",
            stateMutability: "view",
            superFunction: null,
            visibility: "public"
          },
          {
            body: {
              id: 492,
              nodeType: "Block",
              src: "4997:25:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    id: 490,
                    name: "orderId",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 106,
                    src: "5010:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  functionReturnParameters: 489,
                  id: 491,
                  nodeType: "Return",
                  src: "5003:14:1"
                }
              ]
            },
            documentation: null,
            id: 493,
            implemented: true,
            isConstructor: false,
            isDeclaredConst: true,
            modifiers: [],
            name: "getLatestOrderID",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 486,
              nodeType: "ParameterList",
              parameters: [],
              src: "4964:2:1"
            },
            payable: false,
            returnParameters: {
              id: 489,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 488,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 493,
                  src: "4988:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 487,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "4988:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "4987:9:1"
            },
            scope: 690,
            src: "4939:83:1",
            stateMutability: "view",
            superFunction: null,
            visibility: "public"
          },
          {
            body: {
              id: 526,
              nodeType: "Block",
              src: "5161:221:1",
              statements: [
                {
                  assignments: [509],
                  declarations: [
                    {
                      constant: false,
                      id: 509,
                      name: "existingFuture",
                      nodeType: "VariableDeclaration",
                      scope: 527,
                      src: "5167:28:1",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_future_$126_memory_ptr",
                        typeString: "struct FuturesFactory.future"
                      },
                      typeName: {
                        contractScope: null,
                        id: 508,
                        name: "future",
                        nodeType: "UserDefinedTypeName",
                        referencedDeclaration: 126,
                        src: "5167:6:1",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_future_$126_storage_ptr",
                          typeString: "struct FuturesFactory.future"
                        }
                      },
                      value: null,
                      visibility: "internal"
                    }
                  ],
                  id: 513,
                  initialValue: {
                    argumentTypes: null,
                    baseExpression: {
                      argumentTypes: null,
                      id: 510,
                      name: "futuresList",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 147,
                      src: "5198:11:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_mapping$_t_uint256_$_t_struct$_future_$126_storage_$",
                        typeString:
                          "mapping(uint256 => struct FuturesFactory.future storage ref)"
                      }
                    },
                    id: 512,
                    indexExpression: {
                      argumentTypes: null,
                      id: 511,
                      name: "_futureId",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 495,
                      src: "5210:9:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "5198:22:1",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_future_$126_storage",
                      typeString: "struct FuturesFactory.future storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "5167:53:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    components: [
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 514,
                          name: "existingFuture",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 509,
                          src: "5241:14:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_future_$126_memory_ptr",
                            typeString: "struct FuturesFactory.future memory"
                          }
                        },
                        id: 515,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "long",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 117,
                        src: "5241:19:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 516,
                          name: "existingFuture",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 509,
                          src: "5268:14:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_future_$126_memory_ptr",
                            typeString: "struct FuturesFactory.future memory"
                          }
                        },
                        id: 517,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "short",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 119,
                        src: "5268:20:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 518,
                          name: "existingFuture",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 509,
                          src: "5296:14:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_future_$126_memory_ptr",
                            typeString: "struct FuturesFactory.future memory"
                          }
                        },
                        id: 519,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "qty",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 121,
                        src: "5296:18:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 520,
                          name: "existingFuture",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 509,
                          src: "5322:14:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_future_$126_memory_ptr",
                            typeString: "struct FuturesFactory.future memory"
                          }
                        },
                        id: 521,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "price",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 123,
                        src: "5322:20:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 522,
                          name: "existingFuture",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 509,
                          src: "5350:14:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_future_$126_memory_ptr",
                            typeString: "struct FuturesFactory.future memory"
                          }
                        },
                        id: 523,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "expiry",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 125,
                        src: "5350:21:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    id: 524,
                    isConstant: false,
                    isInlineArray: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "TupleExpression",
                    src: "5233:144:1",
                    typeDescriptions: {
                      typeIdentifier:
                        "t_tuple$_t_address_$_t_address_$_t_uint256_$_t_uint256_$_t_uint256_$",
                      typeString:
                        "tuple(address,address,uint256,uint256,uint256)"
                    }
                  },
                  functionReturnParameters: 507,
                  id: 525,
                  nodeType: "Return",
                  src: "5226:151:1"
                }
              ]
            },
            documentation: null,
            id: 527,
            implemented: true,
            isConstructor: false,
            isDeclaredConst: true,
            modifiers: [],
            name: "getFutureDetails",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 496,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 495,
                  name: "_futureId",
                  nodeType: "VariableDeclaration",
                  scope: 527,
                  src: "5052:17:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 494,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "5052:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "5051:19:1"
            },
            payable: false,
            returnParameters: {
              id: 507,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 498,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 527,
                  src: "5097:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 497,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "5097:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 500,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 527,
                  src: "5110:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 499,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "5110:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 502,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 527,
                  src: "5123:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 501,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "5123:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 504,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 527,
                  src: "5136:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 503,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "5136:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 506,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 527,
                  src: "5149:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 505,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "5149:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "5091:69:1"
            },
            scope: 690,
            src: "5026:356:1",
            stateMutability: "view",
            superFunction: null,
            visibility: "public"
          },
          {
            body: {
              id: 564,
              nodeType: "Block",
              src: "5530:247:1",
              statements: [
                {
                  assignments: [545],
                  declarations: [
                    {
                      constant: false,
                      id: 545,
                      name: "existingOrder",
                      nodeType: "VariableDeclaration",
                      scope: 565,
                      src: "5536:26:1",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_order_$139_memory_ptr",
                        typeString: "struct FuturesFactory.order"
                      },
                      typeName: {
                        contractScope: null,
                        id: 544,
                        name: "order",
                        nodeType: "UserDefinedTypeName",
                        referencedDeclaration: 139,
                        src: "5536:5:1",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_order_$139_storage_ptr",
                          typeString: "struct FuturesFactory.order"
                        }
                      },
                      value: null,
                      visibility: "internal"
                    }
                  ],
                  id: 549,
                  initialValue: {
                    argumentTypes: null,
                    baseExpression: {
                      argumentTypes: null,
                      id: 546,
                      name: "ordersList",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 151,
                      src: "5565:10:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_mapping$_t_uint256_$_t_struct$_order_$139_storage_$",
                        typeString:
                          "mapping(uint256 => struct FuturesFactory.order storage ref)"
                      }
                    },
                    id: 548,
                    indexExpression: {
                      argumentTypes: null,
                      id: 547,
                      name: "_orderId",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 529,
                      src: "5576:8:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "5565:20:1",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_order_$139_storage",
                      typeString: "struct FuturesFactory.order storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "5536:49:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    components: [
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 550,
                          name: "existingOrder",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 545,
                          src: "5606:13:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_order_$139_memory_ptr",
                            typeString: "struct FuturesFactory.order memory"
                          }
                        },
                        id: 551,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "trader",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 128,
                        src: "5606:20:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 552,
                          name: "existingOrder",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 545,
                          src: "5634:13:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_order_$139_memory_ptr",
                            typeString: "struct FuturesFactory.order memory"
                          }
                        },
                        id: 553,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "position",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 130,
                        src: "5634:22:1",
                        typeDescriptions: {
                          typeIdentifier: "t_enum$_Position_$115",
                          typeString: "enum FuturesFactory.Position"
                        }
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 554,
                          name: "existingOrder",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 545,
                          src: "5664:13:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_order_$139_memory_ptr",
                            typeString: "struct FuturesFactory.order memory"
                          }
                        },
                        id: 555,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "qty",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 132,
                        src: "5664:17:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 556,
                          name: "existingOrder",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 545,
                          src: "5689:13:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_order_$139_memory_ptr",
                            typeString: "struct FuturesFactory.order memory"
                          }
                        },
                        id: 557,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "price",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 134,
                        src: "5689:19:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 558,
                          name: "existingOrder",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 545,
                          src: "5716:13:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_order_$139_memory_ptr",
                            typeString: "struct FuturesFactory.order memory"
                          }
                        },
                        id: 559,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "expiry",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 136,
                        src: "5716:20:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 560,
                          name: "existingOrder",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 545,
                          src: "5744:13:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_order_$139_memory_ptr",
                            typeString: "struct FuturesFactory.order memory"
                          }
                        },
                        id: 561,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "isFilled",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 138,
                        src: "5744:22:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      }
                    ],
                    id: 562,
                    isConstant: false,
                    isInlineArray: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "TupleExpression",
                    src: "5598:174:1",
                    typeDescriptions: {
                      typeIdentifier:
                        "t_tuple$_t_address_$_t_enum$_Position_$115_$_t_uint256_$_t_uint256_$_t_uint256_$_t_bool_$",
                      typeString:
                        "tuple(address,enum FuturesFactory.Position,uint256,uint256,uint256,bool)"
                    }
                  },
                  functionReturnParameters: 543,
                  id: 563,
                  nodeType: "Return",
                  src: "5591:181:1"
                }
              ]
            },
            documentation: null,
            id: 565,
            implemented: true,
            isConstructor: false,
            isDeclaredConst: true,
            modifiers: [],
            name: "getOrderDetails",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 530,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 529,
                  name: "_orderId",
                  nodeType: "VariableDeclaration",
                  scope: 565,
                  src: "5411:16:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 528,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "5411:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "5410:18:1"
            },
            payable: false,
            returnParameters: {
              id: 543,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 532,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 565,
                  src: "5455:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 531,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "5455:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 534,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 565,
                  src: "5468:8:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_enum$_Position_$115",
                    typeString: "enum FuturesFactory.Position"
                  },
                  typeName: {
                    contractScope: null,
                    id: 533,
                    name: "Position",
                    nodeType: "UserDefinedTypeName",
                    referencedDeclaration: 115,
                    src: "5468:8:1",
                    typeDescriptions: {
                      typeIdentifier: "t_enum$_Position_$115",
                      typeString: "enum FuturesFactory.Position"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 536,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 565,
                  src: "5482:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 535,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "5482:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 538,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 565,
                  src: "5495:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 537,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "5495:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 540,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 565,
                  src: "5508:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 539,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "5508:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 542,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 565,
                  src: "5521:4:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  },
                  typeName: {
                    id: 541,
                    name: "bool",
                    nodeType: "ElementaryTypeName",
                    src: "5521:4:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "5449:80:1"
            },
            scope: 690,
            src: "5386:391:1",
            stateMutability: "view",
            superFunction: null,
            visibility: "public"
          },
          {
            body: {
              id: 606,
              nodeType: "Block",
              src: "5854:316:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        commonType: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        id: 579,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          argumentTypes: null,
                          commonType: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          },
                          id: 575,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            argumentTypes: null,
                            id: 573,
                            name: "_futureId",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 567,
                            src: "5868:9:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "BinaryOperation",
                          operator: "<",
                          rightExpression: {
                            argumentTypes: null,
                            id: 574,
                            name: "futureId",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 104,
                            src: "5880:8:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          src: "5868:20:1",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: "&&",
                        rightExpression: {
                          argumentTypes: null,
                          commonType: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          },
                          id: 578,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            argumentTypes: null,
                            id: 576,
                            name: "_futureId",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 567,
                            src: "5892:9:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "BinaryOperation",
                          operator: ">",
                          rightExpression: {
                            argumentTypes: null,
                            hexValue: "30",
                            id: 577,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            kind: "number",
                            lValueRequested: false,
                            nodeType: "Literal",
                            src: "5904:1:1",
                            subdenomination: null,
                            typeDescriptions: {
                              typeIdentifier: "t_rational_0_by_1",
                              typeString: "int_const 0"
                            },
                            value: "0"
                          },
                          src: "5892:13:1",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        src: "5868:37:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      {
                        argumentTypes: null,
                        hexValue:
                          "496e76616c69642066757475726520636f6e7472616374204944",
                        id: 580,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "5907:28:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_da78eb731c3ccc763cced40df89ec12d13dbd514425e1b0db19f3f824786112d",
                          typeString:
                            'literal_string "Invalid future contract ID"'
                        },
                        value: "Invalid future contract ID"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_da78eb731c3ccc763cced40df89ec12d13dbd514425e1b0db19f3f824786112d",
                          typeString:
                            'literal_string "Invalid future contract ID"'
                        }
                      ],
                      id: 572,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [2943, 2944],
                      referencedDeclaration: 2944,
                      src: "5860:7:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure"
                      }
                    },
                    id: 581,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "5860:76:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 582,
                  nodeType: "ExpressionStatement",
                  src: "5860:76:1"
                },
                {
                  assignments: [584],
                  declarations: [
                    {
                      constant: false,
                      id: 584,
                      name: "existingFuture",
                      nodeType: "VariableDeclaration",
                      scope: 607,
                      src: "5942:28:1",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_future_$126_memory_ptr",
                        typeString: "struct FuturesFactory.future"
                      },
                      typeName: {
                        contractScope: null,
                        id: 583,
                        name: "future",
                        nodeType: "UserDefinedTypeName",
                        referencedDeclaration: 126,
                        src: "5942:6:1",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_future_$126_storage_ptr",
                          typeString: "struct FuturesFactory.future"
                        }
                      },
                      value: null,
                      visibility: "internal"
                    }
                  ],
                  id: 588,
                  initialValue: {
                    argumentTypes: null,
                    baseExpression: {
                      argumentTypes: null,
                      id: 585,
                      name: "futuresList",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 147,
                      src: "5973:11:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_mapping$_t_uint256_$_t_struct$_future_$126_storage_$",
                        typeString:
                          "mapping(uint256 => struct FuturesFactory.future storage ref)"
                      }
                    },
                    id: 587,
                    indexExpression: {
                      argumentTypes: null,
                      id: 586,
                      name: "_futureId",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 567,
                      src: "5985:9:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "5973:22:1",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_future_$126_storage",
                      typeString: "struct FuturesFactory.future storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "5942:53:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        commonType: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        id: 600,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          argumentTypes: null,
                          commonType: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          },
                          id: 594,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            argumentTypes: null,
                            expression: {
                              argumentTypes: null,
                              id: 590,
                              name: "msg",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 2940,
                              src: "6016:3:1",
                              typeDescriptions: {
                                typeIdentifier: "t_magic_message",
                                typeString: "msg"
                              }
                            },
                            id: 591,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberName: "sender",
                            nodeType: "MemberAccess",
                            referencedDeclaration: null,
                            src: "6016:10:1",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          },
                          nodeType: "BinaryOperation",
                          operator: "==",
                          rightExpression: {
                            argumentTypes: null,
                            expression: {
                              argumentTypes: null,
                              id: 592,
                              name: "existingFuture",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 584,
                              src: "6030:14:1",
                              typeDescriptions: {
                                typeIdentifier:
                                  "t_struct$_future_$126_memory_ptr",
                                typeString:
                                  "struct FuturesFactory.future memory"
                              }
                            },
                            id: 593,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberName: "long",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 117,
                            src: "6030:19:1",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          },
                          src: "6016:33:1",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: "||",
                        rightExpression: {
                          argumentTypes: null,
                          commonType: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          },
                          id: 599,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            argumentTypes: null,
                            expression: {
                              argumentTypes: null,
                              id: 595,
                              name: "msg",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 2940,
                              src: "6053:3:1",
                              typeDescriptions: {
                                typeIdentifier: "t_magic_message",
                                typeString: "msg"
                              }
                            },
                            id: 596,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberName: "sender",
                            nodeType: "MemberAccess",
                            referencedDeclaration: null,
                            src: "6053:10:1",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          },
                          nodeType: "BinaryOperation",
                          operator: "==",
                          rightExpression: {
                            argumentTypes: null,
                            expression: {
                              argumentTypes: null,
                              id: 597,
                              name: "existingFuture",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 584,
                              src: "6067:14:1",
                              typeDescriptions: {
                                typeIdentifier:
                                  "t_struct$_future_$126_memory_ptr",
                                typeString:
                                  "struct FuturesFactory.future memory"
                              }
                            },
                            id: 598,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberName: "short",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 119,
                            src: "6067:20:1",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          },
                          src: "6053:34:1",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        src: "6016:71:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      {
                        argumentTypes: null,
                        hexValue:
                          "4f6e6c79206c6f6e67206f722073686f72742073656c6c65722063616e20657865726369736520667574757265",
                        id: 601,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "6095:47:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_9dba8159c3b655a5b6932c075a25bcce49d7a6c89c7e9cff495263cdda08e5ab",
                          typeString:
                            'literal_string "Only long or short seller can exercise future"'
                        },
                        value: "Only long or short seller can exercise future"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_9dba8159c3b655a5b6932c075a25bcce49d7a6c89c7e9cff495263cdda08e5ab",
                          typeString:
                            'literal_string "Only long or short seller can exercise future"'
                        }
                      ],
                      id: 589,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [2943, 2944],
                      referencedDeclaration: 2944,
                      src: "6001:7:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure"
                      }
                    },
                    id: 602,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "6001:147:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 603,
                  nodeType: "ExpressionStatement",
                  src: "6001:147:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    hexValue: "74727565",
                    id: 604,
                    isConstant: false,
                    isLValue: false,
                    isPure: true,
                    kind: "bool",
                    lValueRequested: false,
                    nodeType: "Literal",
                    src: "6161:4:1",
                    subdenomination: null,
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    },
                    value: "true"
                  },
                  functionReturnParameters: 571,
                  id: 605,
                  nodeType: "Return",
                  src: "6154:11:1"
                }
              ]
            },
            documentation: null,
            id: 607,
            implemented: true,
            isConstructor: false,
            isDeclaredConst: true,
            modifiers: [],
            name: "_canBeExercised",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 568,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 567,
                  name: "_futureId",
                  nodeType: "VariableDeclaration",
                  scope: 607,
                  src: "5806:17:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 566,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "5806:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "5805:19:1"
            },
            payable: false,
            returnParameters: {
              id: 571,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 570,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 607,
                  src: "5848:4:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  },
                  typeName: {
                    id: 569,
                    name: "bool",
                    nodeType: "ElementaryTypeName",
                    src: "5848:4:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "5847:6:1"
            },
            scope: 690,
            src: "5781:389:1",
            stateMutability: "view",
            superFunction: null,
            visibility: "internal"
          },
          {
            body: {
              id: 642,
              nodeType: "Block",
              src: "6233:279:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        commonType: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        id: 617,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          argumentTypes: null,
                          id: 613,
                          name: "deployedOracleAddress",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 108,
                          src: "6247:21:1",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: "!=",
                        rightExpression: {
                          argumentTypes: null,
                          arguments: [
                            {
                              argumentTypes: null,
                              hexValue: "30",
                              id: 615,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              kind: "number",
                              lValueRequested: false,
                              nodeType: "Literal",
                              src: "6280:1:1",
                              subdenomination: null,
                              typeDescriptions: {
                                typeIdentifier: "t_rational_0_by_1",
                                typeString: "int_const 0"
                              },
                              value: "0"
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_rational_0_by_1",
                                typeString: "int_const 0"
                              }
                            ],
                            id: 614,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            lValueRequested: false,
                            nodeType: "ElementaryTypeNameExpression",
                            src: "6272:7:1",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_address_$",
                              typeString: "type(address)"
                            },
                            typeName: "address"
                          },
                          id: 616,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "typeConversion",
                          lValueRequested: false,
                          names: [],
                          nodeType: "FunctionCall",
                          src: "6272:10:1",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        src: "6247:35:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      {
                        argumentTypes: null,
                        hexValue:
                          "57656174686572206f7261636c652061646472657373206e6f7420736574",
                        id: 618,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "6284:32:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_356a2336c160aeb30443371900f041c1d67355223ecbb3c6df15f3cfa2802c6f",
                          typeString:
                            'literal_string "Weather oracle address not set"'
                        },
                        value: "Weather oracle address not set"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_356a2336c160aeb30443371900f041c1d67355223ecbb3c6df15f3cfa2802c6f",
                          typeString:
                            'literal_string "Weather oracle address not set"'
                        }
                      ],
                      id: 612,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [2943, 2944],
                      referencedDeclaration: 2944,
                      src: "6239:7:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure"
                      }
                    },
                    id: 619,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "6239:78:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 620,
                  nodeType: "ExpressionStatement",
                  src: "6239:78:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        commonType: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        id: 628,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          argumentTypes: null,
                          arguments: [],
                          expression: {
                            argumentTypes: [],
                            expression: {
                              argumentTypes: null,
                              arguments: [
                                {
                                  argumentTypes: null,
                                  id: 623,
                                  name: "deployedOracleAddress",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 108,
                                  src: "6339:21:1",
                                  typeDescriptions: {
                                    typeIdentifier: "t_address",
                                    typeString: "address"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_address",
                                    typeString: "address"
                                  }
                                ],
                                id: 622,
                                name: "IOracle",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 1145,
                                src: "6331:7:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_type$_t_contract$_IOracle_$1145_$",
                                  typeString: "type(contract IOracle)"
                                }
                              },
                              id: 624,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "typeConversion",
                              lValueRequested: false,
                              names: [],
                              nodeType: "FunctionCall",
                              src: "6331:30:1",
                              typeDescriptions: {
                                typeIdentifier: "t_contract$_IOracle_$1145",
                                typeString: "contract IOracle"
                              }
                            },
                            id: 625,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberName: "avgTempReceived",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 1134,
                            src: "6331:46:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_function_external_view$__$returns$_t_bool_$",
                              typeString:
                                "function () view external returns (bool)"
                            }
                          },
                          id: 626,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          names: [],
                          nodeType: "FunctionCall",
                          src: "6331:48:1",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: "==",
                        rightExpression: {
                          argumentTypes: null,
                          hexValue: "74727565",
                          id: 627,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "bool",
                          lValueRequested: false,
                          nodeType: "Literal",
                          src: "6383:4:1",
                          subdenomination: null,
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          },
                          value: "true"
                        },
                        src: "6331:56:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      {
                        argumentTypes: null,
                        hexValue:
                          "4176672074656d7065726174757265206e6f7420726563696576656420796574",
                        id: 629,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "6389:34:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_b442f2d746d042c4e8e08a6ae892326df128b53df2b22935766dda91e3112a36",
                          typeString:
                            'literal_string "Avg temperature not recieved yet"'
                        },
                        value: "Avg temperature not recieved yet"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_b442f2d746d042c4e8e08a6ae892326df128b53df2b22935766dda91e3112a36",
                          typeString:
                            'literal_string "Avg temperature not recieved yet"'
                        }
                      ],
                      id: 621,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [2943, 2944],
                      referencedDeclaration: 2944,
                      src: "6323:7:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure"
                      }
                    },
                    id: 630,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "6323:101:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 631,
                  nodeType: "ExpressionStatement",
                  src: "6323:101:1"
                },
                {
                  assignments: [633],
                  declarations: [
                    {
                      constant: false,
                      id: 633,
                      name: "avgTemp",
                      nodeType: "VariableDeclaration",
                      scope: 643,
                      src: "6430:14:1",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_int256",
                        typeString: "int256"
                      },
                      typeName: {
                        id: 632,
                        name: "int256",
                        nodeType: "ElementaryTypeName",
                        src: "6430:6:1",
                        typeDescriptions: {
                          typeIdentifier: "t_int256",
                          typeString: "int256"
                        }
                      },
                      value: null,
                      visibility: "internal"
                    }
                  ],
                  id: 639,
                  initialValue: {
                    argumentTypes: null,
                    arguments: [],
                    expression: {
                      argumentTypes: [],
                      expression: {
                        argumentTypes: null,
                        arguments: [
                          {
                            argumentTypes: null,
                            id: 635,
                            name: "deployedOracleAddress",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 108,
                            src: "6455:21:1",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          ],
                          id: 634,
                          name: "IOracle",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 1145,
                          src: "6447:7:1",
                          typeDescriptions: {
                            typeIdentifier:
                              "t_type$_t_contract$_IOracle_$1145_$",
                            typeString: "type(contract IOracle)"
                          }
                        },
                        id: 636,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "typeConversion",
                        lValueRequested: false,
                        names: [],
                        nodeType: "FunctionCall",
                        src: "6447:30:1",
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_IOracle_$1145",
                          typeString: "contract IOracle"
                        }
                      },
                      id: 637,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberName: "avgTemp",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 1136,
                      src: "6447:38:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_external_view$__$returns$_t_int256_$",
                        typeString: "function () view external returns (int256)"
                      }
                    },
                    id: 638,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "6447:40:1",
                    typeDescriptions: {
                      typeIdentifier: "t_int256",
                      typeString: "int256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "6430:57:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    id: 640,
                    name: "avgTemp",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 633,
                    src: "6500:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_int256",
                      typeString: "int256"
                    }
                  },
                  functionReturnParameters: 611,
                  id: 641,
                  nodeType: "Return",
                  src: "6493:14:1"
                }
              ]
            },
            documentation: null,
            id: 643,
            implemented: true,
            isConstructor: false,
            isDeclaredConst: true,
            modifiers: [],
            name: "_getAvgTemperature",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 608,
              nodeType: "ParameterList",
              parameters: [],
              src: "6201:2:1"
            },
            payable: false,
            returnParameters: {
              id: 611,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 610,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 643,
                  src: "6225:6:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_int256",
                    typeString: "int256"
                  },
                  typeName: {
                    id: 609,
                    name: "int256",
                    nodeType: "ElementaryTypeName",
                    src: "6225:6:1",
                    typeDescriptions: {
                      typeIdentifier: "t_int256",
                      typeString: "int256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "6224:8:1"
            },
            scope: 690,
            src: "6174:338:1",
            stateMutability: "view",
            superFunction: null,
            visibility: "public"
          },
          {
            body: {
              id: 665,
              nodeType: "Block",
              src: "6600:89:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        id: 659,
                        name: "_payer",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 647,
                        src: "6651:6:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        argumentTypes: null,
                        id: 660,
                        name: "_amount",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 645,
                        src: "6659:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      arguments: [
                        {
                          argumentTypes: null,
                          id: 657,
                          name: "_amount",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 645,
                          src: "6642:7:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        ],
                        expression: {
                          argumentTypes: null,
                          expression: {
                            argumentTypes: null,
                            arguments: [
                              {
                                argumentTypes: null,
                                id: 653,
                                name: "escrowAddress",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 102,
                                src: "6613:13:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_address",
                                  typeString: "address"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_address",
                                  typeString: "address"
                                }
                              ],
                              id: 652,
                              name: "Escrow",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 86,
                              src: "6606:6:1",
                              typeDescriptions: {
                                typeIdentifier:
                                  "t_type$_t_contract$_Escrow_$86_$",
                                typeString: "type(contract Escrow)"
                              }
                            },
                            id: 654,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "typeConversion",
                            lValueRequested: false,
                            names: [],
                            nodeType: "FunctionCall",
                            src: "6606:21:1",
                            typeDescriptions: {
                              typeIdentifier: "t_contract$_Escrow_$86",
                              typeString: "contract Escrow"
                            }
                          },
                          id: 655,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberName: "deposit",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 45,
                          src: "6606:29:1",
                          typeDescriptions: {
                            typeIdentifier:
                              "t_function_external_payable$_t_address_$_t_uint256_$returns$__$",
                            typeString:
                              "function (address,uint256) payable external"
                          }
                        },
                        id: 656,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "value",
                        nodeType: "MemberAccess",
                        referencedDeclaration: null,
                        src: "6606:35:1",
                        typeDescriptions: {
                          typeIdentifier:
                            "t_function_setvalue_nonpayable$_t_uint256_$returns$_t_function_external_payable$_t_address_$_t_uint256_$returns$__$value_$",
                          typeString:
                            "function (uint256) returns (function (address,uint256) payable external)"
                        }
                      },
                      id: 658,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      names: [],
                      nodeType: "FunctionCall",
                      src: "6606:44:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_external_payable$_t_address_$_t_uint256_$returns$__$value",
                        typeString:
                          "function (address,uint256) payable external"
                      }
                    },
                    id: 661,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "6606:61:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 662,
                  nodeType: "ExpressionStatement",
                  src: "6606:61:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    hexValue: "74727565",
                    id: 663,
                    isConstant: false,
                    isLValue: false,
                    isPure: true,
                    kind: "bool",
                    lValueRequested: false,
                    nodeType: "Literal",
                    src: "6680:4:1",
                    subdenomination: null,
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    },
                    value: "true"
                  },
                  functionReturnParameters: 651,
                  id: 664,
                  nodeType: "Return",
                  src: "6673:11:1"
                }
              ]
            },
            documentation: null,
            id: 666,
            implemented: true,
            isConstructor: false,
            isDeclaredConst: false,
            modifiers: [],
            name: "_transferToEscrow",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 648,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 645,
                  name: "_amount",
                  nodeType: "VariableDeclaration",
                  scope: 666,
                  src: "6543:15:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 644,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "6543:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 647,
                  name: "_payer",
                  nodeType: "VariableDeclaration",
                  scope: 666,
                  src: "6560:14:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 646,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "6560:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "6542:33:1"
            },
            payable: false,
            returnParameters: {
              id: 651,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 650,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 666,
                  src: "6594:4:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  },
                  typeName: {
                    id: 649,
                    name: "bool",
                    nodeType: "ElementaryTypeName",
                    src: "6594:4:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "6593:6:1"
            },
            scope: 690,
            src: "6516:173:1",
            stateMutability: "nonpayable",
            superFunction: null,
            visibility: "internal"
          },
          {
            body: {
              id: 688,
              nodeType: "Block",
              src: "6795:83:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        id: 681,
                        name: "_payer",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 670,
                        src: "6832:6:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        argumentTypes: null,
                        id: 682,
                        name: "_payee",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 672,
                        src: "6840:6:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        argumentTypes: null,
                        id: 683,
                        name: "_amount",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 668,
                        src: "6848:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      expression: {
                        argumentTypes: null,
                        arguments: [
                          {
                            argumentTypes: null,
                            id: 678,
                            name: "escrowAddress",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 102,
                            src: "6808:13:1",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          ],
                          id: 677,
                          name: "Escrow",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 86,
                          src: "6801:6:1",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_contract$_Escrow_$86_$",
                            typeString: "type(contract Escrow)"
                          }
                        },
                        id: 679,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "typeConversion",
                        lValueRequested: false,
                        names: [],
                        nodeType: "FunctionCall",
                        src: "6801:21:1",
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_Escrow_$86",
                          typeString: "contract Escrow"
                        }
                      },
                      id: 680,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberName: "withdraw",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 85,
                      src: "6801:30:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_external_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$_t_bool_$",
                        typeString:
                          "function (address,address,uint256) external returns (bool)"
                      }
                    },
                    id: 684,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "6801:55:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 685,
                  nodeType: "ExpressionStatement",
                  src: "6801:55:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    hexValue: "74727565",
                    id: 686,
                    isConstant: false,
                    isLValue: false,
                    isPure: true,
                    kind: "bool",
                    lValueRequested: false,
                    nodeType: "Literal",
                    src: "6869:4:1",
                    subdenomination: null,
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    },
                    value: "true"
                  },
                  functionReturnParameters: 676,
                  id: 687,
                  nodeType: "Return",
                  src: "6862:11:1"
                }
              ]
            },
            documentation: null,
            id: 689,
            implemented: true,
            isConstructor: false,
            isDeclaredConst: false,
            modifiers: [],
            name: "_withdrawFromEscrow",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 673,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 668,
                  name: "_amount",
                  nodeType: "VariableDeclaration",
                  scope: 689,
                  src: "6722:15:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 667,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "6722:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 670,
                  name: "_payer",
                  nodeType: "VariableDeclaration",
                  scope: 689,
                  src: "6739:14:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 669,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "6739:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 672,
                  name: "_payee",
                  nodeType: "VariableDeclaration",
                  scope: 689,
                  src: "6755:14:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 671,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "6755:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "6721:49:1"
            },
            payable: false,
            returnParameters: {
              id: 676,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 675,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 689,
                  src: "6789:4:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  },
                  typeName: {
                    id: 674,
                    name: "bool",
                    nodeType: "ElementaryTypeName",
                    src: "6789:4:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "6788:6:1"
            },
            scope: 690,
            src: "6693:185:1",
            stateMutability: "nonpayable",
            superFunction: null,
            visibility: "internal"
          }
        ],
        scope: 691,
        src: "247:6633:1"
      }
    ],
    src: "0:6880:1"
  },
  legacyAST: {
    absolutePath: "/home/roheat/honeycomb/helios/contracts/FuturesFactory.sol",
    exportedSymbols: {
      FuturesFactory: [690]
    },
    id: 691,
    nodeType: "SourceUnit",
    nodes: [
      {
        id: 88,
        literals: ["solidity", "0.4", ".24"],
        nodeType: "PragmaDirective",
        src: "0:23:1"
      },
      {
        absolutePath: "/home/roheat/honeycomb/helios/contracts/SafeMath.sol",
        file: "./SafeMath.sol",
        id: 89,
        nodeType: "ImportDirective",
        scope: 691,
        sourceUnit: 1099,
        src: "25:24:1",
        symbolAliases: [],
        unitAlias: ""
      },
      {
        absolutePath: "/home/roheat/honeycomb/helios/contracts/Ownable.sol",
        file: "./Ownable.sol",
        id: 90,
        nodeType: "ImportDirective",
        scope: 691,
        sourceUnit: 971,
        src: "50:23:1",
        symbolAliases: [],
        unitAlias: ""
      },
      {
        absolutePath: "/home/roheat/honeycomb/helios/contracts/Escrow.sol",
        file: "./Escrow.sol",
        id: 91,
        nodeType: "ImportDirective",
        scope: 691,
        sourceUnit: 87,
        src: "74:22:1",
        symbolAliases: [],
        unitAlias: ""
      },
      {
        absolutePath:
          "/home/roheat/honeycomb/helios/contracts/interfaces/IOracle.sol",
        file: "./interfaces/IOracle.sol",
        id: 92,
        nodeType: "ImportDirective",
        scope: 691,
        sourceUnit: 1146,
        src: "97:34:1",
        symbolAliases: [],
        unitAlias: ""
      },
      {
        baseContracts: [
          {
            arguments: null,
            baseName: {
              contractScope: null,
              id: 93,
              name: "Ownable",
              nodeType: "UserDefinedTypeName",
              referencedDeclaration: 970,
              src: "274:7:1",
              typeDescriptions: {
                typeIdentifier: "t_contract$_Ownable_$970",
                typeString: "contract Ownable"
              }
            },
            id: 94,
            nodeType: "InheritanceSpecifier",
            src: "274:7:1"
          }
        ],
        contractDependencies: [86, 970],
        contractKind: "contract",
        documentation: null,
        fullyImplemented: true,
        id: 690,
        linearizedBaseContracts: [690, 970],
        name: "FuturesFactory",
        nodeType: "ContractDefinition",
        nodes: [
          {
            id: 97,
            libraryName: {
              contractScope: null,
              id: 95,
              name: "SafeMath",
              nodeType: "UserDefinedTypeName",
              referencedDeclaration: 1098,
              src: "292:8:1",
              typeDescriptions: {
                typeIdentifier: "t_contract$_SafeMath_$1098",
                typeString: "library SafeMath"
              }
            },
            nodeType: "UsingForDirective",
            src: "286:27:1",
            typeName: {
              id: 96,
              name: "uint256",
              nodeType: "ElementaryTypeName",
              src: "305:7:1",
              typeDescriptions: {
                typeIdentifier: "t_uint256",
                typeString: "uint256"
              }
            }
          },
          {
            id: 100,
            libraryName: {
              contractScope: null,
              id: 98,
              name: "SafeMath",
              nodeType: "UserDefinedTypeName",
              referencedDeclaration: 1098,
              src: "322:8:1",
              typeDescriptions: {
                typeIdentifier: "t_contract$_SafeMath_$1098",
                typeString: "library SafeMath"
              }
            },
            nodeType: "UsingForDirective",
            src: "316:26:1",
            typeName: {
              id: 99,
              name: "int256",
              nodeType: "ElementaryTypeName",
              src: "335:6:1",
              typeDescriptions: {
                typeIdentifier: "t_int256",
                typeString: "int256"
              }
            }
          },
          {
            constant: false,
            id: 102,
            name: "escrowAddress",
            nodeType: "VariableDeclaration",
            scope: 690,
            src: "345:29:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_address",
              typeString: "address"
            },
            typeName: {
              id: 101,
              name: "address",
              nodeType: "ElementaryTypeName",
              src: "345:7:1",
              typeDescriptions: {
                typeIdentifier: "t_address",
                typeString: "address"
              }
            },
            value: null,
            visibility: "private"
          },
          {
            constant: false,
            id: 104,
            name: "futureId",
            nodeType: "VariableDeclaration",
            scope: 690,
            src: "378:24:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_uint256",
              typeString: "uint256"
            },
            typeName: {
              id: 103,
              name: "uint256",
              nodeType: "ElementaryTypeName",
              src: "378:7:1",
              typeDescriptions: {
                typeIdentifier: "t_uint256",
                typeString: "uint256"
              }
            },
            value: null,
            visibility: "private"
          },
          {
            constant: false,
            id: 106,
            name: "orderId",
            nodeType: "VariableDeclaration",
            scope: 690,
            src: "406:23:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_uint256",
              typeString: "uint256"
            },
            typeName: {
              id: 105,
              name: "uint256",
              nodeType: "ElementaryTypeName",
              src: "406:7:1",
              typeDescriptions: {
                typeIdentifier: "t_uint256",
                typeString: "uint256"
              }
            },
            value: null,
            visibility: "private"
          },
          {
            constant: false,
            id: 108,
            name: "deployedOracleAddress",
            nodeType: "VariableDeclaration",
            scope: 690,
            src: "433:37:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_address",
              typeString: "address"
            },
            typeName: {
              id: 107,
              name: "address",
              nodeType: "ElementaryTypeName",
              src: "433:7:1",
              typeDescriptions: {
                typeIdentifier: "t_address",
                typeString: "address"
              }
            },
            value: null,
            visibility: "private"
          },
          {
            constant: false,
            id: 110,
            name: "positionAmount",
            nodeType: "VariableDeclaration",
            scope: 690,
            src: "474:30:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_uint256",
              typeString: "uint256"
            },
            typeName: {
              id: 109,
              name: "uint256",
              nodeType: "ElementaryTypeName",
              src: "474:7:1",
              typeDescriptions: {
                typeIdentifier: "t_uint256",
                typeString: "uint256"
              }
            },
            value: null,
            visibility: "private"
          },
          {
            constant: false,
            id: 112,
            name: "TEMPERATURE_THRESHOLD",
            nodeType: "VariableDeclaration",
            scope: 690,
            src: "508:36:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_uint256",
              typeString: "uint256"
            },
            typeName: {
              id: 111,
              name: "uint256",
              nodeType: "ElementaryTypeName",
              src: "508:7:1",
              typeDescriptions: {
                typeIdentifier: "t_uint256",
                typeString: "uint256"
              }
            },
            value: null,
            visibility: "public"
          },
          {
            canonicalName: "FuturesFactory.Position",
            id: 115,
            members: [
              {
                id: 113,
                name: "LONG",
                nodeType: "EnumValue",
                src: "565:4:1"
              },
              {
                id: 114,
                name: "SHORT",
                nodeType: "EnumValue",
                src: "571:5:1"
              }
            ],
            name: "Position",
            nodeType: "EnumDefinition",
            src: "549:29:1"
          },
          {
            canonicalName: "FuturesFactory.future",
            id: 126,
            members: [
              {
                constant: false,
                id: 117,
                name: "long",
                nodeType: "VariableDeclaration",
                scope: 126,
                src: "602:12:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_address",
                  typeString: "address"
                },
                typeName: {
                  id: 116,
                  name: "address",
                  nodeType: "ElementaryTypeName",
                  src: "602:7:1",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  }
                },
                value: null,
                visibility: "internal"
              },
              {
                constant: false,
                id: 119,
                name: "short",
                nodeType: "VariableDeclaration",
                scope: 126,
                src: "620:13:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_address",
                  typeString: "address"
                },
                typeName: {
                  id: 118,
                  name: "address",
                  nodeType: "ElementaryTypeName",
                  src: "620:7:1",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  }
                },
                value: null,
                visibility: "internal"
              },
              {
                constant: false,
                id: 121,
                name: "qty",
                nodeType: "VariableDeclaration",
                scope: 126,
                src: "639:11:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256"
                },
                typeName: {
                  id: 120,
                  name: "uint256",
                  nodeType: "ElementaryTypeName",
                  src: "639:7:1",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  }
                },
                value: null,
                visibility: "internal"
              },
              {
                constant: false,
                id: 123,
                name: "price",
                nodeType: "VariableDeclaration",
                scope: 126,
                src: "656:13:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256"
                },
                typeName: {
                  id: 122,
                  name: "uint256",
                  nodeType: "ElementaryTypeName",
                  src: "656:7:1",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  }
                },
                value: null,
                visibility: "internal"
              },
              {
                constant: false,
                id: 125,
                name: "expiry",
                nodeType: "VariableDeclaration",
                scope: 126,
                src: "675:14:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256"
                },
                typeName: {
                  id: 124,
                  name: "uint256",
                  nodeType: "ElementaryTypeName",
                  src: "675:7:1",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  }
                },
                value: null,
                visibility: "internal"
              }
            ],
            name: "future",
            nodeType: "StructDefinition",
            scope: 690,
            src: "582:112:1",
            visibility: "public"
          },
          {
            canonicalName: "FuturesFactory.order",
            id: 139,
            members: [
              {
                constant: false,
                id: 128,
                name: "trader",
                nodeType: "VariableDeclaration",
                scope: 139,
                src: "717:14:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_address",
                  typeString: "address"
                },
                typeName: {
                  id: 127,
                  name: "address",
                  nodeType: "ElementaryTypeName",
                  src: "717:7:1",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  }
                },
                value: null,
                visibility: "internal"
              },
              {
                constant: false,
                id: 130,
                name: "position",
                nodeType: "VariableDeclaration",
                scope: 139,
                src: "737:17:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_enum$_Position_$115",
                  typeString: "enum FuturesFactory.Position"
                },
                typeName: {
                  contractScope: null,
                  id: 129,
                  name: "Position",
                  nodeType: "UserDefinedTypeName",
                  referencedDeclaration: 115,
                  src: "737:8:1",
                  typeDescriptions: {
                    typeIdentifier: "t_enum$_Position_$115",
                    typeString: "enum FuturesFactory.Position"
                  }
                },
                value: null,
                visibility: "internal"
              },
              {
                constant: false,
                id: 132,
                name: "qty",
                nodeType: "VariableDeclaration",
                scope: 139,
                src: "760:11:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256"
                },
                typeName: {
                  id: 131,
                  name: "uint256",
                  nodeType: "ElementaryTypeName",
                  src: "760:7:1",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  }
                },
                value: null,
                visibility: "internal"
              },
              {
                constant: false,
                id: 134,
                name: "price",
                nodeType: "VariableDeclaration",
                scope: 139,
                src: "777:13:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256"
                },
                typeName: {
                  id: 133,
                  name: "uint256",
                  nodeType: "ElementaryTypeName",
                  src: "777:7:1",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  }
                },
                value: null,
                visibility: "internal"
              },
              {
                constant: false,
                id: 136,
                name: "expiry",
                nodeType: "VariableDeclaration",
                scope: 139,
                src: "796:14:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256"
                },
                typeName: {
                  id: 135,
                  name: "uint256",
                  nodeType: "ElementaryTypeName",
                  src: "796:7:1",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  }
                },
                value: null,
                visibility: "internal"
              },
              {
                constant: false,
                id: 138,
                name: "isFilled",
                nodeType: "VariableDeclaration",
                scope: 139,
                src: "816:13:1",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_bool",
                  typeString: "bool"
                },
                typeName: {
                  id: 137,
                  name: "bool",
                  nodeType: "ElementaryTypeName",
                  src: "816:4:1",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  }
                },
                value: null,
                visibility: "internal"
              }
            ],
            name: "order",
            nodeType: "StructDefinition",
            scope: 690,
            src: "698:136:1",
            visibility: "public"
          },
          {
            anonymous: false,
            documentation: null,
            id: 143,
            name: "idEvent",
            nodeType: "EventDefinition",
            parameters: {
              id: 142,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 141,
                  indexed: false,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 143,
                  src: "852:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 140,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "852:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "851:9:1"
            },
            src: "838:23:1"
          },
          {
            constant: false,
            id: 147,
            name: "futuresList",
            nodeType: "VariableDeclaration",
            scope: 690,
            src: "865:38:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier:
                "t_mapping$_t_uint256_$_t_struct$_future_$126_storage_$",
              typeString: "mapping(uint256 => struct FuturesFactory.future)"
            },
            typeName: {
              id: 146,
              keyType: {
                id: 144,
                name: "uint256",
                nodeType: "ElementaryTypeName",
                src: "873:7:1",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256"
                }
              },
              nodeType: "Mapping",
              src: "865:26:1",
              typeDescriptions: {
                typeIdentifier:
                  "t_mapping$_t_uint256_$_t_struct$_future_$126_storage_$",
                typeString: "mapping(uint256 => struct FuturesFactory.future)"
              },
              valueType: {
                contractScope: null,
                id: 145,
                name: "future",
                nodeType: "UserDefinedTypeName",
                referencedDeclaration: 126,
                src: "884:6:1",
                typeDescriptions: {
                  typeIdentifier: "t_struct$_future_$126_storage_ptr",
                  typeString: "struct FuturesFactory.future"
                }
              }
            },
            value: null,
            visibility: "internal"
          },
          {
            constant: false,
            id: 151,
            name: "ordersList",
            nodeType: "VariableDeclaration",
            scope: 690,
            src: "929:36:1",
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier:
                "t_mapping$_t_uint256_$_t_struct$_order_$139_storage_$",
              typeString: "mapping(uint256 => struct FuturesFactory.order)"
            },
            typeName: {
              id: 150,
              keyType: {
                id: 148,
                name: "uint256",
                nodeType: "ElementaryTypeName",
                src: "937:7:1",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256"
                }
              },
              nodeType: "Mapping",
              src: "929:25:1",
              typeDescriptions: {
                typeIdentifier:
                  "t_mapping$_t_uint256_$_t_struct$_order_$139_storage_$",
                typeString: "mapping(uint256 => struct FuturesFactory.order)"
              },
              valueType: {
                contractScope: null,
                id: 149,
                name: "order",
                nodeType: "UserDefinedTypeName",
                referencedDeclaration: 139,
                src: "948:5:1",
                typeDescriptions: {
                  typeIdentifier: "t_struct$_order_$139_storage_ptr",
                  typeString: "struct FuturesFactory.order"
                }
              }
            },
            value: null,
            visibility: "internal"
          },
          {
            body: {
              id: 180,
              nodeType: "Block",
              src: "1165:159:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    id: 158,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      argumentTypes: null,
                      id: 156,
                      name: "deployedOracleAddress",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 108,
                      src: "1171:21:1",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      argumentTypes: null,
                      id: 157,
                      name: "_oracleAddress",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 153,
                      src: "1195:14:1",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    src: "1171:38:1",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  id: 159,
                  nodeType: "ExpressionStatement",
                  src: "1171:38:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    id: 166,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      argumentTypes: null,
                      id: 160,
                      name: "escrowAddress",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 102,
                      src: "1215:13:1",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      argumentTypes: null,
                      arguments: [
                        {
                          argumentTypes: null,
                          arguments: [],
                          expression: {
                            argumentTypes: [],
                            id: 163,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: "NewExpression",
                            src: "1239:10:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_function_creation_nonpayable$__$returns$_t_contract$_Escrow_$86_$",
                              typeString:
                                "function () returns (contract Escrow)"
                            },
                            typeName: {
                              contractScope: null,
                              id: 162,
                              name: "Escrow",
                              nodeType: "UserDefinedTypeName",
                              referencedDeclaration: 86,
                              src: "1243:6:1",
                              typeDescriptions: {
                                typeIdentifier: "t_contract$_Escrow_$86",
                                typeString: "contract Escrow"
                              }
                            }
                          },
                          id: 164,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          names: [],
                          nodeType: "FunctionCall",
                          src: "1239:12:1",
                          typeDescriptions: {
                            typeIdentifier: "t_contract$_Escrow_$86",
                            typeString: "contract Escrow"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_contract$_Escrow_$86",
                            typeString: "contract Escrow"
                          }
                        ],
                        id: 161,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        nodeType: "ElementaryTypeNameExpression",
                        src: "1231:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_address_$",
                          typeString: "type(address)"
                        },
                        typeName: "address"
                      },
                      id: 165,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "typeConversion",
                      lValueRequested: false,
                      names: [],
                      nodeType: "FunctionCall",
                      src: "1231:21:1",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    src: "1215:37:1",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  id: 167,
                  nodeType: "ExpressionStatement",
                  src: "1215:37:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    id: 170,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      argumentTypes: null,
                      id: 168,
                      name: "futureId",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 104,
                      src: "1258:8:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      argumentTypes: null,
                      hexValue: "31",
                      id: 169,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "1269:1:1",
                      subdenomination: null,
                      typeDescriptions: {
                        typeIdentifier: "t_rational_1_by_1",
                        typeString: "int_const 1"
                      },
                      value: "1"
                    },
                    src: "1258:12:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 171,
                  nodeType: "ExpressionStatement",
                  src: "1258:12:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    id: 174,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      argumentTypes: null,
                      id: 172,
                      name: "orderId",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 106,
                      src: "1276:7:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      argumentTypes: null,
                      hexValue: "31",
                      id: 173,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "1286:1:1",
                      subdenomination: null,
                      typeDescriptions: {
                        typeIdentifier: "t_rational_1_by_1",
                        typeString: "int_const 1"
                      },
                      value: "1"
                    },
                    src: "1276:11:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 175,
                  nodeType: "ExpressionStatement",
                  src: "1276:11:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    id: 178,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      argumentTypes: null,
                      id: 176,
                      name: "TEMPERATURE_THRESHOLD",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 112,
                      src: "1293:21:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      argumentTypes: null,
                      hexValue: "3138",
                      id: 177,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "1317:2:1",
                      subdenomination: null,
                      typeDescriptions: {
                        typeIdentifier: "t_rational_18_by_1",
                        typeString: "int_const 18"
                      },
                      value: "18"
                    },
                    src: "1293:26:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 179,
                  nodeType: "ExpressionStatement",
                  src: "1293:26:1"
                }
              ]
            },
            documentation: null,
            id: 181,
            implemented: true,
            isConstructor: true,
            isDeclaredConst: false,
            modifiers: [],
            name: "",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 154,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 153,
                  name: "_oracleAddress",
                  nodeType: "VariableDeclaration",
                  scope: 181,
                  src: "1134:22:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 152,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "1134:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "1133:24:1"
            },
            payable: false,
            returnParameters: {
              id: 155,
              nodeType: "ParameterList",
              parameters: [],
              src: "1165:0:1"
            },
            scope: 690,
            src: "1122:202:1",
            stateMutability: "nonpayable",
            superFunction: null,
            visibility: "public"
          },
          {
            body: {
              id: 235,
              nodeType: "Block",
              src: "1451:272:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        id: 199,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          argumentTypes: null,
                          arguments: [
                            {
                              argumentTypes: null,
                              id: 195,
                              name: "_price",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 187,
                              src: "1474:6:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            ],
                            expression: {
                              argumentTypes: null,
                              id: 193,
                              name: "_qty",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 185,
                              src: "1465:4:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            id: 194,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberName: "mul",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 1005,
                            src: "1465:8:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
                              typeString:
                                "function (uint256,uint256) pure returns (uint256)"
                            }
                          },
                          id: 196,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          names: [],
                          nodeType: "FunctionCall",
                          src: "1465:16:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: "==",
                        rightExpression: {
                          argumentTypes: null,
                          expression: {
                            argumentTypes: null,
                            id: 197,
                            name: "msg",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 2940,
                            src: "1485:3:1",
                            typeDescriptions: {
                              typeIdentifier: "t_magic_message",
                              typeString: "msg"
                            }
                          },
                          id: 198,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberName: "value",
                          nodeType: "MemberAccess",
                          referencedDeclaration: null,
                          src: "1485:9:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        src: "1465:29:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      {
                        argumentTypes: null,
                        hexValue:
                          "416d6f756e74207061696420697320696e636f7272656374",
                        id: 200,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "1496:26:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_e5197f906cb686880b18e3b4f67ef11b1a40b0004d98423bf5be9df5c145fdce",
                          typeString:
                            'literal_string "Amount paid is incorrect"'
                        },
                        value: "Amount paid is incorrect"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_e5197f906cb686880b18e3b4f67ef11b1a40b0004d98423bf5be9df5c145fdce",
                          typeString:
                            'literal_string "Amount paid is incorrect"'
                        }
                      ],
                      id: 192,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [2943, 2944],
                      referencedDeclaration: 2944,
                      src: "1457:7:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure"
                      }
                    },
                    id: 201,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1457:66:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 202,
                  nodeType: "ExpressionStatement",
                  src: "1457:66:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    id: 208,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      argumentTypes: null,
                      id: 203,
                      name: "positionAmount",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 110,
                      src: "1529:14:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      argumentTypes: null,
                      arguments: [
                        {
                          argumentTypes: null,
                          expression: {
                            argumentTypes: null,
                            id: 205,
                            name: "msg",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 2940,
                            src: "1554:3:1",
                            typeDescriptions: {
                              typeIdentifier: "t_magic_message",
                              typeString: "msg"
                            }
                          },
                          id: 206,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberName: "value",
                          nodeType: "MemberAccess",
                          referencedDeclaration: null,
                          src: "1554:9:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        ],
                        id: 204,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        nodeType: "ElementaryTypeNameExpression",
                        src: "1546:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_uint256_$",
                          typeString: "type(uint256)"
                        },
                        typeName: "uint256"
                      },
                      id: 207,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "typeConversion",
                      lValueRequested: false,
                      names: [],
                      nodeType: "FunctionCall",
                      src: "1546:18:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "1529:35:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 209,
                  nodeType: "ExpressionStatement",
                  src: "1529:35:1"
                },
                {
                  assignments: [211],
                  declarations: [
                    {
                      constant: false,
                      id: 211,
                      name: "newOrder",
                      nodeType: "VariableDeclaration",
                      scope: 236,
                      src: "1570:21:1",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_order_$139_memory_ptr",
                        typeString: "struct FuturesFactory.order"
                      },
                      typeName: {
                        contractScope: null,
                        id: 210,
                        name: "order",
                        nodeType: "UserDefinedTypeName",
                        referencedDeclaration: 139,
                        src: "1570:5:1",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_order_$139_storage_ptr",
                          typeString: "struct FuturesFactory.order"
                        }
                      },
                      value: null,
                      visibility: "internal"
                    }
                  ],
                  id: 221,
                  initialValue: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 213,
                          name: "msg",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 2940,
                          src: "1600:3:1",
                          typeDescriptions: {
                            typeIdentifier: "t_magic_message",
                            typeString: "msg"
                          }
                        },
                        id: 214,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "sender",
                        nodeType: "MemberAccess",
                        referencedDeclaration: null,
                        src: "1600:10:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        argumentTypes: null,
                        id: 215,
                        name: "_position",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 183,
                        src: "1612:9:1",
                        typeDescriptions: {
                          typeIdentifier: "t_enum$_Position_$115",
                          typeString: "enum FuturesFactory.Position"
                        }
                      },
                      {
                        argumentTypes: null,
                        id: 216,
                        name: "_qty",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 185,
                        src: "1623:4:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        argumentTypes: null,
                        id: 217,
                        name: "_price",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 187,
                        src: "1629:6:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        argumentTypes: null,
                        id: 218,
                        name: "_expiry",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 189,
                        src: "1637:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        argumentTypes: null,
                        hexValue: "66616c7365",
                        id: 219,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "bool",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "1646:5:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        value: "false"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_enum$_Position_$115",
                          typeString: "enum FuturesFactory.Position"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      ],
                      id: 212,
                      name: "order",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 139,
                      src: "1594:5:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_type$_t_struct$_order_$139_storage_ptr_$",
                        typeString:
                          "type(struct FuturesFactory.order storage pointer)"
                      }
                    },
                    id: 220,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "structConstructorCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1594:58:1",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_order_$139_memory",
                      typeString: "struct FuturesFactory.order memory"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "1570:82:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    id: 226,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      argumentTypes: null,
                      baseExpression: {
                        argumentTypes: null,
                        id: 222,
                        name: "ordersList",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 151,
                        src: "1658:10:1",
                        typeDescriptions: {
                          typeIdentifier:
                            "t_mapping$_t_uint256_$_t_struct$_order_$139_storage_$",
                          typeString:
                            "mapping(uint256 => struct FuturesFactory.order storage ref)"
                        }
                      },
                      id: 224,
                      indexExpression: {
                        argumentTypes: null,
                        id: 223,
                        name: "orderId",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 106,
                        src: "1669:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "1658:19:1",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_order_$139_storage",
                        typeString: "struct FuturesFactory.order storage ref"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      argumentTypes: null,
                      id: 225,
                      name: "newOrder",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 211,
                      src: "1680:8:1",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_order_$139_memory_ptr",
                        typeString: "struct FuturesFactory.order memory"
                      }
                    },
                    src: "1658:30:1",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_order_$139_storage",
                      typeString: "struct FuturesFactory.order storage ref"
                    }
                  },
                  id: 227,
                  nodeType: "ExpressionStatement",
                  src: "1658:30:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    id: 233,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      argumentTypes: null,
                      id: 228,
                      name: "orderId",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 106,
                      src: "1694:7:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      argumentTypes: null,
                      arguments: [
                        {
                          argumentTypes: null,
                          hexValue: "31",
                          id: 231,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "number",
                          lValueRequested: false,
                          nodeType: "Literal",
                          src: "1716:1:1",
                          subdenomination: null,
                          typeDescriptions: {
                            typeIdentifier: "t_rational_1_by_1",
                            typeString: "int_const 1"
                          },
                          value: "1"
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_rational_1_by_1",
                            typeString: "int_const 1"
                          }
                        ],
                        expression: {
                          argumentTypes: null,
                          id: 229,
                          name: "orderId",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 106,
                          src: "1704:7:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        id: 230,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "add",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 1077,
                        src: "1704:11:1",
                        typeDescriptions: {
                          typeIdentifier:
                            "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
                          typeString:
                            "function (uint256,uint256) pure returns (uint256)"
                        }
                      },
                      id: 232,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      names: [],
                      nodeType: "FunctionCall",
                      src: "1704:14:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "1694:24:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 234,
                  nodeType: "ExpressionStatement",
                  src: "1694:24:1"
                }
              ]
            },
            documentation: null,
            id: 236,
            implemented: true,
            isConstructor: false,
            isDeclaredConst: false,
            modifiers: [],
            name: "submitOrder",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 190,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 183,
                  name: "_position",
                  nodeType: "VariableDeclaration",
                  scope: 236,
                  src: "1354:18:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_enum$_Position_$115",
                    typeString: "enum FuturesFactory.Position"
                  },
                  typeName: {
                    contractScope: null,
                    id: 182,
                    name: "Position",
                    nodeType: "UserDefinedTypeName",
                    referencedDeclaration: 115,
                    src: "1354:8:1",
                    typeDescriptions: {
                      typeIdentifier: "t_enum$_Position_$115",
                      typeString: "enum FuturesFactory.Position"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 185,
                  name: "_qty",
                  nodeType: "VariableDeclaration",
                  scope: 236,
                  src: "1378:12:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 184,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "1378:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 187,
                  name: "_price",
                  nodeType: "VariableDeclaration",
                  scope: 236,
                  src: "1396:14:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 186,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "1396:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 189,
                  name: "_expiry",
                  nodeType: "VariableDeclaration",
                  scope: 236,
                  src: "1416:15:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 188,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "1416:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "1348:87:1"
            },
            payable: true,
            returnParameters: {
              id: 191,
              nodeType: "ParameterList",
              parameters: [],
              src: "1451:0:1"
            },
            scope: 690,
            src: "1328:395:1",
            stateMutability: "payable",
            superFunction: null,
            visibility: "public"
          },
          {
            body: {
              id: 345,
              nodeType: "Block",
              src: "2222:818:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        id: 255,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          argumentTypes: null,
                          id: 252,
                          name: "positionAmount",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 110,
                          src: "2236:14:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: "==",
                        rightExpression: {
                          argumentTypes: null,
                          expression: {
                            argumentTypes: null,
                            id: 253,
                            name: "msg",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 2940,
                            src: "2254:3:1",
                            typeDescriptions: {
                              typeIdentifier: "t_magic_message",
                              typeString: "msg"
                            }
                          },
                          id: 254,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberName: "value",
                          nodeType: "MemberAccess",
                          referencedDeclaration: null,
                          src: "2254:9:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        src: "2236:27:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      {
                        argumentTypes: null,
                        hexValue:
                          "496e737566696369656e7420706f736974696f6e20616d6f756e74",
                        id: 256,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "2265:29:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_b1830e3a311ee118b47b8bf2c5651f8cdc8ade03d6a6b90f13e529267878a6ce",
                          typeString:
                            'literal_string "Insuficient position amount"'
                        },
                        value: "Insuficient position amount"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_b1830e3a311ee118b47b8bf2c5651f8cdc8ade03d6a6b90f13e529267878a6ce",
                          typeString:
                            'literal_string "Insuficient position amount"'
                        }
                      ],
                      id: 251,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [2943, 2944],
                      referencedDeclaration: 2944,
                      src: "2228:7:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure"
                      }
                    },
                    id: 257,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "2228:67:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 258,
                  nodeType: "ExpressionStatement",
                  src: "2228:67:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        arguments: [
                          {
                            argumentTypes: null,
                            arguments: [
                              {
                                argumentTypes: null,
                                id: 262,
                                name: "positionAmount",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 110,
                                src: "2335:14:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              ],
                              id: 261,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              lValueRequested: false,
                              nodeType: "ElementaryTypeNameExpression",
                              src: "2327:7:1",
                              typeDescriptions: {
                                typeIdentifier: "t_type$_t_uint256_$",
                                typeString: "type(uint256)"
                              },
                              typeName: "uint256"
                            },
                            id: 263,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "typeConversion",
                            lValueRequested: false,
                            names: [],
                            nodeType: "FunctionCall",
                            src: "2327:23:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          {
                            argumentTypes: null,
                            id: 264,
                            name: "_long",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 238,
                            src: "2352:5:1",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            },
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          ],
                          id: 260,
                          name: "_transferToEscrow",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 666,
                          src: "2309:17:1",
                          typeDescriptions: {
                            typeIdentifier:
                              "t_function_internal_nonpayable$_t_uint256_$_t_address_$returns$_t_bool_$",
                            typeString:
                              "function (uint256,address) returns (bool)"
                          }
                        },
                        id: 265,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        names: [],
                        nodeType: "FunctionCall",
                        src: "2309:49:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      {
                        argumentTypes: null,
                        hexValue:
                          "4661696c6564206174206c6f6e67205f7472616e73666572546f457363726f77",
                        id: 266,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "2360:34:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_219df58f81064029780e8ba857a924cb36a5a197c8f3410698ec3dc7e18b0350",
                          typeString:
                            'literal_string "Failed at long _transferToEscrow"'
                        },
                        value: "Failed at long _transferToEscrow"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_219df58f81064029780e8ba857a924cb36a5a197c8f3410698ec3dc7e18b0350",
                          typeString:
                            'literal_string "Failed at long _transferToEscrow"'
                        }
                      ],
                      id: 259,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [2943, 2944],
                      referencedDeclaration: 2944,
                      src: "2301:7:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure"
                      }
                    },
                    id: 267,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "2301:94:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 268,
                  nodeType: "ExpressionStatement",
                  src: "2301:94:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        arguments: [
                          {
                            argumentTypes: null,
                            arguments: [
                              {
                                argumentTypes: null,
                                id: 272,
                                name: "positionAmount",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 110,
                                src: "2435:14:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              ],
                              id: 271,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              lValueRequested: false,
                              nodeType: "ElementaryTypeNameExpression",
                              src: "2427:7:1",
                              typeDescriptions: {
                                typeIdentifier: "t_type$_t_uint256_$",
                                typeString: "type(uint256)"
                              },
                              typeName: "uint256"
                            },
                            id: 273,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "typeConversion",
                            lValueRequested: false,
                            names: [],
                            nodeType: "FunctionCall",
                            src: "2427:23:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          {
                            argumentTypes: null,
                            id: 274,
                            name: "_short",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 240,
                            src: "2452:6:1",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            },
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          ],
                          id: 270,
                          name: "_transferToEscrow",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 666,
                          src: "2409:17:1",
                          typeDescriptions: {
                            typeIdentifier:
                              "t_function_internal_nonpayable$_t_uint256_$_t_address_$returns$_t_bool_$",
                            typeString:
                              "function (uint256,address) returns (bool)"
                          }
                        },
                        id: 275,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        names: [],
                        nodeType: "FunctionCall",
                        src: "2409:50:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      {
                        argumentTypes: null,
                        hexValue:
                          "4661696c65642061742073686f7274205f7472616e73666572546f457363726f77",
                        id: 276,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "2461:35:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_c1dd06e1bec49b538449019ae7ed984bdbde3bba9e30de9227b7736bb6549ab3",
                          typeString:
                            'literal_string "Failed at short _transferToEscrow"'
                        },
                        value: "Failed at short _transferToEscrow"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_c1dd06e1bec49b538449019ae7ed984bdbde3bba9e30de9227b7736bb6549ab3",
                          typeString:
                            'literal_string "Failed at short _transferToEscrow"'
                        }
                      ],
                      id: 269,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [2943, 2944],
                      referencedDeclaration: 2944,
                      src: "2401:7:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure"
                      }
                    },
                    id: 277,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "2401:96:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 278,
                  nodeType: "ExpressionStatement",
                  src: "2401:96:1"
                },
                {
                  assignments: [280],
                  declarations: [
                    {
                      constant: false,
                      id: 280,
                      name: "newFuture",
                      nodeType: "VariableDeclaration",
                      scope: 346,
                      src: "2504:23:1",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_future_$126_memory_ptr",
                        typeString: "struct FuturesFactory.future"
                      },
                      typeName: {
                        contractScope: null,
                        id: 279,
                        name: "future",
                        nodeType: "UserDefinedTypeName",
                        referencedDeclaration: 126,
                        src: "2504:6:1",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_future_$126_storage_ptr",
                          typeString: "struct FuturesFactory.future"
                        }
                      },
                      value: null,
                      visibility: "internal"
                    }
                  ],
                  id: 288,
                  initialValue: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        id: 282,
                        name: "_long",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 238,
                        src: "2544:5:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        argumentTypes: null,
                        id: 283,
                        name: "_short",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 240,
                        src: "2557:6:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        argumentTypes: null,
                        id: 284,
                        name: "_qty",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 242,
                        src: "2571:4:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        argumentTypes: null,
                        id: 285,
                        name: "_price",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 244,
                        src: "2583:6:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        argumentTypes: null,
                        id: 286,
                        name: "_expiry",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 246,
                        src: "2597:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      id: 281,
                      name: "future",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 126,
                      src: "2530:6:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_type$_t_struct$_future_$126_storage_ptr_$",
                        typeString:
                          "type(struct FuturesFactory.future storage pointer)"
                      }
                    },
                    id: 287,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "structConstructorCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "2530:80:1",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_future_$126_memory",
                      typeString: "struct FuturesFactory.future memory"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "2504:106:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    id: 293,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      argumentTypes: null,
                      baseExpression: {
                        argumentTypes: null,
                        id: 289,
                        name: "futuresList",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 147,
                        src: "2617:11:1",
                        typeDescriptions: {
                          typeIdentifier:
                            "t_mapping$_t_uint256_$_t_struct$_future_$126_storage_$",
                          typeString:
                            "mapping(uint256 => struct FuturesFactory.future storage ref)"
                        }
                      },
                      id: 291,
                      indexExpression: {
                        argumentTypes: null,
                        id: 290,
                        name: "futureId",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 104,
                        src: "2629:8:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "2617:21:1",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_future_$126_storage",
                        typeString: "struct FuturesFactory.future storage ref"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      argumentTypes: null,
                      id: 292,
                      name: "newFuture",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 280,
                      src: "2641:9:1",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_future_$126_memory_ptr",
                        typeString: "struct FuturesFactory.future memory"
                      }
                    },
                    src: "2617:33:1",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_future_$126_storage",
                      typeString: "struct FuturesFactory.future storage ref"
                    }
                  },
                  id: 294,
                  nodeType: "ExpressionStatement",
                  src: "2617:33:1"
                },
                {
                  assignments: [296],
                  declarations: [
                    {
                      constant: false,
                      id: 296,
                      name: "prevOrderId",
                      nodeType: "VariableDeclaration",
                      scope: 346,
                      src: "2656:19:1",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 295,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "2656:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      value: null,
                      visibility: "internal"
                    }
                  ],
                  id: 301,
                  initialValue: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        hexValue: "31",
                        id: 299,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "number",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "2690:1:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier: "t_rational_1_by_1",
                          typeString: "int_const 1"
                        },
                        value: "1"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_rational_1_by_1",
                          typeString: "int_const 1"
                        }
                      ],
                      expression: {
                        argumentTypes: null,
                        id: 297,
                        name: "orderId",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 106,
                        src: "2678:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      id: 298,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberName: "sub",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 1053,
                      src: "2678:11:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
                        typeString:
                          "function (uint256,uint256) pure returns (uint256)"
                      }
                    },
                    id: 300,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "2678:14:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "2656:36:1"
                },
                {
                  assignments: [303],
                  declarations: [
                    {
                      constant: false,
                      id: 303,
                      name: "tempOrder",
                      nodeType: "VariableDeclaration",
                      scope: 346,
                      src: "2698:22:1",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_order_$139_memory_ptr",
                        typeString: "struct FuturesFactory.order"
                      },
                      typeName: {
                        contractScope: null,
                        id: 302,
                        name: "order",
                        nodeType: "UserDefinedTypeName",
                        referencedDeclaration: 139,
                        src: "2698:5:1",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_order_$139_storage_ptr",
                          typeString: "struct FuturesFactory.order"
                        }
                      },
                      value: null,
                      visibility: "internal"
                    }
                  ],
                  id: 327,
                  initialValue: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          baseExpression: {
                            argumentTypes: null,
                            id: 305,
                            name: "ordersList",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 151,
                            src: "2736:10:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_mapping$_t_uint256_$_t_struct$_order_$139_storage_$",
                              typeString:
                                "mapping(uint256 => struct FuturesFactory.order storage ref)"
                            }
                          },
                          id: 307,
                          indexExpression: {
                            argumentTypes: null,
                            id: 306,
                            name: "prevOrderId",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 296,
                            src: "2747:11:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "2736:23:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_order_$139_storage",
                            typeString:
                              "struct FuturesFactory.order storage ref"
                          }
                        },
                        id: 308,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "trader",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 128,
                        src: "2736:30:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          baseExpression: {
                            argumentTypes: null,
                            id: 309,
                            name: "ordersList",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 151,
                            src: "2774:10:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_mapping$_t_uint256_$_t_struct$_order_$139_storage_$",
                              typeString:
                                "mapping(uint256 => struct FuturesFactory.order storage ref)"
                            }
                          },
                          id: 311,
                          indexExpression: {
                            argumentTypes: null,
                            id: 310,
                            name: "prevOrderId",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 296,
                            src: "2785:11:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "2774:23:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_order_$139_storage",
                            typeString:
                              "struct FuturesFactory.order storage ref"
                          }
                        },
                        id: 312,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "position",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 130,
                        src: "2774:32:1",
                        typeDescriptions: {
                          typeIdentifier: "t_enum$_Position_$115",
                          typeString: "enum FuturesFactory.Position"
                        }
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          baseExpression: {
                            argumentTypes: null,
                            id: 313,
                            name: "ordersList",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 151,
                            src: "2814:10:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_mapping$_t_uint256_$_t_struct$_order_$139_storage_$",
                              typeString:
                                "mapping(uint256 => struct FuturesFactory.order storage ref)"
                            }
                          },
                          id: 315,
                          indexExpression: {
                            argumentTypes: null,
                            id: 314,
                            name: "prevOrderId",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 296,
                            src: "2825:11:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "2814:23:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_order_$139_storage",
                            typeString:
                              "struct FuturesFactory.order storage ref"
                          }
                        },
                        id: 316,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "qty",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 132,
                        src: "2814:27:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          baseExpression: {
                            argumentTypes: null,
                            id: 317,
                            name: "ordersList",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 151,
                            src: "2849:10:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_mapping$_t_uint256_$_t_struct$_order_$139_storage_$",
                              typeString:
                                "mapping(uint256 => struct FuturesFactory.order storage ref)"
                            }
                          },
                          id: 319,
                          indexExpression: {
                            argumentTypes: null,
                            id: 318,
                            name: "prevOrderId",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 296,
                            src: "2860:11:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "2849:23:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_order_$139_storage",
                            typeString:
                              "struct FuturesFactory.order storage ref"
                          }
                        },
                        id: 320,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "price",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 134,
                        src: "2849:29:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          baseExpression: {
                            argumentTypes: null,
                            id: 321,
                            name: "ordersList",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 151,
                            src: "2886:10:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_mapping$_t_uint256_$_t_struct$_order_$139_storage_$",
                              typeString:
                                "mapping(uint256 => struct FuturesFactory.order storage ref)"
                            }
                          },
                          id: 323,
                          indexExpression: {
                            argumentTypes: null,
                            id: 322,
                            name: "prevOrderId",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 296,
                            src: "2897:11:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "2886:23:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_order_$139_storage",
                            typeString:
                              "struct FuturesFactory.order storage ref"
                          }
                        },
                        id: 324,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "expiry",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 136,
                        src: "2886:30:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        argumentTypes: null,
                        hexValue: "74727565",
                        id: 325,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "bool",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "2924:4:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        value: "true"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_enum$_Position_$115",
                          typeString: "enum FuturesFactory.Position"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      ],
                      id: 304,
                      name: "order",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 139,
                      src: "2723:5:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_type$_t_struct$_order_$139_storage_ptr_$",
                        typeString:
                          "type(struct FuturesFactory.order storage pointer)"
                      }
                    },
                    id: 326,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "structConstructorCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "2723:211:1",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_order_$139_memory",
                      typeString: "struct FuturesFactory.order memory"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "2698:236:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    id: 332,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      argumentTypes: null,
                      baseExpression: {
                        argumentTypes: null,
                        id: 328,
                        name: "ordersList",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 151,
                        src: "2940:10:1",
                        typeDescriptions: {
                          typeIdentifier:
                            "t_mapping$_t_uint256_$_t_struct$_order_$139_storage_$",
                          typeString:
                            "mapping(uint256 => struct FuturesFactory.order storage ref)"
                        }
                      },
                      id: 330,
                      indexExpression: {
                        argumentTypes: null,
                        id: 329,
                        name: "prevOrderId",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 296,
                        src: "2951:11:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "2940:23:1",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_order_$139_storage",
                        typeString: "struct FuturesFactory.order storage ref"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      argumentTypes: null,
                      id: 331,
                      name: "tempOrder",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 303,
                      src: "2966:9:1",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_order_$139_memory_ptr",
                        typeString: "struct FuturesFactory.order memory"
                      }
                    },
                    src: "2940:35:1",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_order_$139_storage",
                      typeString: "struct FuturesFactory.order storage ref"
                    }
                  },
                  id: 333,
                  nodeType: "ExpressionStatement",
                  src: "2940:35:1"
                },
                {
                  eventCall: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        id: 335,
                        name: "futureId",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 104,
                        src: "2994:8:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      id: 334,
                      name: "idEvent",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 143,
                      src: "2986:7:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_event_nonpayable$_t_uint256_$returns$__$",
                        typeString: "function (uint256)"
                      }
                    },
                    id: 336,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "2986:17:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 337,
                  nodeType: "EmitStatement",
                  src: "2981:22:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    id: 343,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      argumentTypes: null,
                      id: 338,
                      name: "futureId",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 104,
                      src: "3009:8:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      argumentTypes: null,
                      arguments: [
                        {
                          argumentTypes: null,
                          hexValue: "31",
                          id: 341,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "number",
                          lValueRequested: false,
                          nodeType: "Literal",
                          src: "3033:1:1",
                          subdenomination: null,
                          typeDescriptions: {
                            typeIdentifier: "t_rational_1_by_1",
                            typeString: "int_const 1"
                          },
                          value: "1"
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_rational_1_by_1",
                            typeString: "int_const 1"
                          }
                        ],
                        expression: {
                          argumentTypes: null,
                          id: 339,
                          name: "futureId",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 104,
                          src: "3020:8:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        id: 340,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "add",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 1077,
                        src: "3020:12:1",
                        typeDescriptions: {
                          typeIdentifier:
                            "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
                          typeString:
                            "function (uint256,uint256) pure returns (uint256)"
                        }
                      },
                      id: 342,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      names: [],
                      nodeType: "FunctionCall",
                      src: "3020:15:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "3009:26:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 344,
                  nodeType: "ExpressionStatement",
                  src: "3009:26:1"
                }
              ]
            },
            documentation: null,
            id: 346,
            implemented: true,
            isConstructor: false,
            isDeclaredConst: false,
            modifiers: [],
            name: "fillOrder",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 247,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 238,
                  name: "_long",
                  nodeType: "VariableDeclaration",
                  scope: 346,
                  src: "2092:13:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 237,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "2092:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 240,
                  name: "_short",
                  nodeType: "VariableDeclaration",
                  scope: 346,
                  src: "2111:14:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 239,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "2111:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 242,
                  name: "_qty",
                  nodeType: "VariableDeclaration",
                  scope: 346,
                  src: "2131:12:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 241,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "2131:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 244,
                  name: "_price",
                  nodeType: "VariableDeclaration",
                  scope: 346,
                  src: "2149:14:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 243,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "2149:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 246,
                  name: "_expiry",
                  nodeType: "VariableDeclaration",
                  scope: 346,
                  src: "2169:15:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 245,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "2169:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "2086:102:1"
            },
            payable: true,
            returnParameters: {
              id: 250,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 249,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 346,
                  src: "2213:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 248,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "2213:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "2212:9:1"
            },
            scope: 690,
            src: "2068:972:1",
            stateMutability: "payable",
            superFunction: null,
            visibility: "public"
          },
          {
            body: {
              id: 468,
              nodeType: "Block",
              src: "3333:1420:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        arguments: [
                          {
                            argumentTypes: null,
                            id: 353,
                            name: "_futureId",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 348,
                            src: "3363:9:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          ],
                          id: 352,
                          name: "_canBeExercised",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 607,
                          src: "3347:15:1",
                          typeDescriptions: {
                            typeIdentifier:
                              "t_function_internal_view$_t_uint256_$returns$_t_bool_$",
                            typeString: "function (uint256) view returns (bool)"
                          }
                        },
                        id: 354,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        names: [],
                        nodeType: "FunctionCall",
                        src: "3347:26:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      {
                        argumentTypes: null,
                        hexValue:
                          "46757475726520636f6e74726163742063616e6e6f742062652073717561726564206f6666",
                        id: 355,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "3375:39:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_06285b237b98788468fb57eba31cc3eb154769821626d67b1eda114d4fe15826",
                          typeString:
                            'literal_string "Future contract cannot be squared off"'
                        },
                        value: "Future contract cannot be squared off"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_06285b237b98788468fb57eba31cc3eb154769821626d67b1eda114d4fe15826",
                          typeString:
                            'literal_string "Future contract cannot be squared off"'
                        }
                      ],
                      id: 351,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [2943, 2944],
                      referencedDeclaration: 2944,
                      src: "3339:7:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure"
                      }
                    },
                    id: 356,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "3339:76:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 357,
                  nodeType: "ExpressionStatement",
                  src: "3339:76:1"
                },
                {
                  assignments: [359],
                  declarations: [
                    {
                      constant: false,
                      id: 359,
                      name: "existingFuture",
                      nodeType: "VariableDeclaration",
                      scope: 469,
                      src: "3421:28:1",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_future_$126_memory_ptr",
                        typeString: "struct FuturesFactory.future"
                      },
                      typeName: {
                        contractScope: null,
                        id: 358,
                        name: "future",
                        nodeType: "UserDefinedTypeName",
                        referencedDeclaration: 126,
                        src: "3421:6:1",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_future_$126_storage_ptr",
                          typeString: "struct FuturesFactory.future"
                        }
                      },
                      value: null,
                      visibility: "internal"
                    }
                  ],
                  id: 363,
                  initialValue: {
                    argumentTypes: null,
                    baseExpression: {
                      argumentTypes: null,
                      id: 360,
                      name: "futuresList",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 147,
                      src: "3452:11:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_mapping$_t_uint256_$_t_struct$_future_$126_storage_$",
                        typeString:
                          "mapping(uint256 => struct FuturesFactory.future storage ref)"
                      }
                    },
                    id: 362,
                    indexExpression: {
                      argumentTypes: null,
                      id: 361,
                      name: "_futureId",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 348,
                      src: "3464:9:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "3452:22:1",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_future_$126_storage",
                      typeString: "struct FuturesFactory.future storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "3421:53:1"
                },
                {
                  assignments: [365],
                  declarations: [
                    {
                      constant: false,
                      id: 365,
                      name: "avgTemp",
                      nodeType: "VariableDeclaration",
                      scope: 469,
                      src: "3481:15:1",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 364,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "3481:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      value: null,
                      visibility: "internal"
                    }
                  ],
                  id: 370,
                  initialValue: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        arguments: [],
                        expression: {
                          argumentTypes: [],
                          id: 367,
                          name: "_getAvgTemperature",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 643,
                          src: "3507:18:1",
                          typeDescriptions: {
                            typeIdentifier:
                              "t_function_internal_view$__$returns$_t_int256_$",
                            typeString: "function () view returns (int256)"
                          }
                        },
                        id: 368,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        names: [],
                        nodeType: "FunctionCall",
                        src: "3507:20:1",
                        typeDescriptions: {
                          typeIdentifier: "t_int256",
                          typeString: "int256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_int256",
                          typeString: "int256"
                        }
                      ],
                      id: 366,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      nodeType: "ElementaryTypeNameExpression",
                      src: "3499:7:1",
                      typeDescriptions: {
                        typeIdentifier: "t_type$_t_uint256_$",
                        typeString: "type(uint256)"
                      },
                      typeName: "uint256"
                    },
                    id: 369,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "typeConversion",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "3499:29:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "3481:47:1"
                },
                {
                  assignments: [],
                  declarations: [
                    {
                      constant: false,
                      id: 372,
                      name: "HDD",
                      nodeType: "VariableDeclaration",
                      scope: 469,
                      src: "3534:11:1",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 371,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "3534:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      value: null,
                      visibility: "internal"
                    }
                  ],
                  id: 373,
                  initialValue: null,
                  nodeType: "VariableDeclarationStatement",
                  src: "3534:11:1"
                },
                {
                  assignments: [],
                  declarations: [
                    {
                      constant: false,
                      id: 375,
                      name: "CDD",
                      nodeType: "VariableDeclaration",
                      scope: 469,
                      src: "3551:11:1",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 374,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "3551:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      value: null,
                      visibility: "internal"
                    }
                  ],
                  id: 376,
                  initialValue: null,
                  nodeType: "VariableDeclarationStatement",
                  src: "3551:11:1"
                },
                {
                  assignments: [],
                  declarations: [
                    {
                      constant: false,
                      id: 378,
                      name: "settlementPrice",
                      nodeType: "VariableDeclaration",
                      scope: 469,
                      src: "3568:23:1",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 377,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "3568:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      value: null,
                      visibility: "internal"
                    }
                  ],
                  id: 379,
                  initialValue: null,
                  nodeType: "VariableDeclarationStatement",
                  src: "3568:23:1"
                },
                {
                  condition: {
                    argumentTypes: null,
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 382,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      argumentTypes: null,
                      id: 380,
                      name: "avgTemp",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 365,
                      src: "3795:7:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "<",
                    rightExpression: {
                      argumentTypes: null,
                      hexValue: "3138",
                      id: 381,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "3805:2:1",
                      subdenomination: null,
                      typeDescriptions: {
                        typeIdentifier: "t_rational_18_by_1",
                        typeString: "int_const 18"
                      },
                      value: "18"
                    },
                    src: "3795:12:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  falseBody: {
                    id: 466,
                    nodeType: "Block",
                    src: "4282:467:1",
                    statements: [
                      {
                        expression: {
                          argumentTypes: null,
                          id: 430,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            argumentTypes: null,
                            id: 425,
                            name: "CDD",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 375,
                            src: "4290:3:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            argumentTypes: null,
                            arguments: [
                              {
                                argumentTypes: null,
                                id: 428,
                                name: "TEMPERATURE_THRESHOLD",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 112,
                                src: "4308:21:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              ],
                              expression: {
                                argumentTypes: null,
                                id: 426,
                                name: "avgTemp",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 365,
                                src: "4296:7:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              id: 427,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "sub",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 1053,
                              src: "4296:11:1",
                              typeDescriptions: {
                                typeIdentifier:
                                  "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
                                typeString:
                                  "function (uint256,uint256) pure returns (uint256)"
                              }
                            },
                            id: 429,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            names: [],
                            nodeType: "FunctionCall",
                            src: "4296:34:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          src: "4290:40:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        id: 431,
                        nodeType: "ExpressionStatement",
                        src: "4290:40:1"
                      },
                      {
                        expression: {
                          argumentTypes: null,
                          id: 437,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            argumentTypes: null,
                            id: 432,
                            name: "settlementPrice",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 378,
                            src: "4338:15:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            argumentTypes: null,
                            arguments: [
                              {
                                argumentTypes: null,
                                hexValue: "33303030303030303030303030303030",
                                id: 435,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                kind: "number",
                                lValueRequested: false,
                                nodeType: "Literal",
                                src: "4364:16:1",
                                subdenomination: null,
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_rational_3000000000000000_by_1",
                                  typeString: "int_const 3000000000000000"
                                },
                                value: "3000000000000000"
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier:
                                    "t_rational_3000000000000000_by_1",
                                  typeString: "int_const 3000000000000000"
                                }
                              ],
                              expression: {
                                argumentTypes: null,
                                id: 433,
                                name: "CDD",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 375,
                                src: "4356:3:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              id: 434,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "mul",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 1005,
                              src: "4356:7:1",
                              typeDescriptions: {
                                typeIdentifier:
                                  "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
                                typeString:
                                  "function (uint256,uint256) pure returns (uint256)"
                              }
                            },
                            id: 436,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            names: [],
                            nodeType: "FunctionCall",
                            src: "4356:25:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          src: "4338:43:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        id: 438,
                        nodeType: "ExpressionStatement",
                        src: "4338:43:1"
                      },
                      {
                        expression: {
                          argumentTypes: null,
                          arguments: [
                            {
                              argumentTypes: null,
                              id: 440,
                              name: "positionAmount",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 110,
                              src: "4490:14:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 441,
                                name: "existingFuture",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 359,
                                src: "4506:14:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_struct$_future_$126_memory_ptr",
                                  typeString:
                                    "struct FuturesFactory.future memory"
                                }
                              },
                              id: 442,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "short",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 119,
                              src: "4506:20:1",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            },
                            {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 443,
                                name: "existingFuture",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 359,
                                src: "4528:14:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_struct$_future_$126_memory_ptr",
                                  typeString:
                                    "struct FuturesFactory.future memory"
                                }
                              },
                              id: 444,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "short",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 119,
                              src: "4528:20:1",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            ],
                            id: 439,
                            name: "_withdrawFromEscrow",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 689,
                            src: "4470:19:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_function_internal_nonpayable$_t_uint256_$_t_address_$_t_address_$returns$_t_bool_$",
                              typeString:
                                "function (uint256,address,address) returns (bool)"
                            }
                          },
                          id: 445,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          names: [],
                          nodeType: "FunctionCall",
                          src: "4470:79:1",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        id: 446,
                        nodeType: "ExpressionStatement",
                        src: "4470:79:1"
                      },
                      {
                        expression: {
                          argumentTypes: null,
                          arguments: [
                            {
                              argumentTypes: null,
                              id: 448,
                              name: "settlementPrice",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 378,
                              src: "4577:15:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 449,
                                name: "existingFuture",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 359,
                                src: "4594:14:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_struct$_future_$126_memory_ptr",
                                  typeString:
                                    "struct FuturesFactory.future memory"
                                }
                              },
                              id: 450,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "long",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 117,
                              src: "4594:19:1",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            },
                            {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 451,
                                name: "existingFuture",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 359,
                                src: "4615:14:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_struct$_future_$126_memory_ptr",
                                  typeString:
                                    "struct FuturesFactory.future memory"
                                }
                              },
                              id: 452,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "short",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 119,
                              src: "4615:20:1",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            ],
                            id: 447,
                            name: "_withdrawFromEscrow",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 689,
                            src: "4557:19:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_function_internal_nonpayable$_t_uint256_$_t_address_$_t_address_$returns$_t_bool_$",
                              typeString:
                                "function (uint256,address,address) returns (bool)"
                            }
                          },
                          id: 453,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          names: [],
                          nodeType: "FunctionCall",
                          src: "4557:79:1",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        id: 454,
                        nodeType: "ExpressionStatement",
                        src: "4557:79:1"
                      },
                      {
                        expression: {
                          argumentTypes: null,
                          arguments: [
                            {
                              argumentTypes: null,
                              arguments: [
                                {
                                  argumentTypes: null,
                                  id: 458,
                                  name: "settlementPrice",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 378,
                                  src: "4683:15:1",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                ],
                                expression: {
                                  argumentTypes: null,
                                  id: 456,
                                  name: "positionAmount",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 110,
                                  src: "4664:14:1",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                id: 457,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                lValueRequested: false,
                                memberName: "sub",
                                nodeType: "MemberAccess",
                                referencedDeclaration: 1053,
                                src: "4664:18:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
                                  typeString:
                                    "function (uint256,uint256) pure returns (uint256)"
                                }
                              },
                              id: 459,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "functionCall",
                              lValueRequested: false,
                              names: [],
                              nodeType: "FunctionCall",
                              src: "4664:35:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 460,
                                name: "existingFuture",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 359,
                                src: "4701:14:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_struct$_future_$126_memory_ptr",
                                  typeString:
                                    "struct FuturesFactory.future memory"
                                }
                              },
                              id: 461,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "long",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 117,
                              src: "4701:19:1",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            },
                            {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 462,
                                name: "existingFuture",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 359,
                                src: "4722:14:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_struct$_future_$126_memory_ptr",
                                  typeString:
                                    "struct FuturesFactory.future memory"
                                }
                              },
                              id: 463,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "long",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 117,
                              src: "4722:19:1",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            ],
                            id: 455,
                            name: "_withdrawFromEscrow",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 689,
                            src: "4644:19:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_function_internal_nonpayable$_t_uint256_$_t_address_$_t_address_$returns$_t_bool_$",
                              typeString:
                                "function (uint256,address,address) returns (bool)"
                            }
                          },
                          id: 464,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          names: [],
                          nodeType: "FunctionCall",
                          src: "4644:98:1",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        id: 465,
                        nodeType: "ExpressionStatement",
                        src: "4644:98:1"
                      }
                    ]
                  },
                  id: 467,
                  nodeType: "IfStatement",
                  src: "3791:958:1",
                  trueBody: {
                    id: 424,
                    nodeType: "Block",
                    src: "3809:467:1",
                    statements: [
                      {
                        expression: {
                          argumentTypes: null,
                          id: 388,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            argumentTypes: null,
                            id: 383,
                            name: "HDD",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 372,
                            src: "3817:3:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            argumentTypes: null,
                            arguments: [
                              {
                                argumentTypes: null,
                                id: 386,
                                name: "avgTemp",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 365,
                                src: "3849:7:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              ],
                              expression: {
                                argumentTypes: null,
                                id: 384,
                                name: "TEMPERATURE_THRESHOLD",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 112,
                                src: "3823:21:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              id: 385,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "sub",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 1053,
                              src: "3823:25:1",
                              typeDescriptions: {
                                typeIdentifier:
                                  "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
                                typeString:
                                  "function (uint256,uint256) pure returns (uint256)"
                              }
                            },
                            id: 387,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            names: [],
                            nodeType: "FunctionCall",
                            src: "3823:34:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          src: "3817:40:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        id: 389,
                        nodeType: "ExpressionStatement",
                        src: "3817:40:1"
                      },
                      {
                        expression: {
                          argumentTypes: null,
                          id: 395,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            argumentTypes: null,
                            id: 390,
                            name: "settlementPrice",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 378,
                            src: "3865:15:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            argumentTypes: null,
                            arguments: [
                              {
                                argumentTypes: null,
                                hexValue: "33303030303030303030303030303030",
                                id: 393,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                kind: "number",
                                lValueRequested: false,
                                nodeType: "Literal",
                                src: "3891:16:1",
                                subdenomination: null,
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_rational_3000000000000000_by_1",
                                  typeString: "int_const 3000000000000000"
                                },
                                value: "3000000000000000"
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier:
                                    "t_rational_3000000000000000_by_1",
                                  typeString: "int_const 3000000000000000"
                                }
                              ],
                              expression: {
                                argumentTypes: null,
                                id: 391,
                                name: "HDD",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 372,
                                src: "3883:3:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              id: 392,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "mul",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 1005,
                              src: "3883:7:1",
                              typeDescriptions: {
                                typeIdentifier:
                                  "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
                                typeString:
                                  "function (uint256,uint256) pure returns (uint256)"
                              }
                            },
                            id: 394,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            names: [],
                            nodeType: "FunctionCall",
                            src: "3883:25:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          src: "3865:43:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        id: 396,
                        nodeType: "ExpressionStatement",
                        src: "3865:43:1"
                      },
                      {
                        expression: {
                          argumentTypes: null,
                          arguments: [
                            {
                              argumentTypes: null,
                              id: 398,
                              name: "positionAmount",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 110,
                              src: "4017:14:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 399,
                                name: "existingFuture",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 359,
                                src: "4033:14:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_struct$_future_$126_memory_ptr",
                                  typeString:
                                    "struct FuturesFactory.future memory"
                                }
                              },
                              id: 400,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "long",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 117,
                              src: "4033:19:1",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            },
                            {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 401,
                                name: "existingFuture",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 359,
                                src: "4054:14:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_struct$_future_$126_memory_ptr",
                                  typeString:
                                    "struct FuturesFactory.future memory"
                                }
                              },
                              id: 402,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "long",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 117,
                              src: "4054:19:1",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            ],
                            id: 397,
                            name: "_withdrawFromEscrow",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 689,
                            src: "3997:19:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_function_internal_nonpayable$_t_uint256_$_t_address_$_t_address_$returns$_t_bool_$",
                              typeString:
                                "function (uint256,address,address) returns (bool)"
                            }
                          },
                          id: 403,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          names: [],
                          nodeType: "FunctionCall",
                          src: "3997:77:1",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        id: 404,
                        nodeType: "ExpressionStatement",
                        src: "3997:77:1"
                      },
                      {
                        expression: {
                          argumentTypes: null,
                          arguments: [
                            {
                              argumentTypes: null,
                              id: 406,
                              name: "settlementPrice",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 378,
                              src: "4102:15:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 407,
                                name: "existingFuture",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 359,
                                src: "4119:14:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_struct$_future_$126_memory_ptr",
                                  typeString:
                                    "struct FuturesFactory.future memory"
                                }
                              },
                              id: 408,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "short",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 119,
                              src: "4119:20:1",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            },
                            {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 409,
                                name: "existingFuture",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 359,
                                src: "4141:14:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_struct$_future_$126_memory_ptr",
                                  typeString:
                                    "struct FuturesFactory.future memory"
                                }
                              },
                              id: 410,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "long",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 117,
                              src: "4141:19:1",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            ],
                            id: 405,
                            name: "_withdrawFromEscrow",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 689,
                            src: "4082:19:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_function_internal_nonpayable$_t_uint256_$_t_address_$_t_address_$returns$_t_bool_$",
                              typeString:
                                "function (uint256,address,address) returns (bool)"
                            }
                          },
                          id: 411,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          names: [],
                          nodeType: "FunctionCall",
                          src: "4082:79:1",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        id: 412,
                        nodeType: "ExpressionStatement",
                        src: "4082:79:1"
                      },
                      {
                        expression: {
                          argumentTypes: null,
                          arguments: [
                            {
                              argumentTypes: null,
                              arguments: [
                                {
                                  argumentTypes: null,
                                  id: 416,
                                  name: "settlementPrice",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 378,
                                  src: "4208:15:1",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                ],
                                expression: {
                                  argumentTypes: null,
                                  id: 414,
                                  name: "positionAmount",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 110,
                                  src: "4189:14:1",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                id: 415,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                lValueRequested: false,
                                memberName: "sub",
                                nodeType: "MemberAccess",
                                referencedDeclaration: 1053,
                                src: "4189:18:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
                                  typeString:
                                    "function (uint256,uint256) pure returns (uint256)"
                                }
                              },
                              id: 417,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "functionCall",
                              lValueRequested: false,
                              names: [],
                              nodeType: "FunctionCall",
                              src: "4189:35:1",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 418,
                                name: "existingFuture",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 359,
                                src: "4226:14:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_struct$_future_$126_memory_ptr",
                                  typeString:
                                    "struct FuturesFactory.future memory"
                                }
                              },
                              id: 419,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "short",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 119,
                              src: "4226:20:1",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            },
                            {
                              argumentTypes: null,
                              expression: {
                                argumentTypes: null,
                                id: 420,
                                name: "existingFuture",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 359,
                                src: "4248:14:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_struct$_future_$126_memory_ptr",
                                  typeString:
                                    "struct FuturesFactory.future memory"
                                }
                              },
                              id: 421,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "short",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 119,
                              src: "4248:20:1",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            ],
                            id: 413,
                            name: "_withdrawFromEscrow",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 689,
                            src: "4169:19:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_function_internal_nonpayable$_t_uint256_$_t_address_$_t_address_$returns$_t_bool_$",
                              typeString:
                                "function (uint256,address,address) returns (bool)"
                            }
                          },
                          id: 422,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          names: [],
                          nodeType: "FunctionCall",
                          src: "4169:100:1",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        id: 423,
                        nodeType: "ExpressionStatement",
                        src: "4169:100:1"
                      }
                    ]
                  }
                }
              ]
            },
            documentation: null,
            id: 469,
            implemented: true,
            isConstructor: false,
            isDeclaredConst: false,
            modifiers: [],
            name: "squareOffOrder",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 349,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 348,
                  name: "_futureId",
                  nodeType: "VariableDeclaration",
                  scope: 469,
                  src: "3307:17:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 347,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "3307:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "3306:19:1"
            },
            payable: false,
            returnParameters: {
              id: 350,
              nodeType: "ParameterList",
              parameters: [],
              src: "3333:0:1"
            },
            scope: 690,
            src: "3283:1470:1",
            stateMutability: "nonpayable",
            superFunction: null,
            visibility: "public"
          },
          {
            body: {
              id: 476,
              nodeType: "Block",
              src: "4815:31:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    id: 474,
                    name: "escrowAddress",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 102,
                    src: "4828:13:1",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  functionReturnParameters: 473,
                  id: 475,
                  nodeType: "Return",
                  src: "4821:20:1"
                }
              ]
            },
            documentation: null,
            id: 477,
            implemented: true,
            isConstructor: false,
            isDeclaredConst: true,
            modifiers: [],
            name: "getEscrowAddress",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 470,
              nodeType: "ParameterList",
              parameters: [],
              src: "4782:2:1"
            },
            payable: false,
            returnParameters: {
              id: 473,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 472,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 477,
                  src: "4806:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 471,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "4806:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "4805:9:1"
            },
            scope: 690,
            src: "4757:89:1",
            stateMutability: "view",
            superFunction: null,
            visibility: "public"
          },
          {
            body: {
              id: 484,
              nodeType: "Block",
              src: "4909:26:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    id: 482,
                    name: "futureId",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 104,
                    src: "4922:8:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  functionReturnParameters: 481,
                  id: 483,
                  nodeType: "Return",
                  src: "4915:15:1"
                }
              ]
            },
            documentation: null,
            id: 485,
            implemented: true,
            isConstructor: false,
            isDeclaredConst: true,
            modifiers: [],
            name: "getLatestFutureID",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 478,
              nodeType: "ParameterList",
              parameters: [],
              src: "4876:2:1"
            },
            payable: false,
            returnParameters: {
              id: 481,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 480,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 485,
                  src: "4900:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 479,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "4900:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "4899:9:1"
            },
            scope: 690,
            src: "4850:85:1",
            stateMutability: "view",
            superFunction: null,
            visibility: "public"
          },
          {
            body: {
              id: 492,
              nodeType: "Block",
              src: "4997:25:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    id: 490,
                    name: "orderId",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 106,
                    src: "5010:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  functionReturnParameters: 489,
                  id: 491,
                  nodeType: "Return",
                  src: "5003:14:1"
                }
              ]
            },
            documentation: null,
            id: 493,
            implemented: true,
            isConstructor: false,
            isDeclaredConst: true,
            modifiers: [],
            name: "getLatestOrderID",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 486,
              nodeType: "ParameterList",
              parameters: [],
              src: "4964:2:1"
            },
            payable: false,
            returnParameters: {
              id: 489,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 488,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 493,
                  src: "4988:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 487,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "4988:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "4987:9:1"
            },
            scope: 690,
            src: "4939:83:1",
            stateMutability: "view",
            superFunction: null,
            visibility: "public"
          },
          {
            body: {
              id: 526,
              nodeType: "Block",
              src: "5161:221:1",
              statements: [
                {
                  assignments: [509],
                  declarations: [
                    {
                      constant: false,
                      id: 509,
                      name: "existingFuture",
                      nodeType: "VariableDeclaration",
                      scope: 527,
                      src: "5167:28:1",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_future_$126_memory_ptr",
                        typeString: "struct FuturesFactory.future"
                      },
                      typeName: {
                        contractScope: null,
                        id: 508,
                        name: "future",
                        nodeType: "UserDefinedTypeName",
                        referencedDeclaration: 126,
                        src: "5167:6:1",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_future_$126_storage_ptr",
                          typeString: "struct FuturesFactory.future"
                        }
                      },
                      value: null,
                      visibility: "internal"
                    }
                  ],
                  id: 513,
                  initialValue: {
                    argumentTypes: null,
                    baseExpression: {
                      argumentTypes: null,
                      id: 510,
                      name: "futuresList",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 147,
                      src: "5198:11:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_mapping$_t_uint256_$_t_struct$_future_$126_storage_$",
                        typeString:
                          "mapping(uint256 => struct FuturesFactory.future storage ref)"
                      }
                    },
                    id: 512,
                    indexExpression: {
                      argumentTypes: null,
                      id: 511,
                      name: "_futureId",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 495,
                      src: "5210:9:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "5198:22:1",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_future_$126_storage",
                      typeString: "struct FuturesFactory.future storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "5167:53:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    components: [
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 514,
                          name: "existingFuture",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 509,
                          src: "5241:14:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_future_$126_memory_ptr",
                            typeString: "struct FuturesFactory.future memory"
                          }
                        },
                        id: 515,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "long",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 117,
                        src: "5241:19:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 516,
                          name: "existingFuture",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 509,
                          src: "5268:14:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_future_$126_memory_ptr",
                            typeString: "struct FuturesFactory.future memory"
                          }
                        },
                        id: 517,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "short",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 119,
                        src: "5268:20:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 518,
                          name: "existingFuture",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 509,
                          src: "5296:14:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_future_$126_memory_ptr",
                            typeString: "struct FuturesFactory.future memory"
                          }
                        },
                        id: 519,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "qty",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 121,
                        src: "5296:18:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 520,
                          name: "existingFuture",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 509,
                          src: "5322:14:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_future_$126_memory_ptr",
                            typeString: "struct FuturesFactory.future memory"
                          }
                        },
                        id: 521,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "price",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 123,
                        src: "5322:20:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 522,
                          name: "existingFuture",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 509,
                          src: "5350:14:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_future_$126_memory_ptr",
                            typeString: "struct FuturesFactory.future memory"
                          }
                        },
                        id: 523,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "expiry",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 125,
                        src: "5350:21:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    id: 524,
                    isConstant: false,
                    isInlineArray: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "TupleExpression",
                    src: "5233:144:1",
                    typeDescriptions: {
                      typeIdentifier:
                        "t_tuple$_t_address_$_t_address_$_t_uint256_$_t_uint256_$_t_uint256_$",
                      typeString:
                        "tuple(address,address,uint256,uint256,uint256)"
                    }
                  },
                  functionReturnParameters: 507,
                  id: 525,
                  nodeType: "Return",
                  src: "5226:151:1"
                }
              ]
            },
            documentation: null,
            id: 527,
            implemented: true,
            isConstructor: false,
            isDeclaredConst: true,
            modifiers: [],
            name: "getFutureDetails",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 496,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 495,
                  name: "_futureId",
                  nodeType: "VariableDeclaration",
                  scope: 527,
                  src: "5052:17:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 494,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "5052:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "5051:19:1"
            },
            payable: false,
            returnParameters: {
              id: 507,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 498,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 527,
                  src: "5097:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 497,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "5097:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 500,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 527,
                  src: "5110:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 499,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "5110:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 502,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 527,
                  src: "5123:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 501,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "5123:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 504,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 527,
                  src: "5136:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 503,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "5136:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 506,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 527,
                  src: "5149:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 505,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "5149:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "5091:69:1"
            },
            scope: 690,
            src: "5026:356:1",
            stateMutability: "view",
            superFunction: null,
            visibility: "public"
          },
          {
            body: {
              id: 564,
              nodeType: "Block",
              src: "5530:247:1",
              statements: [
                {
                  assignments: [545],
                  declarations: [
                    {
                      constant: false,
                      id: 545,
                      name: "existingOrder",
                      nodeType: "VariableDeclaration",
                      scope: 565,
                      src: "5536:26:1",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_order_$139_memory_ptr",
                        typeString: "struct FuturesFactory.order"
                      },
                      typeName: {
                        contractScope: null,
                        id: 544,
                        name: "order",
                        nodeType: "UserDefinedTypeName",
                        referencedDeclaration: 139,
                        src: "5536:5:1",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_order_$139_storage_ptr",
                          typeString: "struct FuturesFactory.order"
                        }
                      },
                      value: null,
                      visibility: "internal"
                    }
                  ],
                  id: 549,
                  initialValue: {
                    argumentTypes: null,
                    baseExpression: {
                      argumentTypes: null,
                      id: 546,
                      name: "ordersList",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 151,
                      src: "5565:10:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_mapping$_t_uint256_$_t_struct$_order_$139_storage_$",
                        typeString:
                          "mapping(uint256 => struct FuturesFactory.order storage ref)"
                      }
                    },
                    id: 548,
                    indexExpression: {
                      argumentTypes: null,
                      id: 547,
                      name: "_orderId",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 529,
                      src: "5576:8:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "5565:20:1",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_order_$139_storage",
                      typeString: "struct FuturesFactory.order storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "5536:49:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    components: [
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 550,
                          name: "existingOrder",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 545,
                          src: "5606:13:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_order_$139_memory_ptr",
                            typeString: "struct FuturesFactory.order memory"
                          }
                        },
                        id: 551,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "trader",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 128,
                        src: "5606:20:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 552,
                          name: "existingOrder",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 545,
                          src: "5634:13:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_order_$139_memory_ptr",
                            typeString: "struct FuturesFactory.order memory"
                          }
                        },
                        id: 553,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "position",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 130,
                        src: "5634:22:1",
                        typeDescriptions: {
                          typeIdentifier: "t_enum$_Position_$115",
                          typeString: "enum FuturesFactory.Position"
                        }
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 554,
                          name: "existingOrder",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 545,
                          src: "5664:13:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_order_$139_memory_ptr",
                            typeString: "struct FuturesFactory.order memory"
                          }
                        },
                        id: 555,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "qty",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 132,
                        src: "5664:17:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 556,
                          name: "existingOrder",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 545,
                          src: "5689:13:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_order_$139_memory_ptr",
                            typeString: "struct FuturesFactory.order memory"
                          }
                        },
                        id: 557,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "price",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 134,
                        src: "5689:19:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 558,
                          name: "existingOrder",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 545,
                          src: "5716:13:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_order_$139_memory_ptr",
                            typeString: "struct FuturesFactory.order memory"
                          }
                        },
                        id: 559,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "expiry",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 136,
                        src: "5716:20:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        argumentTypes: null,
                        expression: {
                          argumentTypes: null,
                          id: 560,
                          name: "existingOrder",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 545,
                          src: "5744:13:1",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_order_$139_memory_ptr",
                            typeString: "struct FuturesFactory.order memory"
                          }
                        },
                        id: 561,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "isFilled",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 138,
                        src: "5744:22:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      }
                    ],
                    id: 562,
                    isConstant: false,
                    isInlineArray: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "TupleExpression",
                    src: "5598:174:1",
                    typeDescriptions: {
                      typeIdentifier:
                        "t_tuple$_t_address_$_t_enum$_Position_$115_$_t_uint256_$_t_uint256_$_t_uint256_$_t_bool_$",
                      typeString:
                        "tuple(address,enum FuturesFactory.Position,uint256,uint256,uint256,bool)"
                    }
                  },
                  functionReturnParameters: 543,
                  id: 563,
                  nodeType: "Return",
                  src: "5591:181:1"
                }
              ]
            },
            documentation: null,
            id: 565,
            implemented: true,
            isConstructor: false,
            isDeclaredConst: true,
            modifiers: [],
            name: "getOrderDetails",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 530,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 529,
                  name: "_orderId",
                  nodeType: "VariableDeclaration",
                  scope: 565,
                  src: "5411:16:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 528,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "5411:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "5410:18:1"
            },
            payable: false,
            returnParameters: {
              id: 543,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 532,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 565,
                  src: "5455:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 531,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "5455:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 534,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 565,
                  src: "5468:8:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_enum$_Position_$115",
                    typeString: "enum FuturesFactory.Position"
                  },
                  typeName: {
                    contractScope: null,
                    id: 533,
                    name: "Position",
                    nodeType: "UserDefinedTypeName",
                    referencedDeclaration: 115,
                    src: "5468:8:1",
                    typeDescriptions: {
                      typeIdentifier: "t_enum$_Position_$115",
                      typeString: "enum FuturesFactory.Position"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 536,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 565,
                  src: "5482:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 535,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "5482:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 538,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 565,
                  src: "5495:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 537,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "5495:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 540,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 565,
                  src: "5508:7:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 539,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "5508:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 542,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 565,
                  src: "5521:4:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  },
                  typeName: {
                    id: 541,
                    name: "bool",
                    nodeType: "ElementaryTypeName",
                    src: "5521:4:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "5449:80:1"
            },
            scope: 690,
            src: "5386:391:1",
            stateMutability: "view",
            superFunction: null,
            visibility: "public"
          },
          {
            body: {
              id: 606,
              nodeType: "Block",
              src: "5854:316:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        commonType: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        id: 579,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          argumentTypes: null,
                          commonType: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          },
                          id: 575,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            argumentTypes: null,
                            id: 573,
                            name: "_futureId",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 567,
                            src: "5868:9:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "BinaryOperation",
                          operator: "<",
                          rightExpression: {
                            argumentTypes: null,
                            id: 574,
                            name: "futureId",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 104,
                            src: "5880:8:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          src: "5868:20:1",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: "&&",
                        rightExpression: {
                          argumentTypes: null,
                          commonType: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          },
                          id: 578,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            argumentTypes: null,
                            id: 576,
                            name: "_futureId",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 567,
                            src: "5892:9:1",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "BinaryOperation",
                          operator: ">",
                          rightExpression: {
                            argumentTypes: null,
                            hexValue: "30",
                            id: 577,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            kind: "number",
                            lValueRequested: false,
                            nodeType: "Literal",
                            src: "5904:1:1",
                            subdenomination: null,
                            typeDescriptions: {
                              typeIdentifier: "t_rational_0_by_1",
                              typeString: "int_const 0"
                            },
                            value: "0"
                          },
                          src: "5892:13:1",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        src: "5868:37:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      {
                        argumentTypes: null,
                        hexValue:
                          "496e76616c69642066757475726520636f6e7472616374204944",
                        id: 580,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "5907:28:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_da78eb731c3ccc763cced40df89ec12d13dbd514425e1b0db19f3f824786112d",
                          typeString:
                            'literal_string "Invalid future contract ID"'
                        },
                        value: "Invalid future contract ID"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_da78eb731c3ccc763cced40df89ec12d13dbd514425e1b0db19f3f824786112d",
                          typeString:
                            'literal_string "Invalid future contract ID"'
                        }
                      ],
                      id: 572,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [2943, 2944],
                      referencedDeclaration: 2944,
                      src: "5860:7:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure"
                      }
                    },
                    id: 581,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "5860:76:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 582,
                  nodeType: "ExpressionStatement",
                  src: "5860:76:1"
                },
                {
                  assignments: [584],
                  declarations: [
                    {
                      constant: false,
                      id: 584,
                      name: "existingFuture",
                      nodeType: "VariableDeclaration",
                      scope: 607,
                      src: "5942:28:1",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_future_$126_memory_ptr",
                        typeString: "struct FuturesFactory.future"
                      },
                      typeName: {
                        contractScope: null,
                        id: 583,
                        name: "future",
                        nodeType: "UserDefinedTypeName",
                        referencedDeclaration: 126,
                        src: "5942:6:1",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_future_$126_storage_ptr",
                          typeString: "struct FuturesFactory.future"
                        }
                      },
                      value: null,
                      visibility: "internal"
                    }
                  ],
                  id: 588,
                  initialValue: {
                    argumentTypes: null,
                    baseExpression: {
                      argumentTypes: null,
                      id: 585,
                      name: "futuresList",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 147,
                      src: "5973:11:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_mapping$_t_uint256_$_t_struct$_future_$126_storage_$",
                        typeString:
                          "mapping(uint256 => struct FuturesFactory.future storage ref)"
                      }
                    },
                    id: 587,
                    indexExpression: {
                      argumentTypes: null,
                      id: 586,
                      name: "_futureId",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 567,
                      src: "5985:9:1",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "5973:22:1",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_future_$126_storage",
                      typeString: "struct FuturesFactory.future storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "5942:53:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        commonType: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        id: 600,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          argumentTypes: null,
                          commonType: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          },
                          id: 594,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            argumentTypes: null,
                            expression: {
                              argumentTypes: null,
                              id: 590,
                              name: "msg",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 2940,
                              src: "6016:3:1",
                              typeDescriptions: {
                                typeIdentifier: "t_magic_message",
                                typeString: "msg"
                              }
                            },
                            id: 591,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberName: "sender",
                            nodeType: "MemberAccess",
                            referencedDeclaration: null,
                            src: "6016:10:1",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          },
                          nodeType: "BinaryOperation",
                          operator: "==",
                          rightExpression: {
                            argumentTypes: null,
                            expression: {
                              argumentTypes: null,
                              id: 592,
                              name: "existingFuture",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 584,
                              src: "6030:14:1",
                              typeDescriptions: {
                                typeIdentifier:
                                  "t_struct$_future_$126_memory_ptr",
                                typeString:
                                  "struct FuturesFactory.future memory"
                              }
                            },
                            id: 593,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberName: "long",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 117,
                            src: "6030:19:1",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          },
                          src: "6016:33:1",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: "||",
                        rightExpression: {
                          argumentTypes: null,
                          commonType: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          },
                          id: 599,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            argumentTypes: null,
                            expression: {
                              argumentTypes: null,
                              id: 595,
                              name: "msg",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 2940,
                              src: "6053:3:1",
                              typeDescriptions: {
                                typeIdentifier: "t_magic_message",
                                typeString: "msg"
                              }
                            },
                            id: 596,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberName: "sender",
                            nodeType: "MemberAccess",
                            referencedDeclaration: null,
                            src: "6053:10:1",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          },
                          nodeType: "BinaryOperation",
                          operator: "==",
                          rightExpression: {
                            argumentTypes: null,
                            expression: {
                              argumentTypes: null,
                              id: 597,
                              name: "existingFuture",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 584,
                              src: "6067:14:1",
                              typeDescriptions: {
                                typeIdentifier:
                                  "t_struct$_future_$126_memory_ptr",
                                typeString:
                                  "struct FuturesFactory.future memory"
                              }
                            },
                            id: 598,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberName: "short",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 119,
                            src: "6067:20:1",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          },
                          src: "6053:34:1",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        src: "6016:71:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      {
                        argumentTypes: null,
                        hexValue:
                          "4f6e6c79206c6f6e67206f722073686f72742073656c6c65722063616e20657865726369736520667574757265",
                        id: 601,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "6095:47:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_9dba8159c3b655a5b6932c075a25bcce49d7a6c89c7e9cff495263cdda08e5ab",
                          typeString:
                            'literal_string "Only long or short seller can exercise future"'
                        },
                        value: "Only long or short seller can exercise future"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_9dba8159c3b655a5b6932c075a25bcce49d7a6c89c7e9cff495263cdda08e5ab",
                          typeString:
                            'literal_string "Only long or short seller can exercise future"'
                        }
                      ],
                      id: 589,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [2943, 2944],
                      referencedDeclaration: 2944,
                      src: "6001:7:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure"
                      }
                    },
                    id: 602,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "6001:147:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 603,
                  nodeType: "ExpressionStatement",
                  src: "6001:147:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    hexValue: "74727565",
                    id: 604,
                    isConstant: false,
                    isLValue: false,
                    isPure: true,
                    kind: "bool",
                    lValueRequested: false,
                    nodeType: "Literal",
                    src: "6161:4:1",
                    subdenomination: null,
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    },
                    value: "true"
                  },
                  functionReturnParameters: 571,
                  id: 605,
                  nodeType: "Return",
                  src: "6154:11:1"
                }
              ]
            },
            documentation: null,
            id: 607,
            implemented: true,
            isConstructor: false,
            isDeclaredConst: true,
            modifiers: [],
            name: "_canBeExercised",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 568,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 567,
                  name: "_futureId",
                  nodeType: "VariableDeclaration",
                  scope: 607,
                  src: "5806:17:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 566,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "5806:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "5805:19:1"
            },
            payable: false,
            returnParameters: {
              id: 571,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 570,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 607,
                  src: "5848:4:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  },
                  typeName: {
                    id: 569,
                    name: "bool",
                    nodeType: "ElementaryTypeName",
                    src: "5848:4:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "5847:6:1"
            },
            scope: 690,
            src: "5781:389:1",
            stateMutability: "view",
            superFunction: null,
            visibility: "internal"
          },
          {
            body: {
              id: 642,
              nodeType: "Block",
              src: "6233:279:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        commonType: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        id: 617,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          argumentTypes: null,
                          id: 613,
                          name: "deployedOracleAddress",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 108,
                          src: "6247:21:1",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: "!=",
                        rightExpression: {
                          argumentTypes: null,
                          arguments: [
                            {
                              argumentTypes: null,
                              hexValue: "30",
                              id: 615,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              kind: "number",
                              lValueRequested: false,
                              nodeType: "Literal",
                              src: "6280:1:1",
                              subdenomination: null,
                              typeDescriptions: {
                                typeIdentifier: "t_rational_0_by_1",
                                typeString: "int_const 0"
                              },
                              value: "0"
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_rational_0_by_1",
                                typeString: "int_const 0"
                              }
                            ],
                            id: 614,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            lValueRequested: false,
                            nodeType: "ElementaryTypeNameExpression",
                            src: "6272:7:1",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_address_$",
                              typeString: "type(address)"
                            },
                            typeName: "address"
                          },
                          id: 616,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "typeConversion",
                          lValueRequested: false,
                          names: [],
                          nodeType: "FunctionCall",
                          src: "6272:10:1",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        src: "6247:35:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      {
                        argumentTypes: null,
                        hexValue:
                          "57656174686572206f7261636c652061646472657373206e6f7420736574",
                        id: 618,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "6284:32:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_356a2336c160aeb30443371900f041c1d67355223ecbb3c6df15f3cfa2802c6f",
                          typeString:
                            'literal_string "Weather oracle address not set"'
                        },
                        value: "Weather oracle address not set"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_356a2336c160aeb30443371900f041c1d67355223ecbb3c6df15f3cfa2802c6f",
                          typeString:
                            'literal_string "Weather oracle address not set"'
                        }
                      ],
                      id: 612,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [2943, 2944],
                      referencedDeclaration: 2944,
                      src: "6239:7:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure"
                      }
                    },
                    id: 619,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "6239:78:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 620,
                  nodeType: "ExpressionStatement",
                  src: "6239:78:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        commonType: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        id: 628,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          argumentTypes: null,
                          arguments: [],
                          expression: {
                            argumentTypes: [],
                            expression: {
                              argumentTypes: null,
                              arguments: [
                                {
                                  argumentTypes: null,
                                  id: 623,
                                  name: "deployedOracleAddress",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 108,
                                  src: "6339:21:1",
                                  typeDescriptions: {
                                    typeIdentifier: "t_address",
                                    typeString: "address"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_address",
                                    typeString: "address"
                                  }
                                ],
                                id: 622,
                                name: "IOracle",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 1145,
                                src: "6331:7:1",
                                typeDescriptions: {
                                  typeIdentifier:
                                    "t_type$_t_contract$_IOracle_$1145_$",
                                  typeString: "type(contract IOracle)"
                                }
                              },
                              id: 624,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "typeConversion",
                              lValueRequested: false,
                              names: [],
                              nodeType: "FunctionCall",
                              src: "6331:30:1",
                              typeDescriptions: {
                                typeIdentifier: "t_contract$_IOracle_$1145",
                                typeString: "contract IOracle"
                              }
                            },
                            id: 625,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberName: "avgTempReceived",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 1134,
                            src: "6331:46:1",
                            typeDescriptions: {
                              typeIdentifier:
                                "t_function_external_view$__$returns$_t_bool_$",
                              typeString:
                                "function () view external returns (bool)"
                            }
                          },
                          id: 626,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          names: [],
                          nodeType: "FunctionCall",
                          src: "6331:48:1",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: "==",
                        rightExpression: {
                          argumentTypes: null,
                          hexValue: "74727565",
                          id: 627,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "bool",
                          lValueRequested: false,
                          nodeType: "Literal",
                          src: "6383:4:1",
                          subdenomination: null,
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          },
                          value: "true"
                        },
                        src: "6331:56:1",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      {
                        argumentTypes: null,
                        hexValue:
                          "4176672074656d7065726174757265206e6f7420726563696576656420796574",
                        id: 629,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "6389:34:1",
                        subdenomination: null,
                        typeDescriptions: {
                          typeIdentifier:
                            "t_stringliteral_b442f2d746d042c4e8e08a6ae892326df128b53df2b22935766dda91e3112a36",
                          typeString:
                            'literal_string "Avg temperature not recieved yet"'
                        },
                        value: "Avg temperature not recieved yet"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        {
                          typeIdentifier:
                            "t_stringliteral_b442f2d746d042c4e8e08a6ae892326df128b53df2b22935766dda91e3112a36",
                          typeString:
                            'literal_string "Avg temperature not recieved yet"'
                        }
                      ],
                      id: 621,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [2943, 2944],
                      referencedDeclaration: 2944,
                      src: "6323:7:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure"
                      }
                    },
                    id: 630,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "6323:101:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 631,
                  nodeType: "ExpressionStatement",
                  src: "6323:101:1"
                },
                {
                  assignments: [633],
                  declarations: [
                    {
                      constant: false,
                      id: 633,
                      name: "avgTemp",
                      nodeType: "VariableDeclaration",
                      scope: 643,
                      src: "6430:14:1",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_int256",
                        typeString: "int256"
                      },
                      typeName: {
                        id: 632,
                        name: "int256",
                        nodeType: "ElementaryTypeName",
                        src: "6430:6:1",
                        typeDescriptions: {
                          typeIdentifier: "t_int256",
                          typeString: "int256"
                        }
                      },
                      value: null,
                      visibility: "internal"
                    }
                  ],
                  id: 639,
                  initialValue: {
                    argumentTypes: null,
                    arguments: [],
                    expression: {
                      argumentTypes: [],
                      expression: {
                        argumentTypes: null,
                        arguments: [
                          {
                            argumentTypes: null,
                            id: 635,
                            name: "deployedOracleAddress",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 108,
                            src: "6455:21:1",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          ],
                          id: 634,
                          name: "IOracle",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 1145,
                          src: "6447:7:1",
                          typeDescriptions: {
                            typeIdentifier:
                              "t_type$_t_contract$_IOracle_$1145_$",
                            typeString: "type(contract IOracle)"
                          }
                        },
                        id: 636,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "typeConversion",
                        lValueRequested: false,
                        names: [],
                        nodeType: "FunctionCall",
                        src: "6447:30:1",
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_IOracle_$1145",
                          typeString: "contract IOracle"
                        }
                      },
                      id: 637,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberName: "avgTemp",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 1136,
                      src: "6447:38:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_external_view$__$returns$_t_int256_$",
                        typeString: "function () view external returns (int256)"
                      }
                    },
                    id: 638,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "6447:40:1",
                    typeDescriptions: {
                      typeIdentifier: "t_int256",
                      typeString: "int256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "6430:57:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    id: 640,
                    name: "avgTemp",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 633,
                    src: "6500:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_int256",
                      typeString: "int256"
                    }
                  },
                  functionReturnParameters: 611,
                  id: 641,
                  nodeType: "Return",
                  src: "6493:14:1"
                }
              ]
            },
            documentation: null,
            id: 643,
            implemented: true,
            isConstructor: false,
            isDeclaredConst: true,
            modifiers: [],
            name: "_getAvgTemperature",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 608,
              nodeType: "ParameterList",
              parameters: [],
              src: "6201:2:1"
            },
            payable: false,
            returnParameters: {
              id: 611,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 610,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 643,
                  src: "6225:6:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_int256",
                    typeString: "int256"
                  },
                  typeName: {
                    id: 609,
                    name: "int256",
                    nodeType: "ElementaryTypeName",
                    src: "6225:6:1",
                    typeDescriptions: {
                      typeIdentifier: "t_int256",
                      typeString: "int256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "6224:8:1"
            },
            scope: 690,
            src: "6174:338:1",
            stateMutability: "view",
            superFunction: null,
            visibility: "public"
          },
          {
            body: {
              id: 665,
              nodeType: "Block",
              src: "6600:89:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        id: 659,
                        name: "_payer",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 647,
                        src: "6651:6:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        argumentTypes: null,
                        id: 660,
                        name: "_amount",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 645,
                        src: "6659:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      arguments: [
                        {
                          argumentTypes: null,
                          id: 657,
                          name: "_amount",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 645,
                          src: "6642:7:1",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        ],
                        expression: {
                          argumentTypes: null,
                          expression: {
                            argumentTypes: null,
                            arguments: [
                              {
                                argumentTypes: null,
                                id: 653,
                                name: "escrowAddress",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 102,
                                src: "6613:13:1",
                                typeDescriptions: {
                                  typeIdentifier: "t_address",
                                  typeString: "address"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_address",
                                  typeString: "address"
                                }
                              ],
                              id: 652,
                              name: "Escrow",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 86,
                              src: "6606:6:1",
                              typeDescriptions: {
                                typeIdentifier:
                                  "t_type$_t_contract$_Escrow_$86_$",
                                typeString: "type(contract Escrow)"
                              }
                            },
                            id: 654,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "typeConversion",
                            lValueRequested: false,
                            names: [],
                            nodeType: "FunctionCall",
                            src: "6606:21:1",
                            typeDescriptions: {
                              typeIdentifier: "t_contract$_Escrow_$86",
                              typeString: "contract Escrow"
                            }
                          },
                          id: 655,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberName: "deposit",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 45,
                          src: "6606:29:1",
                          typeDescriptions: {
                            typeIdentifier:
                              "t_function_external_payable$_t_address_$_t_uint256_$returns$__$",
                            typeString:
                              "function (address,uint256) payable external"
                          }
                        },
                        id: 656,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberName: "value",
                        nodeType: "MemberAccess",
                        referencedDeclaration: null,
                        src: "6606:35:1",
                        typeDescriptions: {
                          typeIdentifier:
                            "t_function_setvalue_nonpayable$_t_uint256_$returns$_t_function_external_payable$_t_address_$_t_uint256_$returns$__$value_$",
                          typeString:
                            "function (uint256) returns (function (address,uint256) payable external)"
                        }
                      },
                      id: 658,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      names: [],
                      nodeType: "FunctionCall",
                      src: "6606:44:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_external_payable$_t_address_$_t_uint256_$returns$__$value",
                        typeString:
                          "function (address,uint256) payable external"
                      }
                    },
                    id: 661,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "6606:61:1",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 662,
                  nodeType: "ExpressionStatement",
                  src: "6606:61:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    hexValue: "74727565",
                    id: 663,
                    isConstant: false,
                    isLValue: false,
                    isPure: true,
                    kind: "bool",
                    lValueRequested: false,
                    nodeType: "Literal",
                    src: "6680:4:1",
                    subdenomination: null,
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    },
                    value: "true"
                  },
                  functionReturnParameters: 651,
                  id: 664,
                  nodeType: "Return",
                  src: "6673:11:1"
                }
              ]
            },
            documentation: null,
            id: 666,
            implemented: true,
            isConstructor: false,
            isDeclaredConst: false,
            modifiers: [],
            name: "_transferToEscrow",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 648,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 645,
                  name: "_amount",
                  nodeType: "VariableDeclaration",
                  scope: 666,
                  src: "6543:15:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 644,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "6543:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 647,
                  name: "_payer",
                  nodeType: "VariableDeclaration",
                  scope: 666,
                  src: "6560:14:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 646,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "6560:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "6542:33:1"
            },
            payable: false,
            returnParameters: {
              id: 651,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 650,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 666,
                  src: "6594:4:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  },
                  typeName: {
                    id: 649,
                    name: "bool",
                    nodeType: "ElementaryTypeName",
                    src: "6594:4:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "6593:6:1"
            },
            scope: 690,
            src: "6516:173:1",
            stateMutability: "nonpayable",
            superFunction: null,
            visibility: "internal"
          },
          {
            body: {
              id: 688,
              nodeType: "Block",
              src: "6795:83:1",
              statements: [
                {
                  expression: {
                    argumentTypes: null,
                    arguments: [
                      {
                        argumentTypes: null,
                        id: 681,
                        name: "_payer",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 670,
                        src: "6832:6:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        argumentTypes: null,
                        id: 682,
                        name: "_payee",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 672,
                        src: "6840:6:1",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        argumentTypes: null,
                        id: 683,
                        name: "_amount",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 668,
                        src: "6848:7:1",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      expression: {
                        argumentTypes: null,
                        arguments: [
                          {
                            argumentTypes: null,
                            id: 678,
                            name: "escrowAddress",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 102,
                            src: "6808:13:1",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          ],
                          id: 677,
                          name: "Escrow",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 86,
                          src: "6801:6:1",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_contract$_Escrow_$86_$",
                            typeString: "type(contract Escrow)"
                          }
                        },
                        id: 679,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "typeConversion",
                        lValueRequested: false,
                        names: [],
                        nodeType: "FunctionCall",
                        src: "6801:21:1",
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_Escrow_$86",
                          typeString: "contract Escrow"
                        }
                      },
                      id: 680,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberName: "withdraw",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 85,
                      src: "6801:30:1",
                      typeDescriptions: {
                        typeIdentifier:
                          "t_function_external_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$_t_bool_$",
                        typeString:
                          "function (address,address,uint256) external returns (bool)"
                      }
                    },
                    id: 684,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "6801:55:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 685,
                  nodeType: "ExpressionStatement",
                  src: "6801:55:1"
                },
                {
                  expression: {
                    argumentTypes: null,
                    hexValue: "74727565",
                    id: 686,
                    isConstant: false,
                    isLValue: false,
                    isPure: true,
                    kind: "bool",
                    lValueRequested: false,
                    nodeType: "Literal",
                    src: "6869:4:1",
                    subdenomination: null,
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    },
                    value: "true"
                  },
                  functionReturnParameters: 676,
                  id: 687,
                  nodeType: "Return",
                  src: "6862:11:1"
                }
              ]
            },
            documentation: null,
            id: 689,
            implemented: true,
            isConstructor: false,
            isDeclaredConst: false,
            modifiers: [],
            name: "_withdrawFromEscrow",
            nodeType: "FunctionDefinition",
            parameters: {
              id: 673,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 668,
                  name: "_amount",
                  nodeType: "VariableDeclaration",
                  scope: 689,
                  src: "6722:15:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 667,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "6722:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 670,
                  name: "_payer",
                  nodeType: "VariableDeclaration",
                  scope: 689,
                  src: "6739:14:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 669,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "6739:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  value: null,
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 672,
                  name: "_payee",
                  nodeType: "VariableDeclaration",
                  scope: 689,
                  src: "6755:14:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 671,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "6755:7:1",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "6721:49:1"
            },
            payable: false,
            returnParameters: {
              id: 676,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 675,
                  name: "",
                  nodeType: "VariableDeclaration",
                  scope: 689,
                  src: "6789:4:1",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  },
                  typeName: {
                    id: 674,
                    name: "bool",
                    nodeType: "ElementaryTypeName",
                    src: "6789:4:1",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  value: null,
                  visibility: "internal"
                }
              ],
              src: "6788:6:1"
            },
            scope: 690,
            src: "6693:185:1",
            stateMutability: "nonpayable",
            superFunction: null,
            visibility: "internal"
          }
        ],
        scope: 691,
        src: "247:6633:1"
      }
    ],
    src: "0:6880:1"
  },
  compiler: {
    name: "solc",
    version: "0.4.24+commit.e67f0147.Emscripten.clang"
  },
  networks: {},
  schemaVersion: "3.0.19",
  updatedAt: "2019-12-08T18:47:24.894Z",
  devdoc: {
    methods: {
      "isOwner()": {
        return: "true if `msg.sender` is the owner of the contract."
      },
      "owner()": {
        return: "the address of the owner."
      },
      "renounceOwnership()": {
        details:
          "Allows the current owner to relinquish control of the contract."
      },
      "transferOwnership(address)": {
        details:
          "Allows the current owner to transfer control of the contract to a newOwner.",
        params: {
          newOwner: "The address to transfer ownership to."
        }
      }
    }
  },
  userdoc: {
    methods: {
      "renounceOwnership()": {
        notice:
          "Renouncing to ownership will leave the contract without an owner. It will not be possible to call the functions with the `onlyOwner` modifier anymore."
      }
    }
  }
};
